"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _cookieUniversal = _interopRequireDefault(require("cookie-universal"));
require("cross-fetch/polyfill");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function () { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function (t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function (t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function (e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function () { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function (e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function (t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function (t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function (t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function (t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function (e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var $s = Object.defineProperty,
  js = Object.defineProperties;
var zs = Object.getOwnPropertyDescriptors;
var An = Object.getOwnPropertySymbols;
var Gs = Object.prototype.hasOwnProperty,
  Ys = Object.prototype.propertyIsEnumerable;
var Tn = Math.pow,
  xn = (e, t, n) => t in e ? $s(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: n
  }) : e[t] = n,
  y = (e, t) => {
    for (var n in t || (t = {})) Gs.call(t, n) && xn(e, n, t[n]);
    if (An) for (var n of An(t)) Ys.call(t, n) && xn(e, n, t[n]);
    return e;
  },
  R = (e, t) => js(e, zs(t));
var l = (e, t, n) => new Promise((o, s) => {
  var i = a => {
      try {
        d(n.next(a));
      } catch (c) {
        s(c);
      }
    },
    r = a => {
      try {
        d(n.throw(a));
      } catch (c) {
        s(c);
      }
    },
    d = a => a.done ? o(a.value) : Promise.resolve(a.value).then(i, r);
  d((n = n.apply(e, t)).next());
});
const Qs = "Logging",
  Zs = "x-amz-user-agent",
  ei = "NoHubcallbackProvidedException";
var G;
(function (e) {
  e.DEBUG = "DEBUG", e.ERROR = "ERROR", e.INFO = "INFO", e.WARN = "WARN", e.VERBOSE = "VERBOSE", e.NONE = "NONE";
})(G || (G = {}));
const vn = {
  VERBOSE: 1,
  DEBUG: 2,
  INFO: 3,
  WARN: 4,
  ERROR: 5,
  NONE: 6
};
class Y {
  /**
   * @constructor
   * @param {string} name - Name of the logger
   */
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : G.WARN;
    this.name = t, this.level = n, this._pluggables = [];
  }
  _padding(t) {
    return t < 10 ? "0" + t : "" + t;
  }
  _ts() {
    const t = /* @__PURE__ */new Date();
    return [this._padding(t.getMinutes()), this._padding(t.getSeconds())].join(":") + "." + t.getMilliseconds();
  }
  configure(t) {
    return t ? (this._config = t, this._config) : this._config;
  }
  /**
   * Write log
   * @method
   * @memeberof Logger
   * @param {LogType|string} type - log type, default INFO
   * @param {string|object} msg - Logging message or object
   */
  _log(t) {
    let o = this.level;
    Y.LOG_LEVEL && (o = Y.LOG_LEVEL), typeof window != "undefined" && window.LOG_LEVEL && (o = window.LOG_LEVEL);
    const s = vn[o];
    if (!(vn[t] >= s)) return;
    let r = console.log.bind(console);
    t === G.ERROR && console.error && (r = console.error.bind(console)), t === G.WARN && console.warn && (r = console.warn.bind(console)), Y.BIND_ALL_LOG_LEVELS && (t === G.INFO && console.info && (r = console.info.bind(console)), t === G.DEBUG && console.debug && (r = console.debug.bind(console)));
    const d = `[${t}] ${this._ts()} ${this.name}`;
    let a = "";
    for (var _len = arguments.length, n = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      n[_key - 1] = arguments[_key];
    }
    if (n.length === 1 && typeof n[0] == "string") a = `${d} - ${n[0]}`, r(a);else if (n.length === 1) a = `${d} ${n[0]}`, r(d, n[0]);else if (typeof n[0] == "string") {
      let c = n.slice(1);
      c.length === 1 && (c = c[0]), a = `${d} - ${n[0]} ${c}`, r(`${d} - ${n[0]}`, c);
    } else a = `${d} ${n}`, r(d, n);
    for (const c of this._pluggables) {
      const u = {
        message: a,
        timestamp: Date.now()
      };
      c.pushLogs([u]);
    }
  }
  /**
   * Write General log. Default to INFO
   * @method
   * @memeberof Logger
   * @param {string|object} msg - Logging message or object
   */
  log() {
    for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      t[_key2] = arguments[_key2];
    }
    this._log(G.INFO, ...t);
  }
  /**
   * Write INFO log
   * @method
   * @memeberof Logger
   * @param {string|object} msg - Logging message or object
   */
  info() {
    for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      t[_key3] = arguments[_key3];
    }
    this._log(G.INFO, ...t);
  }
  /**
   * Write WARN log
   * @method
   * @memeberof Logger
   * @param {string|object} msg - Logging message or object
   */
  warn() {
    for (var _len4 = arguments.length, t = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      t[_key4] = arguments[_key4];
    }
    this._log(G.WARN, ...t);
  }
  /**
   * Write ERROR log
   * @method
   * @memeberof Logger
   * @param {string|object} msg - Logging message or object
   */
  error() {
    for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      t[_key5] = arguments[_key5];
    }
    this._log(G.ERROR, ...t);
  }
  /**
   * Write DEBUG log
   * @method
   * @memeberof Logger
   * @param {string|object} msg - Logging message or object
   */
  debug() {
    for (var _len6 = arguments.length, t = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      t[_key6] = arguments[_key6];
    }
    this._log(G.DEBUG, ...t);
  }
  /**
   * Write VERBOSE log
   * @method
   * @memeberof Logger
   * @param {string|object} msg - Logging message or object
   */
  verbose() {
    for (var _len7 = arguments.length, t = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      t[_key7] = arguments[_key7];
    }
    this._log(G.VERBOSE, ...t);
  }
  addPluggable(t) {
    t && t.getCategoryName() === Qs && (this._pluggables.push(t), t.configure(this._config));
  }
  listPluggables() {
    return this._pluggables;
  }
}
Y.LOG_LEVEL = null;
Y.BIND_ALL_LOG_LEVELS = !1;
class J extends Error {
  /**
   *  Constructs an AmplifyError.
   *
   * @param message text that describes the main problem.
   * @param underlyingError the underlying cause of the error.
   * @param recoverySuggestion suggestion to recover from the error.
   *
   */
  constructor(_ref) {
    let t = _ref.message,
      n = _ref.name,
      o = _ref.recoverySuggestion,
      s = _ref.underlyingError;
    super(t), this.name = n, this.underlyingError = s, this.recoverySuggestion = o, this.constructor = J, Object.setPrototypeOf(this, J.prototype);
  }
}
var tt;
(function (e) {
  e.NoEndpointId = "NoEndpointId", e.PlatformNotSupported = "PlatformNotSupported", e.Unknown = "Unknown";
})(tt || (tt = {}));
const Ao = function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : J;
    return (n, o, s) => {
      const _e$o = e[o],
        i = _e$o.message,
        r = _e$o.recoverySuggestion;
      if (!n) throw new t({
        name: o,
        message: s ? `${i} ${s}` : i,
        recoverySuggestion: r
      });
    };
  },
  se = typeof Symbol != "undefined" ? Symbol("amplify_default") : "@@amplify_default",
  Me = new Y("Hub");
class xo {
  constructor(t) {
    this.listeners = /* @__PURE__ */new Map(), this.protectedChannels = ["core", "auth", "api", "analytics", "interactions", "pubsub", "storage", "ui", "xr"], this.name = t;
  }
  /**
   * Used internally to remove a Hub listener.
   *
   * @remarks
   * This private method is for internal use only. Instead of calling Hub.remove, call the result of Hub.listen.
   */
  _remove(t, n) {
    const o = this.listeners.get(t);
    if (!o) {
      Me.warn(`No listeners for ${t}`);
      return;
    }
    this.listeners.set(t, [...o.filter(_ref2 => {
      let s = _ref2.callback;
      return s !== n;
    })]);
  }
  dispatch(t, n, o, s) {
    typeof t == "string" && this.protectedChannels.indexOf(t) > -1 && (s === se || Me.warn(`WARNING: ${t} is protected and dispatching on it can have unintended consequences`));
    const i = {
      channel: t,
      payload: y({}, n),
      source: o,
      patternInfo: []
    };
    try {
      this._toListeners(i);
    } catch (r) {
      Me.error(r);
    }
  }
  listen(t, n) {
    let o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "noname";
    let s;
    if (typeof n != "function") throw new J({
      name: ei,
      message: "No callback supplied to Hub"
    });
    s = n;
    let i = this.listeners.get(t);
    return i || (i = [], this.listeners.set(t, i)), i.push({
      name: o,
      callback: s
    }), () => {
      this._remove(t, s);
    };
  }
  _toListeners(t) {
    const n = t.channel,
      o = t.payload,
      s = this.listeners.get(n);
    s && s.forEach(i => {
      Me.debug(`Dispatching to ${n} with `, o);
      try {
        i.callback(t);
      } catch (r) {
        Me.error(r);
      }
    });
  }
}
const ie = new xo("__default__"),
  nt = new xo("internal-hub"),
  To = () => {
    if (typeof window == "object" && typeof window.crypto == "object") return window.crypto;
    if (typeof crypto == "object") return crypto;
    throw new J({
      name: "MissingPolyfill",
      message: "Cannot resolve the `crypto` function from the environment."
    });
  },
  ti = () => {
    if (typeof window != "undefined" && typeof window.btoa == "function") return window.btoa;
    if (typeof btoa == "function") return btoa;
    throw new J({
      name: "Base64EncoderError",
      message: "Cannot resolve the `btoa` function from the environment."
    });
  },
  ni = () => {
    if (typeof window != "undefined" && typeof window.atob == "function") return window.atob;
    if (typeof atob == "function") return atob;
    throw new J({
      name: "Base64EncoderError",
      message: "Cannot resolve the `atob` function from the environment."
    });
  },
  vo = {
    convert(e) {
      return ni()(e);
    }
  };
var oe;
(function (e) {
  e.AuthTokenConfigException = "AuthTokenConfigException", e.AuthUserPoolAndIdentityPoolException = "AuthUserPoolAndIdentityPoolException", e.AuthUserPoolException = "AuthUserPoolException", e.InvalidIdentityPoolIdException = "InvalidIdentityPoolIdException", e.OAuthNotConfigureException = "OAuthNotConfigureException";
})(oe || (oe = {}));
const oi = {
    [oe.AuthTokenConfigException]: {
      message: "Auth Token Provider not configured.",
      recoverySuggestion: "Make sure to call Amplify.configure in your app."
    },
    [oe.AuthUserPoolAndIdentityPoolException]: {
      message: "Auth UserPool or IdentityPool not configured.",
      recoverySuggestion: "Make sure to call Amplify.configure in your app with UserPoolId and IdentityPoolId."
    },
    [oe.AuthUserPoolException]: {
      message: "Auth UserPool not configured.",
      recoverySuggestion: "Make sure to call Amplify.configure in your app with userPoolId and userPoolClientId."
    },
    [oe.InvalidIdentityPoolIdException]: {
      message: "Invalid identity pool id provided.",
      recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
    },
    [oe.OAuthNotConfigureException]: {
      message: "oauth param not configured.",
      recoverySuggestion: "Make sure to call Amplify.configure with oauth parameter in your app."
    }
  },
  kt = Ao(oi);
function I(e) {
  let t = !0;
  e ? t = !!e.userPoolId && !!e.userPoolClientId : t = !1, kt(t, oe.AuthUserPoolException);
}
function at(e) {
  var n, o, s, i, r, d, a, c;
  const t = !!((o = (n = e == null ? void 0 : e.loginWith) == null ? void 0 : n.oauth) != null && o.domain) && !!((i = (s = e == null ? void 0 : e.loginWith) == null ? void 0 : s.oauth) != null && i.redirectSignOut) && !!((d = (r = e == null ? void 0 : e.loginWith) == null ? void 0 : r.oauth) != null && d.redirectSignIn) && !!((c = (a = e == null ? void 0 : e.loginWith) == null ? void 0 : a.oauth) != null && c.responseType);
  kt(t, oe.OAuthNotConfigureException);
}
function Je(e) {
  const t = !!(e != null && e.identityPoolId);
  kt(t, oe.InvalidIdentityPoolIdException);
}
function re(e) {
  const t = e.split(".");
  if (t.length !== 3) throw new Error("Invalid token");
  try {
    const o = t[1].replace(/-/g, "+").replace(/_/g, "/"),
      s = decodeURIComponent(vo.convert(o).split("").map(r => `%${`00${r.charCodeAt(0).toString(16)}`.slice(-2)}`).join("")),
      i = JSON.parse(s);
    return {
      toString: () => e,
      payload: i
    };
  } catch (n) {
    throw new Error("Invalid token payload");
  }
}
const Ro = e => {
    const t = Reflect.ownKeys(e);
    for (const n of t) {
      const o = e[n];
      (o && typeof o == "object" || typeof o == "function") && Ro(o);
    }
    return Object.freeze(e);
  },
  si = new Y("parseAWSExports"),
  ii = {
    API_KEY: "apiKey",
    AWS_IAM: "iam",
    AMAZON_COGNITO_USER_POOLS: "userPool",
    OPENID_CONNECT: "oidc",
    NONE: "none",
    AWS_LAMBDA: "lambda",
    // `LAMBDA` is an incorrect value that was added during the v6 rewrite.
    // Keeping it as a valid value until v7 to prevent breaking customers who might
    // be relying on it as a workaround.
    // ref: https://github.com/aws-amplify/amplify-js/pull/12922
    // TODO: @v7 remove next line
    LAMBDA: "lambda"
  },
  ri = function () {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var rn, an, cn, dn, un, ln, hn, fn, gn, pn, mn, En, yn, In, Sn;
    if (!Object.prototype.hasOwnProperty.call(e, "aws_project_region")) throw new J({
      name: "InvalidParameterException",
      message: "Invalid config parameter.",
      recoverySuggestion: "Ensure passing the config object imported from  `amplifyconfiguration.json`."
    });
    const t = e.aws_appsync_apiKey,
      n = e.aws_appsync_authenticationType,
      o = e.aws_appsync_graphqlEndpoint,
      s = e.aws_appsync_region,
      i = e.aws_bots_config,
      r = e.aws_cognito_identity_pool_id,
      d = e.aws_cognito_sign_up_verification_method,
      a = e.aws_cognito_mfa_configuration,
      c = e.aws_cognito_mfa_types,
      u = e.aws_cognito_password_protection_settings,
      f = e.aws_cognito_verification_mechanisms,
      h = e.aws_cognito_signup_attributes,
      g = e.aws_cognito_social_providers,
      E = e.aws_cognito_username_attributes,
      p = e.aws_mandatory_sign_in,
      A = e.aws_mobile_analytics_app_id,
      P = e.aws_mobile_analytics_app_region,
      F = e.aws_user_files_s3_bucket,
      j = e.aws_user_files_s3_bucket_region,
      le = e.aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing,
      Z = e.aws_user_pools_id,
      ee = e.aws_user_pools_web_client_id,
      ae = e.geo,
      pe = e.oauth,
      z = e.predictions,
      tn = e.aws_cloud_logic_custom,
      Ct = e.Notifications,
      nn = e.modelIntrospection,
      V = {};
    A && (V.Analytics = {
      Pinpoint: {
        appId: A,
        region: P
      }
    });
    const _ref3 = Ct != null ? Ct : {},
      me = _ref3.InAppMessaging,
      Ee = _ref3.Push;
    if (me != null && me.AWSPinpoint || Ee != null && Ee.AWSPinpoint) {
      if (me != null && me.AWSPinpoint) {
        const _me$AWSPinpoint = me.AWSPinpoint,
          N = _me$AWSPinpoint.appId,
          ye = _me$AWSPinpoint.region;
        V.Notifications = {
          InAppMessaging: {
            Pinpoint: {
              appId: N,
              region: ye
            }
          }
        };
      }
      if (Ee != null && Ee.AWSPinpoint) {
        const _Ee$AWSPinpoint = Ee.AWSPinpoint,
          N = _Ee$AWSPinpoint.appId,
          ye = _Ee$AWSPinpoint.region;
        V.Notifications = R(y({}, V.Notifications), {
          PushNotification: {
            Pinpoint: {
              appId: N,
              region: ye
            }
          }
        });
      }
    }
    if (Array.isArray(i) && (V.Interactions = {
      LexV1: Object.fromEntries(i.map(N => [N.name, N]))
    }), o) {
      const N = ii[n];
      N || si.debug(`Invalid authentication type ${n}. Falling back to IAM.`), V.API = {
        GraphQL: {
          endpoint: o,
          apiKey: t,
          region: s,
          defaultAuthMode: N != null ? N : "iam"
        }
      }, nn && (V.API.GraphQL.modelIntrospection = nn);
    }
    const Ls = a ? {
        status: a && a.toLowerCase(),
        totpEnabled: (rn = c == null ? void 0 : c.includes("TOTP")) != null ? rn : !1,
        smsEnabled: (an = c == null ? void 0 : c.includes("SMS")) != null ? an : !1
      } : void 0,
      Ks = u ? {
        minLength: u.passwordPolicyMinLength,
        requireLowercase: (dn = (cn = u.passwordPolicyCharacters) == null ? void 0 : cn.includes("REQUIRES_LOWERCASE")) != null ? dn : !1,
        requireUppercase: (ln = (un = u.passwordPolicyCharacters) == null ? void 0 : un.includes("REQUIRES_UPPERCASE")) != null ? ln : !1,
        requireNumbers: (fn = (hn = u.passwordPolicyCharacters) == null ? void 0 : hn.includes("REQUIRES_NUMBERS")) != null ? fn : !1,
        requireSpecialCharacters: (pn = (gn = u.passwordPolicyCharacters) == null ? void 0 : gn.includes("REQUIRES_SYMBOLS")) != null ? pn : !1
      } : void 0,
      Bs = Array.from( /* @__PURE__ */new Set([...(f != null ? f : []), ...(h != null ? h : [])])).reduce((N, ye) => R(y({}, N), {
        // All user attributes generated by the CLI are required
        [ye.toLowerCase()]: {
          required: !0
        }
      }), {}),
      on = (mn = E == null ? void 0 : E.includes("EMAIL")) != null ? mn : !1,
      sn = (En = E == null ? void 0 : E.includes("PHONE_NUMBER")) != null ? En : !1;
    (r || Z) && (V.Auth = {
      Cognito: {
        identityPoolId: r,
        allowGuestAccess: p !== "enable",
        signUpVerificationMethod: d,
        userAttributes: Bs,
        userPoolClientId: ee,
        userPoolId: Z,
        mfa: Ls,
        passwordFormat: Ks,
        loginWith: {
          username: !(on || sn),
          email: on,
          phone: sn
        }
      }
    });
    const Vs = pe ? Object.keys(pe).length > 0 : !1,
      Ws = g ? g.length > 0 : !1;
    if (V.Auth && Vs && (V.Auth.Cognito.loginWith = R(y({}, V.Auth.Cognito.loginWith), {
      oauth: y(y({}, ai(pe)), Ws && {
        providers: ci(g)
      })
    })), F && (V.Storage = {
      S3: {
        bucket: F,
        region: j,
        dangerouslyConnectToHttpEndpointForTesting: le
      }
    }), ae) {
      const N = ae.amazon_location_service;
      V.Geo = {
        LocationService: {
          maps: N.maps,
          geofenceCollections: N.geofenceCollections,
          searchIndices: N.search_indices,
          region: N.region
        }
      };
    }
    if (tn && (V.API = R(y({}, V.API), {
      REST: tn.reduce((N, ye) => {
        const qs = ye.name,
          Hs = ye.endpoint,
          wn = ye.region,
          Cn = ye.service;
        return R(y({}, N), {
          [qs]: y(y({
            endpoint: Hs
          }, Cn ? {
            service: Cn
          } : void 0), wn ? {
            region: wn
          } : void 0)
        });
      }, {})
    })), z) {
      const _ref4 = (Sn = (In = (yn = z == null ? void 0 : z.convert) == null ? void 0 : yn.speechGenerator) == null ? void 0 : In.defaults) != null ? Sn : {},
        N = _ref4.VoiceId;
      V.Predictions = N ? R(y({}, z), {
        convert: R(y({}, z.convert), {
          speechGenerator: R(y({}, z.convert.speechGenerator), {
            defaults: {
              voiceId: N
            }
          })
        })
      }) : z;
    }
    return V;
  },
  Rn = e => {
    var t;
    return (t = e == null ? void 0 : e.split(",")) != null ? t : [];
  },
  ai = _ref5 => {
    let e = _ref5.domain,
      t = _ref5.scope,
      n = _ref5.redirectSignIn,
      o = _ref5.redirectSignOut,
      s = _ref5.responseType;
    return {
      domain: e,
      scopes: t,
      redirectSignIn: Rn(n),
      redirectSignOut: Rn(o),
      responseType: s
    };
  },
  ci = e => e.map(t => {
    const n = t.toLowerCase();
    return n.charAt(0).toUpperCase() + n.slice(1);
  }),
  Po = Symbol("oauth-listener");
function di(e) {
  const t = e.version;
  return t ? t.startsWith("1") : !1;
}
function ui(e) {
  if (!e) return;
  const t = e.bucket_name,
    n = e.aws_region;
  return {
    S3: {
      bucket: t,
      region: n
    }
  };
}
function li(e) {
  var h;
  if (!e) return;
  const t = e.user_pool_id,
    n = e.user_pool_client_id,
    o = e.identity_pool_id,
    s = e.password_policy,
    i = e.mfa_configuration,
    r = e.mfa_methods,
    d = e.unauthenticated_identities_enabled,
    a = e.oauth,
    c = e.username_attributes,
    u = e.standard_required_attributes,
    f = {
      Cognito: {
        userPoolId: t,
        userPoolClientId: n
      }
    };
  return o && (f.Cognito = R(y({}, f.Cognito), {
    identityPoolId: o
  })), s && (f.Cognito.passwordFormat = {
    requireLowercase: s.require_lowercase,
    requireNumbers: s.require_numbers,
    requireUppercase: s.require_uppercase,
    requireSpecialCharacters: s.require_symbols,
    minLength: (h = s.min_length) != null ? h : 6
  }), i && (f.Cognito.mfa = {
    status: Si(i),
    smsEnabled: r == null ? void 0 : r.includes("SMS"),
    totpEnabled: r == null ? void 0 : r.includes("TOTP")
  }), d && (f.Cognito.allowGuestAccess = d), a && (f.Cognito.loginWith = {
    oauth: {
      domain: a.domain,
      redirectSignIn: a.redirect_sign_in_uri,
      redirectSignOut: a.redirect_sign_out_uri,
      responseType: a.response_type === "token" ? "token" : "code",
      scopes: a.scopes,
      providers: Ii(a.identity_providers)
    }
  }), c && (f.Cognito.loginWith = R(y({}, f.Cognito.loginWith), {
    email: c.includes("email"),
    phone: c.includes("phone_number"),
    // Signing in with a username is not currently supported in Gen2, this should always evaluate to false
    username: c.includes("username")
  })), u && (f.Cognito.userAttributes = u.reduce((g, E) => R(y({}, g), {
    [E]: {
      required: !0
    }
  }), {})), f;
}
function hi(e) {
  if (!(e != null && e.amazon_pinpoint)) return;
  const t = e.amazon_pinpoint;
  return {
    Pinpoint: {
      appId: t.app_id,
      region: t.aws_region
    }
  };
}
function fi(e) {
  if (!e) return;
  const t = e.aws_region,
    n = e.geofence_collections,
    o = e.maps,
    s = e.search_indices;
  return {
    LocationService: {
      region: t,
      searchIndices: s,
      geofenceCollections: n,
      maps: o
    }
  };
}
function gi(e) {
  if (!e) return;
  const t = e.aws_region,
    n = e.default_authorization_type,
    o = e.url,
    s = e.api_key,
    i = e.model_introspection;
  return {
    GraphQL: {
      endpoint: o,
      defaultAuthMode: yi(n),
      region: t,
      apiKey: s,
      modelIntrospection: i
    }
  };
}
function pi(e) {
  if (!e) return;
  const t = e.aws_region,
    n = e.channels,
    o = e.amazon_pinpoint_app_id,
    s = n.includes("IN_APP_MESSAGING"),
    i = n.includes("APNS") || n.includes("FCM");
  if (!(s || i)) return;
  const r = {};
  return s && (r.InAppMessaging = {
    Pinpoint: {
      appId: o,
      region: t
    }
  }), i && (r.PushNotification = {
    Pinpoint: {
      appId: o,
      region: t
    }
  }), r;
}
function mi(e) {
  const t = {};
  return e.storage && (t.Storage = ui(e.storage)), e.auth && (t.Auth = li(e.auth)), e.analytics && (t.Analytics = hi(e.analytics)), e.geo && (t.Geo = fi(e.geo)), e.data && (t.API = gi(e.data)), e.notifications && (t.Notifications = pi(e.notifications)), t;
}
const Ei = {
  AMAZON_COGNITO_USER_POOLS: "userPool",
  API_KEY: "apiKey",
  AWS_IAM: "iam",
  AWS_LAMBDA: "lambda",
  OPENID_CONNECT: "oidc"
};
function yi(e) {
  return Ei[e];
}
const Pn = {
  GOOGLE: "Google",
  LOGIN_WITH_AMAZON: "Amazon",
  FACEBOOK: "Facebook",
  SIGN_IN_WITH_APPLE: "Apple"
};
function Ii() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return e.reduce((t, n) => (Pn[n] !== void 0 && t.push(Pn[n]), t), []);
}
function Si(e) {
  return e === "OPTIONAL" ? "optional" : e === "REQUIRED" ? "on" : "off";
}
const _o = e => Object.keys(e).some(t => t.startsWith("aws_")) ? ri(e) : di(e) ? mi(e) : e;
function _n(_ref6) {
  let e = _ref6.expiresAt,
    t = _ref6.clockDrift;
  return Date.now() + t > e;
}
class wi {
  /**
   * Configure Auth category
   *
   * @internal
   *
   * @param authResourcesConfig - Resources configurations required by Auth providers.
   * @param authOptions - Client options used by library
   *
   * @returns void
   */
  configure(t, n) {
    this.authConfig = t, this.authOptions = n;
  }
  /**
   * Fetch the auth tokens, and the temporary AWS credentials and identity if they are configured. By default it
   * does not refresh the auth tokens or credentials if they are loaded in storage already. You can force a refresh
   * with `{ forceRefresh: true }` input.
   *
   * @param options - Options configuring the fetch behavior.
   *
   * @returns Promise of current auth session {@link AuthSession}.
   */
  fetchAuthSession() {
    return l(this, arguments, function () {
      var _this = this;
      let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var i, r, d, a, c, u, n, o, s;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getTokens(t);
            case 2:
              s = _context.sent;
              if (!s) {
                _context.next = 10;
                break;
              }
              o = (r = (i = s.accessToken) == null ? void 0 : i.payload) == null ? void 0 : r.sub;
              _context.next = 7;
              return (a = (d = _this.authOptions) == null ? void 0 : d.credentialsProvider) == null ? void 0 : a.getCredentialsAndIdentityId({
                authConfig: _this.authConfig,
                tokens: s,
                authenticated: !0,
                forceRefresh: t.forceRefresh
              });
            case 7:
              n = _context.sent;
              _context.next = 13;
              break;
            case 10:
              _context.next = 12;
              return (u = (c = _this.authOptions) == null ? void 0 : c.credentialsProvider) == null ? void 0 : u.getCredentialsAndIdentityId({
                authConfig: _this.authConfig,
                authenticated: !1,
                forceRefresh: t.forceRefresh
              });
            case 12:
              n = _context.sent;
            case 13:
              return _context.abrupt("return", {
                tokens: s,
                credentials: n == null ? void 0 : n.credentials,
                identityId: n == null ? void 0 : n.identityId,
                userSub: o
              });
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })();
    });
  }
  clearCredentials() {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var t, n;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (n = (t = this.authOptions) == null ? void 0 : t.credentialsProvider) == null ? void 0 : n.clearCredentialsAndIdentityId();
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
  }
  getTokens(t) {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var n, o, s;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (o = (n = this.authOptions) == null ? void 0 : n.tokenProvider) == null ? void 0 : o.getTokens(t);
          case 2:
            _context3.t0 = s = _context3.sent;
            if (!(_context3.t0 != null)) {
              _context3.next = 7;
              break;
            }
            _context3.t1 = s;
            _context3.next = 8;
            break;
          case 7:
            _context3.t1 = void 0;
          case 8:
            return _context3.abrupt("return", _context3.t1);
          case 9:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
  }
}
function Ci(e, t, n, o) {
  function s(i) {
    return i instanceof n ? i : new n(function (r) {
      r(i);
    });
  }
  return new (n || (n = Promise))(function (i, r) {
    function d(u) {
      try {
        c(o.next(u));
      } catch (f) {
        r(f);
      }
    }
    function a(u) {
      try {
        c(o.throw(u));
      } catch (f) {
        r(f);
      }
    }
    function c(u) {
      u.done ? i(u.value) : s(u.value).then(d, a);
    }
    c((o = o.apply(e, t || [])).next());
  });
}
function Ai(e, t) {
  var n = {
      label: 0,
      sent: function () {
        if (i[0] & 1) throw i[1];
        return i[1];
      },
      trys: [],
      ops: []
    },
    o,
    s,
    i,
    r;
  return r = {
    next: d(0),
    throw: d(1),
    return: d(2)
  }, typeof Symbol == "function" && (r[Symbol.iterator] = function () {
    return this;
  }), r;
  function d(c) {
    return function (u) {
      return a([c, u]);
    };
  }
  function a(c) {
    if (o) throw new TypeError("Generator is already executing.");
    for (; r && (r = 0, c[0] && (n = 0)), n;) try {
      if (o = 1, s && (i = c[0] & 2 ? s.return : c[0] ? s.throw || ((i = s.return) && i.call(s), 0) : s.next) && !(i = i.call(s, c[1])).done) return i;
      switch (s = 0, i && (c = [c[0] & 2, i.value]), c[0]) {
        case 0:
        case 1:
          i = c;
          break;
        case 4:
          return n.label++, {
            value: c[1],
            done: !1
          };
        case 5:
          n.label++, s = c[1], c = [0];
          continue;
        case 7:
          c = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            n = 0;
            continue;
          }
          if (c[0] === 3 && (!i || c[1] > i[0] && c[1] < i[3])) {
            n.label = c[1];
            break;
          }
          if (c[0] === 6 && n.label < i[1]) {
            n.label = i[1], i = c;
            break;
          }
          if (i && n.label < i[2]) {
            n.label = i[2], n.ops.push(c);
            break;
          }
          i[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      c = t.call(e, n);
    } catch (u) {
      c = [6, u], s = 0;
    } finally {
      o = i = 0;
    }
    if (c[0] & 5) throw c[1];
    return {
      value: c[0] ? c[1] : void 0,
      done: !0
    };
  }
}
var X = 64,
  xi = 32,
  Ti = new Uint32Array([1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298]),
  vi = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225],
  Ri = Math.pow(2, 53) - 1,
  Xe = /** @class */
  function () {
    function e() {
      this.state = Int32Array.from(vi), this.temp = new Int32Array(64), this.buffer = new Uint8Array(64), this.bufferLength = 0, this.bytesHashed = 0, this.finished = !1;
    }
    return e.prototype.update = function (t) {
      if (this.finished) throw new Error("Attempted to update an already finished hash.");
      var n = 0,
        o = t.byteLength;
      if (this.bytesHashed += o, this.bytesHashed * 8 > Ri) throw new Error("Cannot hash more than 2^53 - 1 bits");
      for (; o > 0;) this.buffer[this.bufferLength++] = t[n++], o--, this.bufferLength === X && (this.hashBuffer(), this.bufferLength = 0);
    }, e.prototype.digest = function () {
      if (!this.finished) {
        var t = this.bytesHashed * 8,
          n = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength),
          o = this.bufferLength;
        if (n.setUint8(this.bufferLength++, 128), o % X >= X - 8) {
          for (var s = this.bufferLength; s < X; s++) n.setUint8(s, 0);
          this.hashBuffer(), this.bufferLength = 0;
        }
        for (var s = this.bufferLength; s < X - 8; s++) n.setUint8(s, 0);
        n.setUint32(X - 8, Math.floor(t / 4294967296), !0), n.setUint32(X - 4, t), this.hashBuffer(), this.finished = !0;
      }
      for (var i = new Uint8Array(xi), s = 0; s < 8; s++) i[s * 4] = this.state[s] >>> 24 & 255, i[s * 4 + 1] = this.state[s] >>> 16 & 255, i[s * 4 + 2] = this.state[s] >>> 8 & 255, i[s * 4 + 3] = this.state[s] >>> 0 & 255;
      return i;
    }, e.prototype.hashBuffer = function () {
      for (var t = this, n = t.buffer, o = t.state, s = o[0], i = o[1], r = o[2], d = o[3], a = o[4], c = o[5], u = o[6], f = o[7], h = 0; h < X; h++) {
        if (h < 16) this.temp[h] = (n[h * 4] & 255) << 24 | (n[h * 4 + 1] & 255) << 16 | (n[h * 4 + 2] & 255) << 8 | n[h * 4 + 3] & 255;else {
          var g = this.temp[h - 2],
            E = (g >>> 17 | g << 15) ^ (g >>> 19 | g << 13) ^ g >>> 10;
          g = this.temp[h - 15];
          var p = (g >>> 7 | g << 25) ^ (g >>> 18 | g << 14) ^ g >>> 3;
          this.temp[h] = (E + this.temp[h - 7] | 0) + (p + this.temp[h - 16] | 0);
        }
        var A = (((a >>> 6 | a << 26) ^ (a >>> 11 | a << 21) ^ (a >>> 25 | a << 7)) + (a & c ^ ~a & u) | 0) + (f + (Ti[h] + this.temp[h] | 0) | 0) | 0,
          P = ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + (s & i ^ s & r ^ i & r) | 0;
        f = u, u = c, c = a, a = d + A | 0, d = r, r = i, i = s, s = A + P | 0;
      }
      o[0] += s, o[1] += i, o[2] += r, o[3] += d, o[4] += a, o[5] += c, o[6] += u, o[7] += f;
    }, e;
  }();
const Pi = e => new TextEncoder().encode(e);
var _i = typeof Buffer != "undefined" && Buffer.from ? function (e) {
  return Buffer.from(e, "utf8");
} : Pi;
function No(e) {
  return e instanceof Uint8Array ? e : typeof e == "string" ? _i(e) : ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength / Uint8Array.BYTES_PER_ELEMENT) : new Uint8Array(e);
}
function Ni(e) {
  return typeof e == "string" ? e.length === 0 : e.byteLength === 0;
}
var Oe = /** @class */
function () {
  function e(t) {
    this.secret = t, this.hash = new Xe(), this.reset();
  }
  return e.prototype.update = function (t) {
    if (!(Ni(t) || this.error)) try {
      this.hash.update(No(t));
    } catch (n) {
      this.error = n;
    }
  }, e.prototype.digestSync = function () {
    if (this.error) throw this.error;
    return this.outer ? (this.outer.finished || this.outer.update(this.hash.digest()), this.outer.digest()) : this.hash.digest();
  }, e.prototype.digest = function () {
    return Ci(this, void 0, void 0, function () {
      return Ai(this, function (t) {
        return [2, this.digestSync()];
      });
    });
  }, e.prototype.reset = function () {
    if (this.hash = new Xe(), this.secret) {
      this.outer = new Xe();
      var t = bi(this.secret),
        n = new Uint8Array(X);
      n.set(t);
      for (var o = 0; o < X; o++) t[o] ^= 54, n[o] ^= 92;
      this.hash.update(t), this.outer.update(n);
      for (var o = 0; o < t.byteLength; o++) t[o] = 0;
    }
  }, e;
}();
function bi(e) {
  var t = No(e);
  if (t.byteLength > X) {
    var n = new Xe();
    n.update(t), t = n.digest();
  }
  var o = new Uint8Array(X);
  return o.set(t), o;
}
for (let e = 0; e < 256; e++) {
  let t = e.toString(16).toLowerCase();
  t.length === 1 && (t = `0${t}`);
}
var k;
(function (e) {
  e.WebUnknown = "0", e.React = "1", e.NextJs = "2", e.Angular = "3", e.VueJs = "4", e.Nuxt = "5", e.Svelte = "6", e.ServerSideUnknown = "100", e.ReactSSR = "101", e.NextJsSSR = "102", e.AngularSSR = "103", e.VueJsSSR = "104", e.NuxtSSR = "105", e.SvelteSSR = "106", e.ReactNative = "201", e.Expo = "202";
})(k || (k = {}));
var Tt;
(function (e) {
  e.API = "api", e.Auth = "auth", e.Analytics = "analytics", e.DataStore = "datastore", e.Geo = "geo", e.InAppMessaging = "inappmessaging", e.Interactions = "interactions", e.Predictions = "predictions", e.PubSub = "pubsub", e.PushNotification = "pushnotification", e.Storage = "storage";
})(Tt || (Tt = {}));
var Nn;
(function (e) {
  e.Record = "1", e.IdentifyUser = "2";
})(Nn || (Nn = {}));
var bn;
(function (e) {
  e.GraphQl = "1", e.Get = "2", e.Post = "3", e.Put = "4", e.Patch = "5", e.Del = "6", e.Head = "7";
})(bn || (bn = {}));
var T;
(function (e) {
  e.SignUp = "1", e.ConfirmSignUp = "2", e.ResendSignUpCode = "3", e.SignIn = "4", e.FetchMFAPreference = "6", e.UpdateMFAPreference = "7", e.SetUpTOTP = "10", e.VerifyTOTPSetup = "11", e.ConfirmSignIn = "12", e.DeleteUserAttributes = "15", e.DeleteUser = "16", e.UpdateUserAttributes = "17", e.FetchUserAttributes = "18", e.ConfirmUserAttribute = "22", e.SignOut = "26", e.UpdatePassword = "27", e.ResetPassword = "28", e.ConfirmResetPassword = "29", e.FederatedSignIn = "30", e.RememberDevice = "32", e.ForgetDevice = "33", e.FetchDevices = "34", e.SendUserAttributeVerificationCode = "35", e.SignInWithRedirect = "36";
})(T || (T = {}));
var Un;
(function (e) {
  e.Subscribe = "1", e.GraphQl = "2";
})(Un || (Un = {}));
var Mn;
(function (e) {
  e.SearchByText = "0", e.SearchByCoordinates = "1", e.SearchForSuggestions = "2", e.SearchByPlaceId = "3", e.SaveGeofences = "4", e.GetGeofence = "5", e.ListGeofences = "6", e.DeleteGeofences = "7";
})(Mn || (Mn = {}));
var Dn;
(function (e) {
  e.SyncMessages = "1", e.IdentifyUser = "2", e.NotifyMessageInteraction = "3";
})(Dn || (Dn = {}));
var Fn;
(function (e) {
  e.None = "0";
})(Fn || (Fn = {}));
var On;
(function (e) {
  e.Convert = "1", e.Identify = "2", e.Interpret = "3";
})(On || (On = {}));
var kn;
(function (e) {
  e.Subscribe = "1";
})(kn || (kn = {}));
var Ln;
(function (e) {
  e.InitializePushNotifications = "1", e.IdentifyUser = "2";
})(Ln || (Ln = {}));
var Kn;
(function (e) {
  e.UploadData = "1", e.DownloadData = "2", e.List = "3", e.Copy = "4", e.Remove = "5", e.GetProperties = "6", e.GetUrl = "7";
})(Kn || (Kn = {}));
const ct = () => typeof global != "undefined",
  Pe = () => typeof window != "undefined",
  bo = () => typeof document != "undefined",
  Lt = () => typeof process != "undefined",
  ke = (e, t) => !!Object.keys(e).find(n => n.startsWith(t));
function Ui() {
  const e = o => o.startsWith("_react") || o.startsWith("__react"),
    t = o => Object.keys(o).find(e),
    n = () => Array.from(document.querySelectorAll("[id]"));
  return bo() && n().some(t);
}
function Mi() {
  return Lt() && typeof process.env != "undefined" && !!Object.keys(process.env).find(e => e.includes("react"));
}
function Di() {
  return Pe() && ke(window, "__VUE");
}
function Fi() {
  return ct() && ke(global, "__VUE");
}
function Oi() {
  return Pe() && ke(window, "__SVELTE");
}
function ki() {
  return Lt() && typeof process.env != "undefined" && !!Object.keys(process.env).find(e => e.includes("svelte"));
}
function Li() {
  return Pe() && window.next && typeof window.next == "object";
}
function Ki() {
  return ct() && (ke(global, "__next") || ke(global, "__NEXT"));
}
function Bi() {
  return Pe() && (window.__NUXT__ !== void 0 || window.$nuxt !== void 0);
}
function Vi() {
  return ct() && typeof global.__NUXT_PATHS__ != "undefined";
}
function Wi() {
  const e = !!(bo() && document.querySelector("[ng-version]")),
    t = !!(Pe() && typeof window.ng != "undefined");
  return e || t;
}
function qi() {
  var e;
  return Lt() && typeof process.env == "object" && ((e = process.env.npm_lifecycle_script) == null ? void 0 : e.startsWith("ng ")) || !1;
}
function Hi() {
  return typeof navigator != "undefined" && typeof navigator.product != "undefined" && navigator.product === "ReactNative";
}
function $i() {
  return ct() && typeof global.expo != "undefined";
}
function ji() {
  return Pe();
}
const zi = [
// First, detect mobile
{
  platform: k.Expo,
  detectionMethod: $i
}, {
  platform: k.ReactNative,
  detectionMethod: Hi
},
// Next, detect web frameworks
{
  platform: k.NextJs,
  detectionMethod: Li
}, {
  platform: k.Nuxt,
  detectionMethod: Bi
}, {
  platform: k.Angular,
  detectionMethod: Wi
}, {
  platform: k.React,
  detectionMethod: Ui
}, {
  platform: k.VueJs,
  detectionMethod: Di
}, {
  platform: k.Svelte,
  detectionMethod: Oi
}, {
  platform: k.WebUnknown,
  detectionMethod: ji
},
// Last, detect ssr frameworks
{
  platform: k.NextJsSSR,
  detectionMethod: Ki
}, {
  platform: k.NuxtSSR,
  detectionMethod: Vi
}, {
  platform: k.ReactSSR,
  detectionMethod: Mi
}, {
  platform: k.VueJsSSR,
  detectionMethod: Fi
}, {
  platform: k.AngularSSR,
  detectionMethod: qi
}, {
  platform: k.SvelteSSR,
  detectionMethod: ki
}];
function Gi() {
  var e;
  return ((e = zi.find(t => t.detectionMethod())) == null ? void 0 : e.platform) || k.ServerSideUnknown;
}
const Kt = () => typeof window != "undefined" && typeof window.document != "undefined";
class Uo {
  constructor() {
    this.oAuthListener = void 0, this.resourcesConfig = {}, this.libraryOptions = {}, this.Auth = new wi();
  }
  /**
   * Configures Amplify for use with your back-end resources.
   *
   * @remarks
   * This API does not perform any merging of either `resourcesConfig` or `libraryOptions`. The most recently
   * provided values will be used after configuration.
   *
   * @remarks
   * `configure` can be used to specify additional library options where available for supported categories.
   *
   * @param resourceConfig - Back-end resource configuration. Typically provided via the `aws-exports.js` file.
   * @param libraryOptions - Additional options for customizing the behavior of the library.
   */
  configure(t, n) {
    const o = _o(t);
    this.resourcesConfig = o, n && (this.libraryOptions = n), this.resourcesConfig = Ro(this.resourcesConfig), this.Auth.configure(this.resourcesConfig.Auth, this.libraryOptions.Auth), ie.dispatch("core", {
      event: "configure",
      data: this.resourcesConfig
    }, "Configure", se), this.notifyOAuthListener();
  }
  /**
   * Provides access to the current back-end resource configuration for the Library.
   *
   * @returns Returns the immutable back-end resource configuration.
   */
  getConfig() {
    return this.resourcesConfig;
  }
  /** @internal */
  [Po](t) {
    var n, o, s;
    (o = (n = this.resourcesConfig.Auth) == null ? void 0 : n.Cognito.loginWith) != null && o.oauth ? t((s = this.resourcesConfig.Auth) == null ? void 0 : s.Cognito) : this.oAuthListener = t;
  }
  notifyOAuthListener() {
    var t, n, o;
    !((n = (t = this.resourcesConfig.Auth) == null ? void 0 : t.Cognito.loginWith) != null && n.oauth) || !this.oAuthListener || (this.oAuthListener((o = this.resourcesConfig.Auth) == null ? void 0 : o.Cognito), this.oAuthListener = void 0);
  }
}
const C = new Uo(),
  Bt = (e, t) => e.Auth.fetchAuthSession(t),
  L = e => Bt(C, e);
function Mo() {
  return C.Auth.clearCredentials();
}
const dt = e => {
    var o, s;
    const t = e.headers,
      n = e.statusCode;
    return R(y({}, Yi(e) ? e.$metadata : {}), {
      httpStatusCode: n,
      requestId: (s = (o = t["x-amzn-requestid"]) != null ? o : t["x-amzn-request-id"]) != null ? s : t["x-amz-request-id"],
      extendedRequestId: t["x-amz-id-2"],
      cfId: t["x-amz-cf-id"]
    });
  },
  Yi = e => typeof (e == null ? void 0 : e.$metadata) == "object",
  _e = e => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var r, d, a, c, u, t, o, s, i;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!(!e || e.statusCode < 300)) {
            _context4.next = 2;
            break;
          }
          return _context4.abrupt("return");
        case 2:
          _context4.next = 4;
          return ut(e);
        case 4:
          t = _context4.sent;
          o = (f => {
            const _f$toString$split = f.toString().split(/[,:]+/),
              _f$toString$split2 = _slicedToArray(_f$toString$split, 1),
              h = _f$toString$split2[0];
            return h.includes("#") ? h.split("#")[1] : h;
          })((a = (d = (r = e.headers["x-amzn-errortype"]) != null ? r : t.code) != null ? d : t.__type) != null ? a : "UnknownError");
          s = (u = (c = t.message) != null ? c : t.Message) != null ? u : "Unknown error";
          i = new Error(s);
          return _context4.abrupt("return", Object.assign(i, {
            name: o,
            $metadata: dt(e)
          }));
        case 9:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  })),
  ut = e => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var t;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          if (e.body) {
            _context5.next = 2;
            break;
          }
          throw new Error("Missing response payload");
        case 2:
          _context5.next = 4;
          return e.body.json();
        case 4:
          t = _context5.sent;
          return _context5.abrupt("return", Object.assign(t, {
            $metadata: dt(e)
          }));
        case 6:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  })),
  _ = (e, t, n, o) => (s, i) => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var r, d, a, c;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          r = y(y({}, o), s);
          _context6.next = 3;
          return r.endpointResolver(r, i);
        case 3:
          d = _context6.sent;
          _context6.next = 6;
          return t(i, d);
        case 6:
          a = _context6.sent;
          _context6.next = 9;
          return e(a, y({}, r));
        case 9:
          c = _context6.sent;
          return _context6.abrupt("return", n(c));
        case 11:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  })),
  Do = {
    id: "aws",
    outputs: {
      dnsSuffix: "amazonaws.com"
    },
    regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
    regions: ["aws-global"]
  },
  Ji = {
    partitions: [Do, {
      id: "aws-cn",
      outputs: {
        dnsSuffix: "amazonaws.com.cn"
      },
      regionRegex: "^cn\\-\\w+\\-\\d+$",
      regions: ["aws-cn-global"]
    }]
  },
  Fo = e => {
    const t = Ji.partitions;
    for (const _ref7 of t) {
      const n = _ref7.regions;
      const o = _ref7.outputs;
      const s = _ref7.regionRegex;
      const i = new RegExp(s);
      if (n.includes(e) || i.test(e)) return o.dnsSuffix;
    }
    return Do.outputs.dnsSuffix;
  },
  Xi = 3,
  Qi = _ref8 => {
    let _ref8$maxAttempts = _ref8.maxAttempts,
      e = _ref8$maxAttempts === void 0 ? Xi : _ref8$maxAttempts,
      t = _ref8.retryDecider,
      n = _ref8.computeDelay,
      o = _ref8.abortSignal;
    if (e < 1) throw new Error("maxAttempts must be greater than 0");
    return (s, i) => function (d) {
      return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var h, g, E, a, c, u, f, p;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              c = (h = i.attemptsCount) != null ? h : 0;
              f = () => {
                if (u) return Bn(u, c), u;
                throw Bn(a, c), a;
              };
            case 2:
              if (!(!(o != null && o.aborted) && c < e)) {
                _context7.next = 28;
                break;
              }
              _context7.prev = 3;
              _context7.next = 6;
              return s(d);
            case 6:
              u = _context7.sent;
              a = void 0;
              _context7.next = 13;
              break;
            case 10:
              _context7.prev = 10;
              _context7.t0 = _context7["catch"](3);
              a = _context7.t0, u = void 0;
            case 13:
              c = ((g = i.attemptsCount) != null ? g : 0) > c ? (E = i.attemptsCount) != null ? E : 0 : c + 1;
              i.attemptsCount = c;
              _context7.next = 17;
              return t(u, a);
            case 17:
              if (!_context7.sent) {
                _context7.next = 25;
                break;
              }
              if (!(!(o != null && o.aborted) && c < e)) {
                _context7.next = 22;
                break;
              }
              p = n(c);
              _context7.next = 22;
              return Zi(p, o);
            case 22:
              return _context7.abrupt("continue", 26);
            case 25:
              return _context7.abrupt("return", f());
            case 26:
              _context7.next = 2;
              break;
            case 28:
              if (!(o != null && o.aborted)) {
                _context7.next = 30;
                break;
              }
              throw new Error("Request aborted.");
            case 30:
              return _context7.abrupt("return", f());
            case 31:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[3, 10]]);
      }));
    };
  },
  Zi = (e, t) => {
    if (t != null && t.aborted) return Promise.resolve();
    let n, o;
    const s = new Promise(i => {
      o = i, n = setTimeout(i, e);
    });
    return t == null || t.addEventListener("abort", function i(r) {
      clearTimeout(n), t == null || t.removeEventListener("abort", i), o();
    }), s;
  },
  Bn = (e, t) => {
    var n;
    Object.prototype.toString.call(e) === "[object Object]" && (e.$metadata = R(y({}, (n = e.$metadata) != null ? n : {}), {
      attempts: t
    }));
  },
  er = _ref9 => {
    let _ref9$userAgentHeader = _ref9.userAgentHeader,
      e = _ref9$userAgentHeader === void 0 ? "x-amz-user-agent" : _ref9$userAgentHeader,
      _ref9$userAgentValue = _ref9.userAgentValue,
      t = _ref9$userAgentValue === void 0 ? "" : _ref9$userAgentValue;
    return n => function (s) {
      return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var i;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!(t.trim().length === 0)) {
                _context8.next = 4;
                break;
              }
              _context8.next = 3;
              return n(s);
            case 3:
              return _context8.abrupt("return", _context8.sent);
            case 4:
              i = e.toLowerCase();
              s.headers[i] = s.headers[i] ? `${s.headers[i]} ${t}` : t;
              _context8.next = 8;
              return n(s);
            case 8:
              return _context8.abrupt("return", _context8.sent);
            case 9:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
    };
  },
  Vt = (e, t) => (n, o) => {
    const s = {};
    let i = r => e(r, o);
    for (let r = t.length - 1; r >= 0; r--) {
      const d = t[r];
      i = d(o)(i, s);
    }
    return i(n);
  },
  At = e => {
    let t;
    return () => (t || (t = e()), t);
  },
  tr = e => !["HEAD", "GET", "DELETE"].includes(e.toUpperCase()),
  nr = (d, a) => l(void 0, [d, a], function (_ref10, _ref11) {
    let e = _ref10.url,
      t = _ref10.method,
      n = _ref10.headers,
      o = _ref10.body;
    let s = _ref11.abortSignal,
      i = _ref11.cache,
      r = _ref11.withCrossDomainCredentials;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
      var g, E, c, u, f, h;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            _context9.next = 3;
            return fetch(e, {
              method: t,
              headers: n,
              body: tr(t) ? o : void 0,
              signal: s,
              cache: i,
              credentials: r ? "include" : "same-origin"
            });
          case 3:
            c = _context9.sent;
            _context9.next = 9;
            break;
          case 6:
            _context9.prev = 6;
            _context9.t0 = _context9["catch"](0);
            throw _context9.t0 instanceof TypeError ? new Error("Network error") : _context9.t0;
          case 9:
            u = {};
            (g = c.headers) == null || g.forEach((p, A) => {
              u[A.toLowerCase()] = p;
            });
            f = {
              statusCode: c.status,
              headers: u,
              body: null
            }, h = Object.assign((E = c.body) != null ? E : {}, {
              text: At(() => c.text()),
              blob: At(() => c.blob()),
              json: At(() => c.json())
            });
            return _context9.abrupt("return", R(y({}, f), {
              body: h
            }));
          case 13:
          case "end":
            return _context9.stop();
        }
      }, _callee9, null, [[0, 6]]);
    })();
  }),
  Oo = Vt(nr, [er, Qi]),
  or = 5 * 60 * 1e3;
function sr() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : or;
  return o => {
    const s = Tn(2, o) * 100 + 100 * Math.random();
    return s > e ? !1 : s;
  };
}
const Vn = 5 * 60 * 1e3,
  ko = e => {
    const n = sr(Vn)(e);
    return n === !1 ? Vn : n;
  },
  ir = ["AuthFailure", "InvalidSignatureException", "RequestExpired", "RequestInTheFuture", "RequestTimeTooSkewed", "SignatureDoesNotMatch", "BadRequestException"
  // API Gateway
  ],
  rr = e => !!e && ir.includes(e),
  Lo = e => (t, n) => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
    var r, o, s, i;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          if (!(n != null)) {
            _context10.next = 4;
            break;
          }
          _context10.t0 = n;
          _context10.next = 7;
          break;
        case 4:
          _context10.next = 6;
          return e(t);
        case 6:
          _context10.t0 = _context10.sent;
        case 7:
          _context10.t1 = r = _context10.t0;
          if (!(_context10.t1 != null)) {
            _context10.next = 12;
            break;
          }
          _context10.t2 = r;
          _context10.next = 13;
          break;
        case 12:
          _context10.t2 = void 0;
        case 13:
          o = _context10.t2;
          s = (o == null ? void 0 : o.code) || (o == null ? void 0 : o.name);
          i = t == null ? void 0 : t.statusCode;
          return _context10.abrupt("return", ur(n) || dr(i, s) || rr(s) || lr(i, s));
        case 17:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  })),
  ar = ["BandwidthLimitExceeded", "EC2ThrottledException", "LimitExceededException", "PriorRequestNotComplete", "ProvisionedThroughputExceededException", "RequestLimitExceeded", "RequestThrottled", "RequestThrottledException", "SlowDown", "ThrottledException", "Throttling", "ThrottlingException", "TooManyRequestsException"],
  cr = ["TimeoutError", "RequestTimeout", "RequestTimeoutException"],
  dr = (e, t) => e === 429 || !!t && ar.includes(t),
  ur = e => (e == null ? void 0 : e.name) === "Network error",
  lr = (e, t) => !!e && [500, 502, 503, 504].includes(e) || !!t && cr.includes(t),
  Ie = URL,
  hr = "6.4.3";
let Fe;
const Qe = [];
let ot = !1;
const fr = 10,
  gr = 10,
  pr = 1e3,
  Ko = () => {
    var e;
    if (!Fe) {
      if (Fe = Gi(), ot) for (; Qe.length;) (e = Qe.pop()) == null || e();else Qe.forEach(t => {
        t();
      });
      Wn(k.ServerSideUnknown, fr), Wn(k.WebUnknown, gr);
    }
    return Fe;
  },
  mr = e => {
    ot || Qe.push(e);
  };
function Er() {
  Fe = void 0;
}
function Wn(e, t) {
  Fe === e && !ot && setTimeout(() => {
    Er(), ot = !0, setTimeout(Ko, pr);
  }, t);
}
const yr = {},
  Ir = (e, t) => {
    var n, o;
    return (o = (n = yr[e]) == null ? void 0 : n[t]) == null ? void 0 : o.additionalDetails;
  },
  Sr = "aws-amplify",
  wr = function () {
    let _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      e = _ref12.category,
      t = _ref12.action;
    const n = [[Sr, hr]];
    if (e && n.push([e, t]), n.push(["framework", Ko()]), e && t) {
      const o = Ir(e, t);
      o && o.forEach(s => {
        n.push(s);
      });
    }
    return n;
  },
  lt = e => wr(e).map(_ref13 => {
    let _ref14 = _slicedToArray(_ref13, 2),
      o = _ref14[0],
      s = _ref14[1];
    return o && s ? `${o}/${s}` : o;
  }).join(" "),
  Cr = "cognito-identity",
  Ar = _ref15 => {
    let e = _ref15.region;
    return {
      url: new Ie(`https://cognito-identity.${e}.${Fo(e)}`)
    };
  },
  xr = () => e => function (n) {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt("return", (n.headers["cache-control"] = "no-store", e(n)));
          case 1:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
  },
  Bo = Vt(Oo, [xr]),
  Wt = {
    service: Cr,
    endpointResolver: Ar,
    retryDecider: Lo(_e),
    computeDelay: ko,
    userAgentValue: lt(),
    cache: "no-store"
  };
mr(() => {
  Wt.userAgentValue = lt();
});
const Vo = e => ({
    "content-type": "application/x-amz-json-1.1",
    "x-amz-target": `AWSCognitoIdentityService.${e}`
  }),
  Wo = (_ref16, t, n) => {
    let e = _ref16.url;
    return {
      headers: t,
      url: e,
      body: n,
      method: "POST"
    };
  },
  Tr = (e, t) => {
    const n = Vo("GetId"),
      o = JSON.stringify(e);
    return Wo(t, n, o);
  },
  vr = e => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          if (!(e.statusCode >= 300)) {
            _context12.next = 4;
            break;
          }
          _context12.next = 3;
          return _e(e);
        case 3:
          throw _context12.sent;
        case 4:
          _context12.next = 6;
          return ut(e);
        case 6:
          _context12.t0 = _context12.sent.IdentityId;
          _context12.t1 = dt(e);
          return _context12.abrupt("return", {
            IdentityId: _context12.t0,
            $metadata: _context12.t1
          });
        case 9:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  })),
  Rr = _(Bo, Tr, vr, Wt),
  Pr = (e, t) => {
    const n = Vo("GetCredentialsForIdentity"),
      o = JSON.stringify(e);
    return Wo(t, n, o);
  },
  _r = e => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
    var t;
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          if (!(e.statusCode >= 300)) {
            _context13.next = 4;
            break;
          }
          _context13.next = 3;
          return _e(e);
        case 3:
          throw _context13.sent;
        case 4:
          _context13.next = 6;
          return ut(e);
        case 6:
          t = _context13.sent;
          return _context13.abrupt("return", {
            IdentityId: t.IdentityId,
            Credentials: Nr(t.Credentials),
            $metadata: dt(e)
          });
        case 8:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  })),
  Nr = function () {
    let _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      e = _ref17.AccessKeyId,
      t = _ref17.SecretKey,
      n = _ref17.SessionToken,
      o = _ref17.Expiration;
    return {
      AccessKeyId: e,
      SecretKey: t,
      SessionToken: n,
      Expiration: o && new Date(o * 1e3)
    };
  },
  qn = _(Bo, Pr, _r, Wt);
class $e extends J {
  constructor() {
    super({
      name: tt.PlatformNotSupported,
      message: "Function not supported on current platform"
    });
  }
}
class qo {
  constructor(t) {
    this.storage = t;
  }
  /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */
  setItem(t, n) {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
      return _regeneratorRuntime().wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            if (this.storage) {
              _context14.next = 2;
              break;
            }
            throw new $e();
          case 2:
            this.storage.setItem(t, n);
          case 3:
          case "end":
            return _context14.stop();
        }
      }, _callee14, this);
    }));
  }
  /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */
  getItem(t) {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
      return _regeneratorRuntime().wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            if (this.storage) {
              _context15.next = 2;
              break;
            }
            throw new $e();
          case 2:
            return _context15.abrupt("return", this.storage.getItem(t));
          case 3:
          case "end":
            return _context15.stop();
        }
      }, _callee15, this);
    }));
  }
  /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */
  removeItem(t) {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
      return _regeneratorRuntime().wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            if (this.storage) {
              _context16.next = 2;
              break;
            }
            throw new $e();
          case 2:
            this.storage.removeItem(t);
          case 3:
          case "end":
            return _context16.stop();
        }
      }, _callee16, this);
    }));
  }
  /**
   * This is used to clear the storage
   * @returns {string} nothing
   */
  clear() {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
      return _regeneratorRuntime().wrap(function _callee17$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            if (this.storage) {
              _context17.next = 2;
              break;
            }
            throw new $e();
          case 2:
            this.storage.clear();
          case 3:
          case "end":
            return _context17.stop();
        }
      }, _callee17, this);
    }));
  }
}
class Ho {
  constructor() {
    this.storage = /* @__PURE__ */new Map();
  }
  get length() {
    return this.storage.size;
  }
  key(t) {
    return t > this.length - 1 ? null : Array.from(this.storage.keys())[t];
  }
  setItem(t, n) {
    this.storage.set(t, n);
  }
  getItem(t) {
    var n;
    return (n = this.storage.get(t)) != null ? n : null;
  }
  removeItem(t) {
    this.storage.delete(t);
  }
  clear() {
    this.storage.clear();
  }
}
const br = () => typeof window != "undefined" && window.localStorage ? window.localStorage : new Ho(),
  Ur = () => typeof window != "undefined" && window.sessionStorage ? window.sessionStorage : new Ho();
class Mr extends qo {
  constructor() {
    super(br());
  }
}
class Dr extends qo {
  constructor() {
    super(Ur());
  }
}
/*! js-cookie v3.0.5 | MIT */
function je(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var o in n) e[o] = n[o];
  }
  return e;
}
var Fr = {
  read: function (e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function (e) {
    return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};
function vt(e, t) {
  function n(s, i, r) {
    if (typeof document != "undefined") {
      r = je({}, t, r), typeof r.expires == "number" && (r.expires = new Date(Date.now() + r.expires * 864e5)), r.expires && (r.expires = r.expires.toUTCString()), s = encodeURIComponent(s).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var d = "";
      for (var a in r) r[a] && (d += "; " + a, r[a] !== !0 && (d += "=" + r[a].split(";")[0]));
      return document.cookie = s + "=" + e.write(i, s) + d;
    }
  }
  function o(s) {
    if (!(typeof document == "undefined" || arguments.length && !s)) {
      for (var i = document.cookie ? document.cookie.split("; ") : [], r = {}, d = 0; d < i.length; d++) {
        var a = i[d].split("="),
          c = a.slice(1).join("=");
        try {
          var u = decodeURIComponent(a[0]);
          if (r[u] = e.read(c, u), s === u) break;
        } catch (f) {}
      }
      return s ? r[s] : r;
    }
  }
  return Object.create({
    set: n,
    get: o,
    remove: function (s, i) {
      n(s, "", je({}, i, {
        expires: -1
      }));
    },
    withAttributes: function (s) {
      return vt(this.converter, je({}, this.attributes, s));
    },
    withConverter: function (s) {
      return vt(je({}, this.converter, s), this.attributes);
    }
  }, {
    attributes: {
      value: Object.freeze(t)
    },
    converter: {
      value: Object.freeze(e)
    }
  });
}
var ze = vt(Fr, {
  path: "/"
});
class Rt {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const n = t.path,
      o = t.domain,
      s = t.expires,
      i = t.sameSite,
      r = t.secure;
    if (this.domain = o, this.path = n || "/", this.expires = Object.prototype.hasOwnProperty.call(t, "expires") ? s : 365, this.secure = Object.prototype.hasOwnProperty.call(t, "secure") ? r : !0, Object.prototype.hasOwnProperty.call(t, "sameSite")) {
      if (!i || !["strict", "lax", "none"].includes(i)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
      if (i === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
      this.sameSite = i;
    }
  }
  setItem(t, n) {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
      return _regeneratorRuntime().wrap(function _callee18$(_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            ze.set(t, n, this.getData());
          case 1:
          case "end":
            return _context18.stop();
        }
      }, _callee18, this);
    }));
  }
  getItem(t) {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
      var n;
      return _regeneratorRuntime().wrap(function _callee19$(_context19) {
        while (1) switch (_context19.prev = _context19.next) {
          case 0:
            n = ze.get(t);
            return _context19.abrupt("return", n != null ? n : null);
          case 2:
          case "end":
            return _context19.stop();
        }
      }, _callee19);
    }));
  }
  removeItem(t) {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
      return _regeneratorRuntime().wrap(function _callee20$(_context20) {
        while (1) switch (_context20.prev = _context20.next) {
          case 0:
            ze.remove(t, this.getData());
          case 1:
          case "end":
            return _context20.stop();
        }
      }, _callee20, this);
    }));
  }
  clear() {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
      var t, n;
      return _regeneratorRuntime().wrap(function _callee21$(_context21) {
        while (1) switch (_context21.prev = _context21.next) {
          case 0:
            t = ze.get(), n = Object.keys(t).map(o => this.removeItem(o));
            _context21.next = 3;
            return Promise.all(n);
          case 3:
          case "end":
            return _context21.stop();
        }
      }, _callee21, this);
    }));
  }
  getData() {
    return y({
      path: this.path,
      expires: this.expires,
      domain: this.domain,
      secure: this.secure
    }, this.sameSite && {
      sameSite: this.sameSite
    });
  }
}
const ve = new Mr();
new Dr();
const Or = e => {
  const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let n = "";
  for (let o = 0; o < e; o++) n += t.charAt(Math.floor(Math.random() * t.length));
  return n;
};
function kr(e) {
  return (e.match(/.{2}/g) || []).map(n => String.fromCharCode(parseInt(n, 16))).join("");
}
function Lr(e) {
  return e.split("").map(t => t.charCodeAt(0).toString(16).padStart(2, "0")).join("");
}
const Kr = e => {
    let t;
    return function () {
      for (var _len8 = arguments.length, n = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        n[_key8] = arguments[_key8];
      }
      return l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              return _context22.abrupt("return", t || (t = new Promise((o, s) => {
                e(...n).then(i => {
                  o(i);
                }).catch(i => {
                  s(i);
                }).finally(() => {
                  t = void 0;
                });
              }), t));
            case 1:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }));
    };
  },
  Br = () => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
    var _navigator, e, _yield$e$getHighEntro, _yield$e$getHighEntro2, t, _yield$e$getHighEntro3, n, _yield$e$getHighEntro4, o, _yield$e$getHighEntro5, s, _yield$e$getHighEntro6, i, r;
    return _regeneratorRuntime().wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          _navigator = navigator, e = _navigator.userAgentData;
          if (e) {
            _context23.next = 3;
            break;
          }
          return _context23.abrupt("return", navigator.userAgent);
        case 3:
          _context23.next = 5;
          return e.getHighEntropyValues(["platform", "platformVersion", "architecture", "model", "fullVersionList"]);
        case 5:
          _yield$e$getHighEntro = _context23.sent;
          _yield$e$getHighEntro2 = _yield$e$getHighEntro.platform;
          t = _yield$e$getHighEntro2 === void 0 ? "" : _yield$e$getHighEntro2;
          _yield$e$getHighEntro3 = _yield$e$getHighEntro.platformVersion;
          n = _yield$e$getHighEntro3 === void 0 ? "" : _yield$e$getHighEntro3;
          _yield$e$getHighEntro4 = _yield$e$getHighEntro.model;
          o = _yield$e$getHighEntro4 === void 0 ? "" : _yield$e$getHighEntro4;
          _yield$e$getHighEntro5 = _yield$e$getHighEntro.architecture;
          s = _yield$e$getHighEntro5 === void 0 ? "" : _yield$e$getHighEntro5;
          _yield$e$getHighEntro6 = _yield$e$getHighEntro.fullVersionList;
          i = _yield$e$getHighEntro6 === void 0 ? [] : _yield$e$getHighEntro6;
          r = i.map(a => `${a.brand}/${a.version}`).join(";");
          return _context23.abrupt("return", [t, n, s, o, t, r].filter(a => a).join(" "));
        case 18:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
function Vr(e) {
  return Array.from(e, t => String.fromCodePoint(t)).join("");
}
const Le = {
  convert(e) {
    let _ref18 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        urlSafe: !1
      },
      t = _ref18.urlSafe;
    const n = typeof e == "string" ? e : Vr(e),
      o = ti()(n);
    return t ? o.replace(/\+/g, "-").replace(/\//g, "_") : o;
  }
};
function Wr() {
  return To().getRandomValues(new Uint32Array(1))[0];
}
function qr(e) {
  const t = e.words,
    n = e.sigBytes,
    o = [];
  for (let s = 0; s < n; s++) {
    const i = t[s >>> 2] >>> 24 - s % 4 * 8 & 255;
    o.push((i >>> 4).toString(16)), o.push((i & 15).toString(16));
  }
  return o.join("");
}
class qt {
  constructor(t, n) {
    this.words = [];
    let o = t;
    o = this.words = o || [], n !== void 0 ? this.sigBytes = n : this.sigBytes = o.length * 4;
  }
  random(t) {
    const n = [];
    for (let o = 0; o < t; o += 4) n.push(Wr());
    return new qt(n, t);
  }
  toString() {
    return qr(this);
  }
}
class S extends J {
  constructor(t) {
    super(t), this.constructor = S, Object.setPrototypeOf(this, S.prototype);
  }
}
function ge(e) {
  if (!e || e.name === "Error" || e instanceof TypeError) throw new S({
    name: tt.Unknown,
    message: "An unknown error has occurred.",
    underlyingError: e
  });
}
const $o = "cognito-idp",
  Hr = _ref19 => {
    let e = _ref19.region;
    var s;
    const t = (s = C.getConfig().Auth) == null ? void 0 : s.Cognito,
      n = t == null ? void 0 : t.userPoolEndpoint,
      o = new Ie(`https://${$o}.${e}.${Fo(e)}`);
    return {
      url: n ? new Ie(n) : o
    };
  },
  $r = () => (e, t) => function (o) {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
      return _regeneratorRuntime().wrap(function _callee24$(_context24) {
        while (1) switch (_context24.prev = _context24.next) {
          case 0:
            return _context24.abrupt("return", (o.headers["cache-control"] = "no-store", e(o)));
          case 1:
          case "end":
            return _context24.stop();
        }
      }, _callee24);
    }));
  },
  U = Vt(Oo, [$r]),
  M = {
    service: $o,
    endpointResolver: Hr,
    retryDecider: Lo(_e),
    computeDelay: ko,
    userAgentValue: lt(),
    cache: "no-store"
  },
  jr = e => ({
    "content-type": "application/x-amz-json-1.1",
    "x-amz-target": `AWSCognitoIdentityProviderService.${e}`
  }),
  zr = (_ref20, t, n) => {
    let e = _ref20.url;
    return {
      headers: t,
      url: e,
      body: n,
      method: "POST"
    };
  },
  D = e => (t, n) => {
    const o = jr(e),
      s = JSON.stringify(t);
    return zr(n, o, s);
  },
  O = () => e => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
    var t;
    return _regeneratorRuntime().wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          if (!(e.statusCode >= 300)) {
            _context25.next = 7;
            break;
          }
          _context25.next = 3;
          return _e(e);
        case 3:
          t = _context25.sent;
          throw ge(t), new S({
            name: t.name,
            message: t.message
          });
        case 7:
          _context25.next = 9;
          return ut(e);
        case 9:
          return _context25.abrupt("return", _context25.sent);
        case 10:
        case "end":
          return _context25.stop();
      }
    }, _callee25);
  })),
  jo = () => e => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
    var t;
    return _regeneratorRuntime().wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          if (!(e.statusCode >= 300)) {
            _context26.next = 7;
            break;
          }
          _context26.next = 3;
          return _e(e);
        case 3:
          t = _context26.sent;
          throw ge(t), new S({
            name: t.name,
            message: t.message
          });
        case 7:
          return _context26.abrupt("return");
        case 8:
        case "end":
          return _context26.stop();
      }
    }, _callee26);
  })),
  Ke = _(U, D("InitiateAuth"), O(), M),
  Gr = _(U, D("RevokeToken"), O(), M),
  Yr = _(U, D("SignUp"), O(), M),
  Jr = _(U, D("ConfirmSignUp"), O(), M),
  Xr = _(U, D("ForgotPassword"), O(), M),
  Qr = _(U, D("ConfirmForgotPassword"), O(), M),
  ue = _(U, D("RespondToAuthChallenge"), O(), M),
  Zr = _(U, D("ResendConfirmationCode"), O(), M),
  zo = _(U, D("VerifySoftwareToken"), O(), M),
  Go = _(U, D("AssociateSoftwareToken"), O(), M),
  ea = _(U, D("SetUserMFAPreference"), O(), M),
  Yo = _(U, D("GetUser"), O(), M),
  ta = _(U, D("ChangePassword"), O(), M),
  na = _(U, D("ConfirmDevice"), O(), M),
  oa = _(U, D("ForgetDevice"), jo(), M),
  sa = _(U, D("DeleteUser"), jo(), M),
  ia = _(U, D("GetUserAttributeVerificationCode"), O(), M),
  ra = _(U, D("GlobalSignOut"), O(), M),
  aa = _(U, D("UpdateUserAttributes"), O(), M),
  ca = _(U, D("VerifyUserAttribute"), O(), M),
  da = _(U, D("UpdateDeviceStatus"), O(), M),
  ua = _(U, D("ListDevices"), O(), M),
  la = _(U, D("DeleteUserAttributes"), O(), M);
var w;
(function (e) {
  e.EmptySignInUsername = "EmptySignInUsername", e.EmptySignInPassword = "EmptySignInPassword", e.CustomAuthSignInPassword = "CustomAuthSignInPassword", e.EmptySignUpUsername = "EmptySignUpUsername", e.EmptySignUpPassword = "EmptySignUpPassword", e.EmptyConfirmSignUpUsername = "EmptyConfirmSignUpUsername", e.EmptyConfirmSignUpCode = "EmptyConfirmSignUpCode", e.EmptyResendSignUpCodeUsername = "EmptyresendSignUpCodeUsername", e.EmptyChallengeResponse = "EmptyChallengeResponse", e.EmptyConfirmResetPasswordUsername = "EmptyConfirmResetPasswordUsername", e.EmptyConfirmResetPasswordNewPassword = "EmptyConfirmResetPasswordNewPassword", e.EmptyConfirmResetPasswordConfirmationCode = "EmptyConfirmResetPasswordConfirmationCode", e.EmptyResetPasswordUsername = "EmptyResetPasswordUsername", e.EmptyVerifyTOTPSetupCode = "EmptyVerifyTOTPSetupCode", e.EmptyConfirmUserAttributeCode = "EmptyConfirmUserAttributeCode", e.IncorrectMFAMethod = "IncorrectMFAMethod", e.EmptyUpdatePassword = "EmptyUpdatePassword";
})(w || (w = {}));
const ha = {
  [w.EmptyChallengeResponse]: {
    message: "challengeResponse is required to confirmSignIn"
  },
  [w.EmptyConfirmResetPasswordUsername]: {
    message: "username is required to confirmResetPassword"
  },
  [w.EmptyConfirmSignUpCode]: {
    message: "code is required to confirmSignUp"
  },
  [w.EmptyConfirmSignUpUsername]: {
    message: "username is required to confirmSignUp"
  },
  [w.EmptyConfirmResetPasswordConfirmationCode]: {
    message: "confirmationCode is required to confirmResetPassword"
  },
  [w.EmptyConfirmResetPasswordNewPassword]: {
    message: "newPassword is required to confirmResetPassword"
  },
  [w.EmptyResendSignUpCodeUsername]: {
    message: "username is required to confirmSignUp"
  },
  [w.EmptyResetPasswordUsername]: {
    message: "username is required to resetPassword"
  },
  [w.EmptySignInPassword]: {
    message: "password is required to signIn"
  },
  [w.EmptySignInUsername]: {
    message: "username is required to signIn"
  },
  [w.EmptySignUpPassword]: {
    message: "password is required to signUp"
  },
  [w.EmptySignUpUsername]: {
    message: "username is required to signUp"
  },
  [w.CustomAuthSignInPassword]: {
    message: "A password is not needed when signing in with CUSTOM_WITHOUT_SRP",
    recoverySuggestion: "Do not include a password in your signIn call."
  },
  [w.IncorrectMFAMethod]: {
    message: "Incorrect MFA method was chosen. It should be either SMS or TOTP",
    recoverySuggestion: "Try to pass TOTP or SMS as the challengeResponse"
  },
  [w.EmptyVerifyTOTPSetupCode]: {
    message: "code is required to verifyTotpSetup"
  },
  [w.EmptyUpdatePassword]: {
    message: "oldPassword and newPassword are required to changePassword"
  },
  [w.EmptyConfirmUserAttributeCode]: {
    message: "confirmation code is required to confirmUserAttribute"
  }
};
var K;
(function (e) {
  e.DEFAULT_MSG = "Authentication Error", e.EMPTY_EMAIL = "Email cannot be empty", e.EMPTY_PHONE = "Phone number cannot be empty", e.EMPTY_USERNAME = "Username cannot be empty", e.INVALID_USERNAME = "The username should either be a string or one of the sign in types", e.EMPTY_PASSWORD = "Password cannot be empty", e.EMPTY_CODE = "Confirmation code cannot be empty", e.SIGN_UP_ERROR = "Error creating account", e.NO_MFA = "No valid MFA method provided", e.INVALID_MFA = "Invalid MFA type", e.EMPTY_CHALLENGE = "Challenge response cannot be empty", e.NO_USER_SESSION = "Failed to get the session because the user is empty", e.NETWORK_ERROR = "Network Error", e.DEVICE_CONFIG = "Device tracking has not been configured in this User Pool", e.AUTOSIGNIN_ERROR = "Please use your credentials to sign in", e.OAUTH_ERROR = "Couldn't finish OAuth flow, check your User Pool HostedUI settings";
})(K || (K = {}));
var Se;
(function (e) {
  e.SignInException = "SignInException", e.OAuthSignInError = "OAuthSignInException";
})(Se || (Se = {}));
function b(e, t) {
  const _ha$t = ha[t],
    n = _ha$t.message,
    o = _ha$t.recoverySuggestion;
  if (!e) throw new S({
    name: t,
    message: n,
    recoverySuggestion: o
  });
}
function x(e) {
  const t = e == null ? void 0 : e.split("_")[0];
  if (!e || e.indexOf("_") < 0 || !t || typeof t != "string") throw new S({
    name: "InvalidUserPoolId",
    message: "Invalid user pool id provided."
  });
  return t;
}
function Pt(e) {
  if (!e || !e.includes(":")) throw new S({
    name: "InvalidIdentityPoolIdException",
    message: "Invalid identity pool id provided.",
    recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
  });
  return e.split(":")[0];
}
function _t(e) {
  return Object.entries(e).map(_ref21 => {
    let _ref22 = _slicedToArray(_ref21, 2),
      t = _ref22[0],
      n = _ref22[1];
    return {
      Name: t,
      Value: n
    };
  });
}
function fa(e) {
  const t = {};
  return e == null || e.forEach(n => {
    n.Name && (t[n.Name] = n.Value);
  }), t;
}
var Hn;
(function (e) {
  e.ConcurrentModificationException = "ConcurrentModificationException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.NotAuthorizedException = "NotAuthorizedException", e.ResourceNotFoundException = "ResourceNotFoundException", e.SoftwareTokenMFANotFoundException = "SoftwareTokenMFANotFoundException";
})(Hn || (Hn = {}));
var $n;
(function (e) {
  e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.InvalidPasswordException = "InvalidPasswordException", e.LimitExceededException = "LimitExceededException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})($n || ($n = {}));
var jn;
(function (e) {
  e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidLambdaResponseException = "InvalidLambdaResponseException", e.InvalidParameterException = "InvalidParameterException", e.InvalidPasswordException = "InvalidPasswordException", e.InvalidUserPoolConfigurationException = "InvalidUserPoolConfigurationException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UsernameExistsException = "UsernameExistsException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(jn || (jn = {}));
var zn;
(function (e) {
  e.CodeMismatchException = "CodeMismatchException", e.ExpiredCodeException = "ExpiredCodeException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidLambdaResponseException = "InvalidLambdaResponseException", e.InvalidParameterException = "InvalidParameterException", e.InvalidPasswordException = "InvalidPasswordException", e.LimitExceededException = "LimitExceededException", e.NotAuthorizedException = "NotAuthorizedException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyFailedAttemptsException = "TooManyFailedAttemptsException", e.TooManyRequestsException = "TooManyRequestsException", e.UnexpectedLambdaException = "UnexpectedLambdaException", e.UserLambdaValidationException = "UserLambdaValidationException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(zn || (zn = {}));
var Gn;
(function (e) {
  e.AliasExistsException = "AliasExistsException", e.CodeMismatchException = "CodeMismatchException", e.ExpiredCodeException = "ExpiredCodeException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidLambdaResponseException = "InvalidLambdaResponseException", e.InvalidParameterException = "InvalidParameterException", e.LimitExceededException = "LimitExceededException", e.NotAuthorizedException = "NotAuthorizedException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyFailedAttemptsException = "TooManyFailedAttemptsException", e.TooManyRequestsException = "TooManyRequestsException", e.UnexpectedLambdaException = "UnexpectedLambdaException", e.UserLambdaValidationException = "UserLambdaValidationException", e.UserNotFoundException = "UserNotFoundException";
})(Gn || (Gn = {}));
var Yn;
(function (e) {
  e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(Yn || (Yn = {}));
var Jn;
(function (e) {
  e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(Jn || (Jn = {}));
var Xn;
(function (e) {
  e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.InvalidUserPoolConfigurationException = "InvalidUserPoolConfigurationException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(Xn || (Xn = {}));
var Qn;
(function (e) {
  e.CodeDeliveryFailureException = "CodeDeliveryFailureException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidEmailRoleAccessPolicyException = "InvalidEmailRoleAccessPolicyException", e.InvalidLambdaResponseException = "InvalidLambdaResponseException", e.InvalidParameterException = "InvalidParameterException", e.InvalidSmsRoleAccessPolicyException = "InvalidSmsRoleAccessPolicyException", e.InvalidSmsRoleTrustRelationshipException = "InvalidSmsRoleTrustRelationshipException", e.LimitExceededException = "LimitExceededException", e.NotAuthorizedException = "NotAuthorizedException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UnexpectedLambdaException = "UnexpectedLambdaException", e.UserLambdaValidationException = "UserLambdaValidationException", e.UserNotFoundException = "UserNotFoundException";
})(Qn || (Qn = {}));
var Zn;
(function (e) {
  e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(Zn || (Zn = {}));
var eo;
(function (e) {
  e.ExternalServiceException = "ExternalServiceException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.LimitExceededException = "LimitExceededException", e.NotAuthorizedException = "NotAuthorizedException", e.ResourceConflictException = "ResourceConflictException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException";
})(eo || (eo = {}));
var to;
(function (e) {
  e.ExternalServiceException = "ExternalServiceException", e.InternalErrorException = "InternalErrorException", e.InvalidIdentityPoolConfigurationException = "InvalidIdentityPoolConfigurationException", e.InvalidParameterException = "InvalidParameterException", e.NotAuthorizedException = "NotAuthorizedException", e.ResourceConflictException = "ResourceConflictException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException";
})(to || (to = {}));
var no;
(function (e) {
  e.CodeDeliveryFailureException = "CodeDeliveryFailureException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidEmailRoleAccessPolicyException = "InvalidEmailRoleAccessPolicyException", e.InvalidLambdaResponseException = "InvalidLambdaResponseException", e.InvalidParameterException = "InvalidParameterException", e.InvalidSmsRoleAccessPolicyException = "InvalidSmsRoleAccessPolicyException", e.InvalidSmsRoleTrustRelationshipException = "InvalidSmsRoleTrustRelationshipException", e.LimitExceededException = "LimitExceededException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UnexpectedLambdaException = "UnexpectedLambdaException", e.UserLambdaValidationException = "UserLambdaValidationException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(no || (no = {}));
var oo;
(function (e) {
  e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UserNotConfirmedException = "UserNotConfirmedException";
})(oo || (oo = {}));
var st;
(function (e) {
  e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidLambdaResponseException = "InvalidLambdaResponseException", e.InvalidParameterException = "InvalidParameterException", e.InvalidSmsRoleAccessPolicyException = "InvalidSmsRoleAccessPolicyException", e.InvalidSmsRoleTrustRelationshipException = "InvalidSmsRoleTrustRelationshipException", e.InvalidUserPoolConfigurationException = "InvalidUserPoolConfigurationException", e.NotAuthorizedException = "NotAuthorizedException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UnexpectedLambdaException = "UnexpectedLambdaException", e.UserLambdaValidationException = "UserLambdaValidationException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(st || (st = {}));
var so;
(function (e) {
  e.CodeDeliveryFailureException = "CodeDeliveryFailureException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidEmailRoleAccessPolicyException = "InvalidEmailRoleAccessPolicyException", e.InvalidLambdaResponseException = "InvalidLambdaResponseException", e.InvalidParameterException = "InvalidParameterException", e.InvalidSmsRoleAccessPolicyException = "InvalidSmsRoleAccessPolicyException", e.InvalidSmsRoleTrustRelationshipException = "InvalidSmsRoleTrustRelationshipException", e.LimitExceededException = "LimitExceededException", e.NotAuthorizedException = "NotAuthorizedException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UnexpectedLambdaException = "UnexpectedLambdaException", e.UserLambdaValidationException = "UserLambdaValidationException", e.UserNotFoundException = "UserNotFoundException";
})(so || (so = {}));
var io;
(function (e) {
  e.AliasExistsException = "AliasExistsException", e.CodeMismatchException = "CodeMismatchException", e.ExpiredCodeException = "ExpiredCodeException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidLambdaResponseException = "InvalidLambdaResponseException", e.InvalidParameterException = "InvalidParameterException", e.InvalidPasswordException = "InvalidPasswordException", e.InvalidSmsRoleAccessPolicyException = "InvalidSmsRoleAccessPolicyException", e.InvalidSmsRoleTrustRelationshipException = "InvalidSmsRoleTrustRelationshipException", e.InvalidUserPoolConfigurationException = "InvalidUserPoolConfigurationException", e.MFAMethodNotFoundException = "MFAMethodNotFoundException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.SoftwareTokenMFANotFoundException = "SoftwareTokenMFANotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UnexpectedLambdaException = "UnexpectedLambdaException", e.UserLambdaValidationException = "UserLambdaValidationException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(io || (io = {}));
var ro;
(function (e) {
  e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(ro || (ro = {}));
var ao;
(function (e) {
  e.CodeDeliveryFailureException = "CodeDeliveryFailureException", e.InternalErrorException = "InternalErrorException", e.InvalidEmailRoleAccessPolicyException = "InvalidEmailRoleAccessPolicyException", e.InvalidLambdaResponseException = "InvalidLambdaResponseException", e.InvalidParameterException = "InvalidParameterException", e.InvalidPasswordException = "InvalidPasswordException", e.InvalidSmsRoleAccessPolicyException = "InvalidSmsRoleAccessPolicyException", e.InvalidSmsRoleTrustRelationshipException = "InvalidSmsRoleTrustRelationshipException", e.NotAuthorizedException = "NotAuthorizedException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UnexpectedLambdaException = "UnexpectedLambdaException", e.UserLambdaValidationException = "UserLambdaValidationException", e.UsernameExistsException = "UsernameExistsException";
})(ao || (ao = {}));
var co;
(function (e) {
  e.AliasExistsException = "AliasExistsException", e.CodeDeliveryFailureException = "CodeDeliveryFailureException", e.CodeMismatchException = "CodeMismatchException", e.ExpiredCodeException = "ExpiredCodeException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidEmailRoleAccessPolicyException = "InvalidEmailRoleAccessPolicyException", e.InvalidLambdaResponseException = "InvalidLambdaResponseException", e.InvalidParameterException = "InvalidParameterException", e.InvalidSmsRoleAccessPolicyException = "InvalidSmsRoleAccessPolicyException", e.InvalidSmsRoleTrustRelationshipException = "InvalidSmsRoleTrustRelationshipException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UnexpectedLambdaException = "UnexpectedLambdaException", e.UserLambdaValidationException = "UserLambdaValidationException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(co || (co = {}));
var uo;
(function (e) {
  e.CodeMismatchException = "CodeMismatchException", e.EnableSoftwareTokenMFAException = "EnableSoftwareTokenMFAException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.InvalidUserPoolConfigurationException = "InvalidUserPoolConfigurationException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.SoftwareTokenMFANotFoundException = "SoftwareTokenMFANotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(uo || (uo = {}));
var lo;
(function (e) {
  e.AliasExistsException = "AliasExistsException", e.CodeMismatchException = "CodeMismatchException", e.ExpiredCodeException = "ExpiredCodeException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.LimitExceededException = "LimitExceededException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(lo || (lo = {}));
var ho;
(function (e) {
  e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.InvalidUserPoolConfigurationException = "InvalidUserPoolConfigurationException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(ho || (ho = {}));
var fo;
(function (e) {
  e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.InvalidUserPoolConfigurationException = "InvalidUserPoolConfigurationException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(fo || (fo = {}));
const ga = "SetUpTOTPException",
  ht = "UserUnAuthenticatedException",
  pa = "UserAlreadyAuthenticatedException",
  ma = "DeviceMetadataNotFoundException",
  Jo = "AutoSignInException",
  Ea = "InvalidRedirectException",
  ya = new S({
    name: Ea,
    message: "signInRedirect or signOutRedirect had an invalid format or was not found.",
    recoverySuggestion: "Please make sure the signIn/Out redirect in your oauth config is valid."
  }),
  Ia = "InvalidOriginException",
  Sa = new S({
    name: Ia,
    message: "redirect is coming from a different origin. The oauth flow needs to be initiated from the same origin",
    recoverySuggestion: "Please call signInWithRedirect from the same origin."
  }),
  wa = "OAuthSignOutException",
  Ca = "TokenRefreshException",
  Aa = "UnexpectedSignInInterruptionException";
function q(e) {
  if (!e || !e.accessToken) throw new S({
    name: ht,
    message: "User needs to be authenticated to call this API.",
    recoverySuggestion: "Sign in before calling this API again."
  });
}
function xa(e) {
  if (!e || !e.idToken) throw new S({
    name: ht,
    message: "User needs to be authenticated to call this API.",
    recoverySuggestion: "Sign in before calling this API again."
  });
}
const Ta = new S({
    name: Ca,
    message: `Token refresh is not supported when authenticated with the 'implicit grant' (token) oauth flow. 
	Please change your oauth configuration to use 'code grant' flow.`,
    recoverySuggestion: `Please logout and change your Amplify configuration to use "code grant" flow. 
	E.g { responseType: 'code' }`
  }),
  va = new S({
    name: ht,
    message: "User needs to be authenticated to call this API.",
    recoverySuggestion: "Sign in before calling this API again."
  });
function Xo(e) {
  if (_a(e)) throw Ta;
  if (!Pa(e)) throw va;
}
function ft(e) {
  if (!e || !e.deviceKey || !e.deviceGroupKey || !e.randomPassword) throw new S({
    name: ma,
    message: "Either deviceKey, deviceGroupKey or secretPassword were not found during the sign-in process.",
    recoverySuggestion: "Make sure to not clear storage after calling the signIn API."
  });
}
const Ra = {
  inflightOAuth: "inflightOAuth",
  oauthSignIn: "oauthSignIn",
  oauthPKCE: "oauthPKCE",
  oauthState: "oauthState"
};
function Qo(e) {
  return (e == null ? void 0 : e.accessToken) || (e == null ? void 0 : e.idToken);
}
function Pa(e) {
  return Qo(e) && (e == null ? void 0 : e.refreshToken);
}
function _a(e) {
  return Qo(e) && !(e != null && e.refreshToken);
}
const Na = e => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
  var d, a, c, t, n, _ref23, o, s, i, r;
  return _regeneratorRuntime().wrap(function _callee27$(_context27) {
    while (1) switch (_context27.prev = _context27.next) {
      case 0:
        t = (d = e.getConfig().Auth) == null ? void 0 : d.Cognito;
        I(t);
        _context27.next = 4;
        return e.Auth.getTokens({
          forceRefresh: !1
        });
      case 4:
        n = _context27.sent;
        q(n);
        _ref23 = (c = (a = n.idToken) == null ? void 0 : a.payload) != null ? c : {}, o = _ref23["cognito:username"], s = _ref23.sub, i = {
          username: o,
          userId: s
        }, r = ba(n);
        return _context27.abrupt("return", (r && (i.signInDetails = r), i));
      case 8:
      case "end":
        return _context27.stop();
    }
  }, _callee27);
}));
function ba(e) {
  return e == null ? void 0 : e.signInDetails;
}
const Ht = () => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
    return _regeneratorRuntime().wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          return _context28.abrupt("return", Na(C));
        case 1:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  })),
  v = (e, t) => lt(y({
    category: Tt.Auth,
    action: e
  }, t)),
  Ua = (e, t) => {
    switch (t.type) {
      case "SET_SIGN_IN_SESSION":
        return R(y({}, e), {
          signInSession: t.value
        });
      case "SET_SIGN_IN_STATE":
        return y({}, t.value);
      case "SET_CHALLENGE_NAME":
        return R(y({}, e), {
          challengeName: t.value
        });
      case "SET_USERNAME":
        return R(y({}, e), {
          username: t.value
        });
      case "SET_INITIAL_STATE":
        return Zo();
      default:
        return e;
    }
  };
function Zo() {
  return {
    username: void 0,
    challengeName: void 0,
    signInSession: void 0
  };
}
const Ma = e => {
    let t = e(Zo(), {
      type: "SET_INITIAL_STATE"
    });
    return {
      getState: () => t,
      dispatch: n => {
        t = e(t, n);
      }
    };
  },
  fe = Ma(Ua);
function Be(e) {
  fe.dispatch({
    type: "SET_SIGN_IN_STATE",
    value: e
  });
}
function de() {
  fe.dispatch({
    type: "SET_INITIAL_STATE"
  });
}
const Ze = {
  convert(e) {
    return new TextEncoder().encode(e);
  }
};
function m(e, t) {
  e != null && this.fromString(e, t);
}
function H() {
  return new m(null, null);
}
let he;
const Da = 244837814094590,
  go = (Da & 16777215) === 15715070;
function Fa(e, t, n, o, s, i) {
  for (; --i >= 0;) {
    const r = t * this[e++] + n[o] + s;
    s = Math.floor(r / 67108864), n[o++] = r & 67108863;
  }
  return s;
}
function Oa(e, t, n, o, s, i) {
  const r = t & 32767,
    d = t >> 15;
  for (; --i >= 0;) {
    let a = this[e] & 32767;
    const c = this[e++] >> 15,
      u = d * a + c * r;
    a = r * a + ((u & 32767) << 15) + n[o] + (s & 1073741823), s = (a >>> 30) + (u >>> 15) + d * c + (s >>> 30), n[o++] = a & 1073741823;
  }
  return s;
}
function ka(e, t, n, o, s, i) {
  const r = t & 16383,
    d = t >> 14;
  for (; --i >= 0;) {
    let a = this[e] & 16383;
    const c = this[e++] >> 14,
      u = d * a + c * r;
    a = r * a + ((u & 16383) << 14) + n[o] + s, s = (a >> 28) + (u >> 14) + d * c, n[o++] = a & 268435455;
  }
  return s;
}
const po = typeof navigator != "undefined";
po && go && navigator.appName === "Microsoft Internet Explorer" ? (m.prototype.am = Oa, he = 30) : po && go && navigator.appName !== "Netscape" ? (m.prototype.am = Fa, he = 26) : (m.prototype.am = ka, he = 28);
m.prototype.DB = he;
m.prototype.DM = (1 << he) - 1;
m.prototype.DV = 1 << he;
const $t = 52;
m.prototype.FV = Math.pow(2, $t);
m.prototype.F1 = $t - he;
m.prototype.F2 = 2 * he - $t;
const La = "0123456789abcdefghijklmnopqrstuvwxyz",
  gt = [];
let Ne, Q;
Ne = 48;
for (Q = 0; Q <= 9; ++Q) gt[Ne++] = Q;
Ne = 97;
for (Q = 10; Q < 36; ++Q) gt[Ne++] = Q;
Ne = 65;
for (Q = 10; Q < 36; ++Q) gt[Ne++] = Q;
function mo(e) {
  return La.charAt(e);
}
function Ka(e, t) {
  const n = gt[e.charCodeAt(t)];
  return n == null ? -1 : n;
}
function Ba(e) {
  for (let t = this.t - 1; t >= 0; --t) e[t] = this[t];
  e.t = this.t, e.s = this.s;
}
function Va(e) {
  this.t = 1, this.s = e < 0 ? -1 : 0, e > 0 ? this[0] = e : e < -1 ? this[0] = e + this.DV : this.t = 0;
}
function jt(e) {
  const t = H();
  return t.fromInt(e), t;
}
function Wa(e, t) {
  let n;
  if (t === 16) n = 4;else if (t === 8) n = 3;else if (t === 2) n = 1;else if (t === 32) n = 5;else if (t === 4) n = 2;else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
  this.t = 0, this.s = 0;
  let o = e.length,
    s = !1,
    i = 0;
  for (; --o >= 0;) {
    const r = Ka(e, o);
    if (r < 0) {
      e.charAt(o) === "-" && (s = !0);
      continue;
    }
    s = !1, i === 0 ? this[this.t++] = r : i + n > this.DB ? (this[this.t - 1] |= (r & (1 << this.DB - i) - 1) << i, this[this.t++] = r >> this.DB - i) : this[this.t - 1] |= r << i, i += n, i >= this.DB && (i -= this.DB);
  }
  this.clamp(), s && m.ZERO.subTo(this, this);
}
function qa() {
  const e = this.s & this.DM;
  for (; this.t > 0 && this[this.t - 1] == e;) --this.t;
}
function Ha(e) {
  if (this.s < 0) return "-" + this.negate().toString(e);
  let t;
  if (e == 16) t = 4;else if (e === 8) t = 3;else if (e === 2) t = 1;else if (e === 32) t = 5;else if (e === 4) t = 2;else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
  const n = (1 << t) - 1;
  let o,
    s = !1,
    i = "",
    r = this.t,
    d = this.DB - r * this.DB % t;
  if (r-- > 0) for (d < this.DB && (o = this[r] >> d) > 0 && (s = !0, i = mo(o)); r >= 0;) d < t ? (o = (this[r] & (1 << d) - 1) << t - d, o |= this[--r] >> (d += this.DB - t)) : (o = this[r] >> (d -= t) & n, d <= 0 && (d += this.DB, --r)), o > 0 && (s = !0), s && (i += mo(o));
  return s ? i : "0";
}
function $a() {
  const e = H();
  return m.ZERO.subTo(this, e), e;
}
function ja() {
  return this.s < 0 ? this.negate() : this;
}
function za(e) {
  let t = this.s - e.s;
  if (t != 0) return t;
  let n = this.t;
  if (t = n - e.t, t != 0) return this.s < 0 ? -t : t;
  for (; --n >= 0;) if ((t = this[n] - e[n]) != 0) return t;
  return 0;
}
function zt(e) {
  let t = 1,
    n;
  return (n = e >>> 16) !== 0 && (e = n, t += 16), (n = e >> 8) !== 0 && (e = n, t += 8), (n = e >> 4) !== 0 && (e = n, t += 4), (n = e >> 2) !== 0 && (e = n, t += 2), (n = e >> 1) !== 0 && (e = n, t += 1), t;
}
function Ga() {
  return this.t <= 0 ? 0 : this.DB * (this.t - 1) + zt(this[this.t - 1] ^ this.s & this.DM);
}
function Ya(e, t) {
  let n;
  for (n = this.t - 1; n >= 0; --n) t[n + e] = this[n];
  for (n = e - 1; n >= 0; --n) t[n] = 0;
  t.t = this.t + e, t.s = this.s;
}
function Ja(e, t) {
  for (let n = e; n < this.t; ++n) t[n - e] = this[n];
  t.t = Math.max(this.t - e, 0), t.s = this.s;
}
function Xa(e, t) {
  const n = e % this.DB,
    o = this.DB - n,
    s = (1 << o) - 1,
    i = Math.floor(e / this.DB);
  let r = this.s << n & this.DM,
    d;
  for (d = this.t - 1; d >= 0; --d) t[d + i + 1] = this[d] >> o | r, r = (this[d] & s) << n;
  for (d = i - 1; d >= 0; --d) t[d] = 0;
  t[i] = r, t.t = this.t + i + 1, t.s = this.s, t.clamp();
}
function Qa(e, t) {
  t.s = this.s;
  const n = Math.floor(e / this.DB);
  if (n >= this.t) {
    t.t = 0;
    return;
  }
  const o = e % this.DB,
    s = this.DB - o,
    i = (1 << o) - 1;
  t[0] = this[n] >> o;
  for (let r = n + 1; r < this.t; ++r) t[r - n - 1] |= (this[r] & i) << s, t[r - n] = this[r] >> o;
  o > 0 && (t[this.t - n - 1] |= (this.s & i) << s), t.t = this.t - n, t.clamp();
}
function Za(e, t) {
  let n = 0,
    o = 0;
  const s = Math.min(e.t, this.t);
  for (; n < s;) o += this[n] - e[n], t[n++] = o & this.DM, o >>= this.DB;
  if (e.t < this.t) {
    for (o -= e.s; n < this.t;) o += this[n], t[n++] = o & this.DM, o >>= this.DB;
    o += this.s;
  } else {
    for (o += this.s; n < e.t;) o -= e[n], t[n++] = o & this.DM, o >>= this.DB;
    o -= e.s;
  }
  t.s = o < 0 ? -1 : 0, o < -1 ? t[n++] = this.DV + o : o > 0 && (t[n++] = o), t.t = n, t.clamp();
}
function ec(e, t) {
  const n = this.abs(),
    o = e.abs();
  let s = n.t;
  for (t.t = s + o.t; --s >= 0;) t[s] = 0;
  for (s = 0; s < o.t; ++s) t[s + n.t] = n.am(0, o[s], t, s, 0, n.t);
  t.s = 0, t.clamp(), this.s !== e.s && m.ZERO.subTo(t, t);
}
function tc(e) {
  const t = this.abs();
  let n = e.t = 2 * t.t;
  for (; --n >= 0;) e[n] = 0;
  for (n = 0; n < t.t - 1; ++n) {
    const o = t.am(n, t[n], e, 2 * n, 0, 1);
    (e[n + t.t] += t.am(n + 1, 2 * t[n], e, 2 * n + 1, o, t.t - n - 1)) >= t.DV && (e[n + t.t] -= t.DV, e[n + t.t + 1] = 1);
  }
  e.t > 0 && (e[e.t - 1] += t.am(n, t[n], e, 2 * n, 0, 1)), e.s = 0, e.clamp();
}
function nc(e, t, n) {
  const o = e.abs();
  if (o.t <= 0) return;
  const s = this.abs();
  if (s.t < o.t) {
    t != null && t.fromInt(0), n != null && this.copyTo(n);
    return;
  }
  n === null && (n = H());
  const i = H(),
    r = this.s,
    d = e.s,
    a = this.DB - zt(o[o.t - 1]);
  a > 0 ? (o.lShiftTo(a, i), s.lShiftTo(a, n)) : (o.copyTo(i), s.copyTo(n));
  const c = i.t,
    u = i[c - 1];
  if (u === 0) return;
  const f = u * (1 << this.F1) + (c > 1 ? i[c - 2] >> this.F2 : 0),
    h = this.FV / f,
    g = (1 << this.F1) / f,
    E = 1 << this.F2;
  let p = n.t,
    A = p - c;
  const P = t === null ? H() : t;
  for (i.dlShiftTo(A, P), n.compareTo(P) >= 0 && (n[n.t++] = 1, n.subTo(P, n)), m.ONE.dlShiftTo(c, P), P.subTo(i, i); i.t < c;) i[i.t++] = 0;
  for (; --A >= 0;) {
    let F = n[--p] === u ? this.DM : Math.floor(n[p] * h + (n[p - 1] + E) * g);
    if ((n[p] += i.am(0, F, n, A, 0, c)) < F) for (i.dlShiftTo(A, P), n.subTo(P, n); n[p] < --F;) n.subTo(P, n);
  }
  t !== null && (n.drShiftTo(c, t), r !== d && m.ZERO.subTo(t, t)), n.t = c, n.clamp(), a > 0 && n.rShiftTo(a, n), r < 0 && m.ZERO.subTo(n, n);
}
function oc(e) {
  const t = H();
  return this.abs().divRemTo(e, null, t), this.s < 0 && t.compareTo(m.ZERO) > 0 && e.subTo(t, t), t;
}
function sc() {
  if (this.t < 1) return 0;
  const e = this[0];
  if (!(e & 1)) return 0;
  let t = e & 3;
  return t = t * (2 - (e & 15) * t) & 15, t = t * (2 - (e & 255) * t) & 255, t = t * (2 - ((e & 65535) * t & 65535)) & 65535, t = t * (2 - e * t % this.DV) % this.DV, t > 0 ? this.DV - t : -t;
}
function ic(e) {
  return this.compareTo(e) === 0;
}
function rc(e, t) {
  let n = 0,
    o = 0;
  const s = Math.min(e.t, this.t);
  for (; n < s;) o += this[n] + e[n], t[n++] = o & this.DM, o >>= this.DB;
  if (e.t < this.t) {
    for (o += e.s; n < this.t;) o += this[n], t[n++] = o & this.DM, o >>= this.DB;
    o += this.s;
  } else {
    for (o += this.s; n < e.t;) o += e[n], t[n++] = o & this.DM, o >>= this.DB;
    o += e.s;
  }
  t.s = o < 0 ? -1 : 0, o > 0 ? t[n++] = o : o < -1 && (t[n++] = this.DV + o), t.t = n, t.clamp();
}
function ac(e) {
  const t = H();
  return this.addTo(e, t), t;
}
function cc(e) {
  const t = H();
  return this.subTo(e, t), t;
}
function dc(e) {
  const t = H();
  return this.multiplyTo(e, t), t;
}
function uc(e) {
  const t = H();
  return this.divRemTo(e, t, null), t;
}
function be(e) {
  this.m = e, this.mp = e.invDigit(), this.mpl = this.mp & 32767, this.mph = this.mp >> 15, this.um = (1 << e.DB - 15) - 1, this.mt2 = 2 * e.t;
}
function lc(e) {
  const t = H();
  return e.abs().dlShiftTo(this.m.t, t), t.divRemTo(this.m, null, t), e.s < 0 && t.compareTo(m.ZERO) > 0 && this.m.subTo(t, t), t;
}
function hc(e) {
  const t = H();
  return e.copyTo(t), this.reduce(t), t;
}
function fc(e) {
  for (; e.t <= this.mt2;) e[e.t++] = 0;
  for (let t = 0; t < this.m.t; ++t) {
    let n = e[t] & 32767;
    const o = n * this.mpl + ((n * this.mph + (e[t] >> 15) * this.mpl & this.um) << 15) & e.DM;
    for (n = t + this.m.t, e[n] += this.m.am(0, o, e, t, 0, this.m.t); e[n] >= e.DV;) e[n] -= e.DV, e[++n]++;
  }
  e.clamp(), e.drShiftTo(this.m.t, e), e.compareTo(this.m) >= 0 && e.subTo(this.m, e);
}
function gc(e, t) {
  e.squareTo(t), this.reduce(t);
}
function pc(e, t, n) {
  e.multiplyTo(t, n), this.reduce(n);
}
be.prototype.convert = lc;
be.prototype.revert = hc;
be.prototype.reduce = fc;
be.prototype.mulTo = pc;
be.prototype.sqrTo = gc;
function mc(e, t, n) {
  let o = e.bitLength(),
    s,
    i = jt(1);
  const r = new be(t);
  if (o <= 0) return i;
  o < 18 ? s = 1 : o < 48 ? s = 3 : o < 144 ? s = 4 : o < 768 ? s = 5 : s = 6;
  const d = [];
  let a = 3;
  const c = s - 1,
    u = (1 << s) - 1;
  if (d[1] = r.convert(this), s > 1) {
    const P = H();
    for (r.sqrTo(d[1], P); a <= u;) d[a] = H(), r.mulTo(P, d[a - 2], d[a]), a += 2;
  }
  let f = e.t - 1,
    h,
    g = !0,
    E = H(),
    p;
  for (o = zt(e[f]) - 1; f >= 0;) {
    for (o >= c ? h = e[f] >> o - c & u : (h = (e[f] & (1 << o + 1) - 1) << c - o, f > 0 && (h |= e[f - 1] >> this.DB + o - c)), a = s; !(h & 1);) h >>= 1, --a;
    if ((o -= a) < 0 && (o += this.DB, --f), g) d[h].copyTo(i), g = !1;else {
      for (; a > 1;) r.sqrTo(i, E), r.sqrTo(E, i), a -= 2;
      a > 0 ? r.sqrTo(i, E) : (p = i, i = E, E = p), r.mulTo(E, d[h], i);
    }
    for (; f >= 0 && !(e[f] & 1 << o);) r.sqrTo(i, E), p = i, i = E, E = p, --o < 0 && (o = this.DB - 1, --f);
  }
  const A = r.revert(i);
  return n(null, A), A;
}
m.prototype.copyTo = Ba;
m.prototype.fromInt = Va;
m.prototype.fromString = Wa;
m.prototype.clamp = qa;
m.prototype.dlShiftTo = Ya;
m.prototype.drShiftTo = Ja;
m.prototype.lShiftTo = Xa;
m.prototype.rShiftTo = Qa;
m.prototype.subTo = Za;
m.prototype.multiplyTo = ec;
m.prototype.squareTo = tc;
m.prototype.divRemTo = nc;
m.prototype.invDigit = sc;
m.prototype.addTo = rc;
m.prototype.toString = Ha;
m.prototype.negate = $a;
m.prototype.abs = ja;
m.prototype.compareTo = za;
m.prototype.bitLength = Ga;
m.prototype.mod = oc;
m.prototype.equals = ic;
m.prototype.add = ac;
m.prototype.subtract = cc;
m.prototype.multiply = dc;
m.prototype.divide = uc;
m.prototype.modPow = mc;
m.ZERO = jt(0);
m.ONE = jt(1);
const Ec = d => l(void 0, [d], function (_ref24) {
    let e = _ref24.a,
      t = _ref24.g,
      n = _ref24.k,
      o = _ref24.x,
      s = _ref24.B,
      i = _ref24.N,
      r = _ref24.U;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
      return _regeneratorRuntime().wrap(function _callee29$(_context29) {
        while (1) switch (_context29.prev = _context29.next) {
          case 0:
            return _context29.abrupt("return", new Promise((a, c) => {
              t.modPow(o, i, (u, f) => {
                if (u) {
                  c(u);
                  return;
                }
                s.subtract(n.multiply(f)).modPow(e.add(r.multiply(o)), i, (h, g) => {
                  if (h) {
                    c(h);
                    return;
                  }
                  a(g.mod(i));
                });
              });
            }));
          case 1:
          case "end":
            return _context29.stop();
        }
      }, _callee29);
    })();
  }),
  yc = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF",
  es = {},
  Nt = {};
for (let e = 0; e < 256; e++) {
  let t = e.toString(16).toLowerCase();
  t.length === 1 && (t = `0${t}`), es[e] = t, Nt[t] = e;
}
const Re = e => {
    if (e.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const t = new Uint8Array(e.length / 2);
    for (let n = 0; n < e.length; n += 2) {
      const o = e.slice(n, n + 2).toLowerCase();
      if (o in Nt) t[n / 2] = Nt[o];else throw new Error(`Cannot decode unrecognized sequence ${o} as hexadecimal`);
    }
    return t;
  },
  Gt = e => {
    let t = "";
    for (let n = 0; n < e.byteLength; n++) t += es[e[n]];
    return t;
  },
  bt = e => {
    const t = new Oe();
    t.update(e);
    const n = t.digestSync(),
      o = Gt(n);
    return new Array(64 - o.length).join("0") + o;
  },
  et = e => bt(Re(e)),
  Ic = /^[89a-f]/i,
  ce = e => {
    if (!(e instanceof m)) throw new Error("Not a BigInteger");
    const t = e.compareTo(m.ZERO) < 0;
    let n = e.abs().toString(16);
    if (n = n.length % 2 !== 0 ? `0${n}` : n, n = Ic.test(n) ? `00${n}` : n, t) {
      const o = n.split("").map(i => {
        const r = ~parseInt(i, 16) & 15;
        return "0123456789ABCDEF".charAt(r);
      }).join("");
      n = new m(o, 16).add(m.ONE).toString(16), n.toUpperCase().startsWith("FF8") && (n = n.substring(2));
    }
    return n;
  },
  Sc = _ref25 => {
    let e = _ref25.A,
      t = _ref25.B;
    const n = new m(et(ce(e) + ce(t)), 16);
    if (n.equals(m.ZERO)) throw new Error("U cannot be zero.");
    return n;
  },
  wc = (e, t, n) => {
    const o = new Oe(t);
    o.update(e);
    const s = o.digestSync(),
      i = new Oe(s);
    return i.update(n), i.digestSync().slice(0, 16);
  },
  Yt = e => {
    const t = new qt().random(e).toString();
    return Re(t);
  },
  Cc = () => Le.convert(Yt(40));
class Ac {
  constructor(_ref26) {
    let t = _ref26.userPoolName,
      n = _ref26.a,
      o = _ref26.g,
      s = _ref26.A,
      i = _ref26.N;
    this.encoder = Ze, this.userPoolName = t, this.a = n, this.g = o, this.A = s, this.N = i, this.k = new m(et(`${ce(i)}${ce(o)}`), 16);
  }
  /**
   * @returns {string} Generated random value included in password hash.
   */
  getRandomPassword() {
    if (!this.randomPassword) throw new S({
      name: "EmptyBigIntegerRandomPassword",
      message: "random password is empty"
    });
    return this.randomPassword;
  }
  /**
   * @returns {string} Generated random value included in devices hash.
   */
  getSaltToHashDevices() {
    if (!this.saltToHashDevices) throw new S({
      name: "EmptyBigIntegersaltToHashDevices",
      message: "saltToHashDevices is empty"
    });
    return this.saltToHashDevices;
  }
  /**
   * @returns {string} Value used to verify devices.
   */
  getVerifierDevices() {
    if (!this.verifierDevices) throw new S({
      name: "EmptyBigIntegerVerifierDevices",
      message: "verifyDevices is empty"
    });
    return this.verifierDevices;
  }
  /**
   * Generate salts and compute verifier.
   *
   * @param {string} deviceGroupKey Devices to generate verifier for.
   * @param {string} username User to generate verifier for.
   *
   * @returns {Promise<void>}
   */
  generateHashDevice(t, n) {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
      var o, s, i;
      return _regeneratorRuntime().wrap(function _callee30$(_context30) {
        while (1) switch (_context30.prev = _context30.next) {
          case 0:
            this.randomPassword = Cc();
            o = `${t}${n}:${this.randomPassword}`, s = bt(o), i = Gt(Yt(16));
            return _context30.abrupt("return", (this.saltToHashDevices = ce(new m(i, 16)), new Promise((r, d) => {
              this.g.modPow(new m(et(this.saltToHashDevices + s), 16), this.N, (a, c) => {
                if (a) {
                  d(a);
                  return;
                }
                this.verifierDevices = ce(c), r();
              });
            })));
          case 3:
          case "end":
            return _context30.stop();
        }
      }, _callee30, this);
    }));
  }
  /**
   * Calculates the final HKDF key based on computed S value, computed U value and the key
   *
   * @param {String} username Username.
   * @param {String} password Password.
   * @param {AuthBigInteger} B Server B value.
   * @param {AuthBigInteger} salt Generated salt.
   */
  getPasswordAuthenticationKey(i) {
    return l(this, arguments, function (_ref27) {
      var _this2 = this;
      let t = _ref27.username,
        n = _ref27.password,
        o = _ref27.serverBValue,
        s = _ref27.salt;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
        var r, d, a, c, u, f, h, g;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              if (!o.mod(_this2.N).equals(m.ZERO)) {
                _context31.next = 2;
                break;
              }
              throw new Error("B cannot be zero.");
            case 2:
              r = Sc({
                A: _this2.A,
                B: o
              });
              d = `${_this2.userPoolName}${t}:${n}`;
              a = bt(d);
              c = new m(et(ce(s) + a), 16);
              _context31.next = 8;
              return Ec({
                a: _this2.a,
                g: _this2.g,
                k: _this2.k,
                x: c,
                B: o,
                N: _this2.N,
                U: r
              });
            case 8:
              u = _context31.sent;
              f = _this2.encoder.convert("Caldera Derived Key");
              h = _this2.encoder.convert("");
              g = new Uint8Array(f.byteLength + h.byteLength);
              return _context31.abrupt("return", (g.set(f, 0), g.set(h, f.byteLength), wc(Re(ce(u)), Re(ce(r)), g)));
            case 13:
            case "end":
              return _context31.stop();
          }
        }, _callee31);
      })();
    });
  }
}
const xc = o => l(void 0, [o], function (_ref28) {
    let e = _ref28.a,
      t = _ref28.g,
      n = _ref28.N;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
      return _regeneratorRuntime().wrap(function _callee32$(_context32) {
        while (1) switch (_context32.prev = _context32.next) {
          case 0:
            return _context32.abrupt("return", new Promise((s, i) => {
              t.modPow(e, n, (r, d) => {
                if (r) {
                  i(r);
                  return;
                }
                if (d.mod(n).equals(m.ZERO)) {
                  i(new Error("Illegal parameter. A mod N cannot be 0."));
                  return;
                }
                s(d);
              });
            }));
          case 1:
          case "end":
            return _context32.stop();
        }
      }, _callee32);
    })();
  }),
  pt = e => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
    var t, n, o, s;
    return _regeneratorRuntime().wrap(function _callee33$(_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          t = new m(yc, 16);
          n = new m("2", 16);
          o = Tc();
          _context33.next = 5;
          return xc({
            a: o,
            g: n,
            N: t
          });
        case 5:
          s = _context33.sent;
          return _context33.abrupt("return", new Ac({
            userPoolName: e,
            a: o,
            g: n,
            A: s,
            N: t
          }));
        case 7:
        case "end":
          return _context33.stop();
      }
    }, _callee33);
  })),
  Tc = () => {
    const e = Gt(Yt(128));
    return new m(e, 16);
  },
  vc = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  Rc = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  ts = () => {
    const e = /* @__PURE__ */new Date(),
      t = Rc[e.getUTCDay()],
      n = vc[e.getUTCMonth()],
      o = e.getUTCDate();
    let s = e.getUTCHours();
    s < 10 && (s = `0${s}`);
    let i = e.getUTCMinutes();
    i < 10 && (i = `0${i}`);
    let r = e.getUTCSeconds();
    r < 10 && (r = `0${r}`);
    const d = e.getUTCFullYear();
    return `${t} ${n} ${o} ${s}:${i}:${r} UTC ${d}`;
  },
  ns = _ref29 => {
    let e = _ref29.userPoolName,
      t = _ref29.username,
      n = _ref29.challengeParameters,
      o = _ref29.dateNow,
      s = _ref29.hkdf;
    const i = Ze.convert(e),
      r = Ze.convert(t),
      d = Pc(n.SECRET_BLOCK),
      a = Ze.convert(o),
      c = new Uint8Array(i.byteLength + r.byteLength + d.byteLength + a.byteLength);
    c.set(i, 0), c.set(r, i.byteLength), c.set(d, i.byteLength + r.byteLength), c.set(a, i.byteLength + r.byteLength + d.byteLength);
    const u = new Oe(s);
    u.update(c);
    const f = u.digestSync();
    return Le.convert(f);
  },
  Pc = e => {
    const t = "=".repeat((4 - e.length % 4) % 4),
      n = (e + t).replace(/-/g, "+").replace(/_/g, "/"),
      o = vo.convert(n),
      s = new Uint8Array(o.length);
    for (let i = 0; i < o.length; ++i) s[i] = o.charCodeAt(i);
    return s;
  };
function W(_ref30) {
  let e = _ref30.username,
    t = _ref30.userPoolId,
    n = _ref30.userPoolClientId;
  if (typeof window == "undefined") return;
  const o = window.AmazonCognitoAdvancedSecurityData;
  if (typeof o == "undefined") return;
  const s = o.getData(e, t, n);
  return s ? {
    EncodedData: s
  } : {};
}
const Ut = "userAttributes.";
function _c(r) {
  return l(this, arguments, function (_ref31) {
    let e = _ref31.challengeResponse,
      t = _ref31.clientMetadata,
      n = _ref31.session,
      o = _ref31.username,
      s = _ref31.config,
      i = _ref31.tokenOrchestrator;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
      var d, a, c, u, f, h, g;
      return _regeneratorRuntime().wrap(function _callee34$(_context34) {
        while (1) switch (_context34.prev = _context34.next) {
          case 0:
            d = s.userPoolId;
            a = s.userPoolClientId;
            c = {
              USERNAME: o,
              ANSWER: e
            };
            _context34.next = 5;
            return i == null ? void 0 : i.getDeviceMetadata(o);
          case 5:
            u = _context34.sent;
            u && u.deviceKey && (c.DEVICE_KEY = u.deviceKey);
            f = W({
              username: o,
              userPoolId: d,
              userPoolClientId: a
            });
            h = {
              ChallengeName: "CUSTOM_CHALLENGE",
              ChallengeResponses: c,
              Session: n,
              ClientMetadata: t,
              ClientId: a,
              UserContextData: f
            };
            _context34.next = 11;
            return ue({
              region: x(d),
              userAgentValue: v(T.ConfirmSignIn)
            }, h);
          case 11:
            g = _context34.sent;
            return _context34.abrupt("return", g.ChallengeName === "DEVICE_SRP_AUTH" ? mt({
              username: o,
              config: s,
              clientMetadata: t,
              session: g.Session,
              tokenOrchestrator: i
            }) : g);
          case 13:
          case "end":
            return _context34.stop();
        }
      }, _callee34);
    })();
  });
}
function Nc(r) {
  return l(this, arguments, function (_ref32) {
    let e = _ref32.challengeResponse,
      t = _ref32.username,
      n = _ref32.clientMetadata,
      o = _ref32.session,
      s = _ref32.deviceName,
      i = _ref32.config;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
      var d, a, c, _yield$zo, u, f;
      return _regeneratorRuntime().wrap(function _callee35$(_context35) {
        while (1) switch (_context35.prev = _context35.next) {
          case 0:
            d = i.userPoolId;
            a = i.userPoolClientId;
            c = {
              USERNAME: t
            };
            _context35.next = 5;
            return zo({
              region: x(d),
              userAgentValue: v(T.ConfirmSignIn)
            }, {
              UserCode: e,
              Session: o,
              FriendlyDeviceName: s
            });
          case 5:
            _yield$zo = _context35.sent;
            u = _yield$zo.Session;
            fe.dispatch({
              type: "SET_SIGN_IN_SESSION",
              value: u
            });
            f = {
              ChallengeName: "MFA_SETUP",
              ChallengeResponses: c,
              Session: u,
              ClientMetadata: n,
              ClientId: a
            };
            return _context35.abrupt("return", ue({
              region: x(d)
            }, f));
          case 10:
          case "end":
            return _context35.stop();
        }
      }, _callee35);
    })();
  });
}
function bc(i) {
  return l(this, arguments, function (_ref33) {
    let e = _ref33.challengeResponse,
      t = _ref33.username,
      n = _ref33.clientMetadata,
      o = _ref33.session,
      s = _ref33.config;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
      var r, d, a, c, u;
      return _regeneratorRuntime().wrap(function _callee36$(_context36) {
        while (1) switch (_context36.prev = _context36.next) {
          case 0:
            r = s.userPoolId, d = s.userPoolClientId;
            b(e === "TOTP" || e === "SMS", w.IncorrectMFAMethod);
            a = {
              USERNAME: t,
              ANSWER: qc(e)
            }, c = W({
              username: t,
              userPoolId: r,
              userPoolClientId: d
            }), u = {
              ChallengeName: "SELECT_MFA_TYPE",
              ChallengeResponses: a,
              Session: o,
              ClientMetadata: n,
              ClientId: d,
              UserContextData: c
            };
            return _context36.abrupt("return", ue({
              region: x(r),
              userAgentValue: v(T.ConfirmSignIn)
            }, u));
          case 4:
          case "end":
            return _context36.stop();
        }
      }, _callee36);
    })();
  });
}
function Uc(i) {
  return l(this, arguments, function (_ref34) {
    let e = _ref34.challengeResponse,
      t = _ref34.clientMetadata,
      n = _ref34.session,
      o = _ref34.username,
      s = _ref34.config;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
      var r, d, a, c, u;
      return _regeneratorRuntime().wrap(function _callee37$(_context37) {
        while (1) switch (_context37.prev = _context37.next) {
          case 0:
            r = s.userPoolId, d = s.userPoolClientId, a = {
              USERNAME: o,
              SMS_MFA_CODE: e
            }, c = W({
              username: o,
              userPoolId: r,
              userPoolClientId: d
            }), u = {
              ChallengeName: "SMS_MFA",
              ChallengeResponses: a,
              Session: n,
              ClientMetadata: t,
              ClientId: d,
              UserContextData: c
            };
            return _context37.abrupt("return", ue({
              region: x(r),
              userAgentValue: v(T.ConfirmSignIn)
            }, u));
          case 2:
          case "end":
            return _context37.stop();
        }
      }, _callee37);
    })();
  });
}
function Mc(i) {
  return l(this, arguments, function (_ref35) {
    let e = _ref35.challengeResponse,
      t = _ref35.clientMetadata,
      n = _ref35.session,
      o = _ref35.username,
      s = _ref35.config;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
      var r, d, a, c, u;
      return _regeneratorRuntime().wrap(function _callee38$(_context38) {
        while (1) switch (_context38.prev = _context38.next) {
          case 0:
            r = s.userPoolId, d = s.userPoolClientId, a = {
              USERNAME: o,
              SOFTWARE_TOKEN_MFA_CODE: e
            }, c = W({
              username: o,
              userPoolId: r,
              userPoolClientId: d
            }), u = {
              ChallengeName: "SOFTWARE_TOKEN_MFA",
              ChallengeResponses: a,
              Session: n,
              ClientMetadata: t,
              ClientId: d,
              UserContextData: c
            };
            return _context38.abrupt("return", ue({
              region: x(r),
              userAgentValue: v(T.ConfirmSignIn)
            }, u));
          case 2:
          case "end":
            return _context38.stop();
        }
      }, _callee38);
    })();
  });
}
function Dc(r) {
  return l(this, arguments, function (_ref36) {
    let e = _ref36.challengeResponse,
      t = _ref36.clientMetadata,
      n = _ref36.session,
      o = _ref36.username,
      s = _ref36.requiredAttributes,
      i = _ref36.config;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
      var d, a, c, u, f;
      return _regeneratorRuntime().wrap(function _callee39$(_context39) {
        while (1) switch (_context39.prev = _context39.next) {
          case 0:
            d = i.userPoolId, a = i.userPoolClientId, c = R(y({}, Vc(s)), {
              NEW_PASSWORD: e,
              USERNAME: o
            }), u = W({
              username: o,
              userPoolId: d,
              userPoolClientId: a
            }), f = {
              ChallengeName: "NEW_PASSWORD_REQUIRED",
              ChallengeResponses: c,
              ClientMetadata: t,
              Session: n,
              ClientId: a,
              UserContextData: u
            };
            return _context39.abrupt("return", ue({
              region: x(d),
              userAgentValue: v(T.ConfirmSignIn)
            }, f));
          case 2:
          case "end":
            return _context39.stop();
        }
      }, _callee39);
    })();
  });
}
function Fc(e, t, n, o, s) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
    var g, E, p, A, i, r, d, a, c, u, f, h;
    return _regeneratorRuntime().wrap(function _callee40$(_context40) {
      while (1) switch (_context40.prev = _context40.next) {
        case 0:
          i = o.userPoolClientId;
          r = o.userPoolId;
          d = {
            USERNAME: e,
            PASSWORD: t
          };
          _context40.next = 5;
          return s.getDeviceMetadata(e);
        case 5:
          a = _context40.sent;
          a && a.deviceKey && (d.DEVICE_KEY = a.deviceKey);
          c = W({
            username: e,
            userPoolId: r,
            userPoolClientId: i
          });
          u = {
            AuthFlow: "USER_PASSWORD_AUTH",
            AuthParameters: d,
            ClientMetadata: n,
            ClientId: i,
            UserContextData: c
          };
          _context40.next = 11;
          return Ke({
            region: x(r),
            userAgentValue: v(T.SignIn)
          }, u);
        case 11:
          f = _context40.sent;
          h = (A = (p = (g = f.ChallengeParameters) == null ? void 0 : g.USERNAME) != null ? p : (E = f.ChallengeParameters) == null ? void 0 : E.USER_ID_FOR_SRP) != null ? A : e;
          return _context40.abrupt("return", (Et(h), f.ChallengeName === "DEVICE_SRP_AUTH" ? mt({
            username: h,
            config: o,
            clientMetadata: n,
            session: f.Session,
            tokenOrchestrator: s
          }) : f));
        case 14:
        case "end":
          return _context40.stop();
      }
    }, _callee40);
  }));
}
function Oc(e, t, n, o, s) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
    var A, i, r, d, a, c, u, f, h, g, E, p;
    return _regeneratorRuntime().wrap(function _callee41$(_context41) {
      while (1) switch (_context41.prev = _context41.next) {
        case 0:
          i = o.userPoolId;
          r = o.userPoolClientId;
          d = (i == null ? void 0 : i.split("_")[1]) || "";
          _context41.next = 5;
          return pt(d);
        case 5:
          a = _context41.sent;
          c = {
            USERNAME: e,
            SRP_A: a.A.toString(16)
          };
          u = W({
            username: e,
            userPoolId: i,
            userPoolClientId: r
          });
          f = {
            AuthFlow: "USER_SRP_AUTH",
            AuthParameters: c,
            ClientMetadata: n,
            ClientId: r,
            UserContextData: u
          };
          _context41.next = 11;
          return Ke({
            region: x(i),
            userAgentValue: v(T.SignIn)
          }, f);
        case 11:
          h = _context41.sent;
          g = h.ChallengeParameters;
          E = h.Session;
          p = (A = g == null ? void 0 : g.USERNAME) != null ? A : e;
          return _context41.abrupt("return", (Et(p), He(os, [t, g, n, E, a, o, s], p, s)));
        case 16:
        case "end":
          return _context41.stop();
      }
    }, _callee41);
  }));
}
function kc(e, t, n, o) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
    var h, g, s, i, r, d, a, c, u, f;
    return _regeneratorRuntime().wrap(function _callee42$(_context42) {
      while (1) switch (_context42.prev = _context42.next) {
        case 0:
          s = n.userPoolClientId;
          i = n.userPoolId;
          r = {
            USERNAME: e
          };
          _context42.next = 5;
          return o.getDeviceMetadata(e);
        case 5:
          d = _context42.sent;
          d && d.deviceKey && (r.DEVICE_KEY = d.deviceKey);
          a = W({
            username: e,
            userPoolId: i,
            userPoolClientId: s
          });
          c = {
            AuthFlow: "CUSTOM_AUTH",
            AuthParameters: r,
            ClientMetadata: t,
            ClientId: s,
            UserContextData: a
          };
          _context42.next = 11;
          return Ke({
            region: x(i),
            userAgentValue: v(T.SignIn)
          }, c);
        case 11:
          u = _context42.sent;
          f = (g = (h = u.ChallengeParameters) == null ? void 0 : h.USERNAME) != null ? g : e;
          return _context42.abrupt("return", (Et(f), u.ChallengeName === "DEVICE_SRP_AUTH" ? mt({
            username: f,
            config: n,
            clientMetadata: t,
            session: u.Session,
            tokenOrchestrator: o
          }) : u));
        case 14:
        case "end":
          return _context42.stop();
      }
    }, _callee42);
  }));
}
function Lc(e, t, n, o, s) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
    var p, i, r, d, a, c, u, f, _yield$Ke, h, g, E;
    return _regeneratorRuntime().wrap(function _callee43$(_context43) {
      while (1) switch (_context43.prev = _context43.next) {
        case 0:
          I(o);
          i = o.userPoolId;
          r = o.userPoolClientId;
          d = (i == null ? void 0 : i.split("_")[1]) || "";
          _context43.next = 6;
          return pt(d);
        case 6:
          a = _context43.sent;
          c = {
            USERNAME: e,
            SRP_A: a.A.toString(16),
            CHALLENGE_NAME: "SRP_A"
          };
          u = W({
            username: e,
            userPoolId: i,
            userPoolClientId: r
          });
          f = {
            AuthFlow: "CUSTOM_AUTH",
            AuthParameters: c,
            ClientMetadata: n,
            ClientId: r,
            UserContextData: u
          };
          _context43.next = 12;
          return Ke({
            region: x(i),
            userAgentValue: v(T.SignIn)
          }, f);
        case 12:
          _yield$Ke = _context43.sent;
          h = _yield$Ke.ChallengeParameters;
          g = _yield$Ke.Session;
          E = (p = h == null ? void 0 : h.USERNAME) != null ? p : e;
          return _context43.abrupt("return", (Et(E), He(os, [t, h, n, g, a, o, s], E, s)));
        case 17:
        case "end":
          return _context43.stop();
      }
    }, _callee43);
  }));
}
function mt(i) {
  return l(this, arguments, function (_ref37) {
    let e = _ref37.username,
      t = _ref37.config,
      n = _ref37.clientMetadata,
      o = _ref37.session,
      s = _ref37.tokenOrchestrator;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
      var r, d, a, c, u, f, _yield$ue, h, g;
      return _regeneratorRuntime().wrap(function _callee44$(_context44) {
        while (1) switch (_context44.prev = _context44.next) {
          case 0:
            r = t.userPoolId;
            d = t.userPoolClientId;
            _context44.next = 4;
            return s == null ? void 0 : s.getDeviceMetadata(e);
          case 4:
            a = _context44.sent;
            ft(a);
            _context44.next = 8;
            return pt(a.deviceGroupKey);
          case 8:
            c = _context44.sent;
            u = {
              USERNAME: e,
              SRP_A: c.A.toString(16),
              DEVICE_KEY: a.deviceKey
            };
            f = {
              ChallengeName: "DEVICE_SRP_AUTH",
              ClientId: d,
              ChallengeResponses: u,
              ClientMetadata: n,
              Session: o
            };
            _context44.next = 13;
            return ue({
              region: x(r)
            }, f);
          case 13:
            _yield$ue = _context44.sent;
            h = _yield$ue.ChallengeParameters;
            g = _yield$ue.Session;
            return _context44.abrupt("return", Kc(e, h, n, g, c, t, s));
          case 17:
          case "end":
            return _context44.stop();
        }
      }, _callee44);
    })();
  });
}
function Kc(a, c, u, f, h, g, E) {
  return l(this, arguments, function (e, t, n, o, s, _ref38, d) {
    let i = _ref38.userPoolId,
      r = _ref38.userPoolClientId;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee45() {
      var z, p, A, P, F, j, le, Z, ee, ae, pe;
      return _regeneratorRuntime().wrap(function _callee45$(_context45) {
        while (1) switch (_context45.prev = _context45.next) {
          case 0:
            _context45.next = 2;
            return d == null ? void 0 : d.getDeviceMetadata(e);
          case 2:
            p = _context45.sent;
            ft(p);
            A = new m(t == null ? void 0 : t.SRP_B, 16);
            P = new m(t == null ? void 0 : t.SALT, 16);
            F = p.deviceKey;
            j = p.deviceGroupKey;
            _context45.next = 10;
            return s.getPasswordAuthenticationKey({
              username: p.deviceKey,
              password: p.randomPassword,
              serverBValue: A,
              salt: P
            });
          case 10:
            le = _context45.sent;
            Z = ts();
            ee = {
              USERNAME: (z = t == null ? void 0 : t.USERNAME) != null ? z : e,
              PASSWORD_CLAIM_SECRET_BLOCK: t == null ? void 0 : t.SECRET_BLOCK,
              TIMESTAMP: Z,
              PASSWORD_CLAIM_SIGNATURE: ns({
                username: F,
                userPoolName: j,
                challengeParameters: t,
                dateNow: Z,
                hkdf: le
              }),
              DEVICE_KEY: F
            };
            ae = W({
              username: e,
              userPoolId: i,
              userPoolClientId: r
            });
            pe = {
              ChallengeName: "DEVICE_PASSWORD_VERIFIER",
              ClientId: r,
              ChallengeResponses: ee,
              Session: o,
              ClientMetadata: n,
              UserContextData: ae
            };
            return _context45.abrupt("return", ue({
              region: x(i)
            }, pe));
          case 16:
          case "end":
            return _context45.stop();
        }
      }, _callee45);
    })();
  });
}
function os(e, t, n, o, s, i, r) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
    var d, a, c, u, f, h, g, E, p, A, P, F, j;
    return _regeneratorRuntime().wrap(function _callee46$(_context46) {
      while (1) switch (_context46.prev = _context46.next) {
        case 0:
          d = i.userPoolId, a = i.userPoolClientId, c = (d == null ? void 0 : d.split("_")[1]) || "", u = new m(t == null ? void 0 : t.SRP_B, 16), f = new m(t == null ? void 0 : t.SALT, 16), h = t == null ? void 0 : t.USER_ID_FOR_SRP;
          if (h) {
            _context46.next = 3;
            break;
          }
          throw new S({
            name: "EmptyUserIdForSRPException",
            message: "USER_ID_FOR_SRP was not found in challengeParameters"
          });
        case 3:
          _context46.next = 5;
          return s.getPasswordAuthenticationKey({
            username: h,
            password: e,
            serverBValue: u,
            salt: f
          });
        case 5:
          g = _context46.sent;
          E = ts();
          p = {
            USERNAME: h,
            PASSWORD_CLAIM_SECRET_BLOCK: t == null ? void 0 : t.SECRET_BLOCK,
            TIMESTAMP: E,
            PASSWORD_CLAIM_SIGNATURE: ns({
              username: h,
              userPoolName: c,
              challengeParameters: t,
              dateNow: E,
              hkdf: g
            })
          };
          _context46.next = 10;
          return r.getDeviceMetadata(h);
        case 10:
          A = _context46.sent;
          A && A.deviceKey && (p.DEVICE_KEY = A.deviceKey);
          P = W({
            username: h,
            userPoolId: d,
            userPoolClientId: a
          });
          F = {
            ChallengeName: "PASSWORD_VERIFIER",
            ChallengeResponses: p,
            ClientMetadata: n,
            Session: o,
            ClientId: a,
            UserContextData: P
          };
          _context46.next = 16;
          return ue({
            region: x(d)
          }, F);
        case 16:
          j = _context46.sent;
          return _context46.abrupt("return", j.ChallengeName === "DEVICE_SRP_AUTH" ? mt({
            username: h,
            config: i,
            clientMetadata: n,
            session: j.Session,
            tokenOrchestrator: r
          }) : j);
        case 18:
        case "end":
          return _context46.stop();
      }
    }, _callee46);
  }));
}
function Ve(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee47() {
    var s, t, n, o, _fe$getState, i, r, _yield$Go, d, a;
    return _regeneratorRuntime().wrap(function _callee47$(_context47) {
      while (1) switch (_context47.prev = _context47.next) {
        case 0:
          t = e.challengeName, n = e.challengeParameters, o = (s = C.getConfig().Auth) == null ? void 0 : s.Cognito;
          _context47.t0 = (I(o), t);
          _context47.next = _context47.t0 === "CUSTOM_CHALLENGE" ? 4 : _context47.t0 === "MFA_SETUP" ? 5 : _context47.t0 === "NEW_PASSWORD_REQUIRED" ? 14 : _context47.t0 === "SELECT_MFA_TYPE" ? 15 : _context47.t0 === "SMS_MFA" ? 16 : _context47.t0 === "SOFTWARE_TOKEN_MFA" ? 17 : 18;
          break;
        case 4:
          return _context47.abrupt("return", {
            isSignedIn: !1,
            nextStep: {
              signInStep: "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE",
              additionalInfo: n
            }
          });
        case 5:
          _fe$getState = fe.getState(), i = _fe$getState.signInSession, r = _fe$getState.username;
          if (Hc(n, "TOTP")) {
            _context47.next = 8;
            break;
          }
          throw new S({
            name: Se.SignInException,
            message: `Cannot initiate MFA setup from available types: ${it(Mt(n.MFAS_CAN_SETUP))}`
          });
        case 8:
          _context47.next = 10;
          return Go({
            region: x(o.userPoolId)
          }, {
            Session: i
          });
        case 10:
          _yield$Go = _context47.sent;
          d = _yield$Go.Session;
          a = _yield$Go.SecretCode;
          return _context47.abrupt("return", (fe.dispatch({
            type: "SET_SIGN_IN_SESSION",
            value: d
          }), {
            isSignedIn: !1,
            nextStep: {
              signInStep: "CONTINUE_SIGN_IN_WITH_TOTP_SETUP",
              totpSetupDetails: ss(a, r)
            }
          }));
        case 14:
          return _context47.abrupt("return", {
            isSignedIn: !1,
            nextStep: {
              signInStep: "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED",
              missingAttributes: Bc(n.requiredAttributes)
            }
          });
        case 15:
          return _context47.abrupt("return", {
            isSignedIn: !1,
            nextStep: {
              signInStep: "CONTINUE_SIGN_IN_WITH_MFA_SELECTION",
              allowedMFATypes: it(Mt(n.MFAS_CAN_CHOOSE))
            }
          });
        case 16:
          return _context47.abrupt("return", {
            isSignedIn: !1,
            nextStep: {
              signInStep: "CONFIRM_SIGN_IN_WITH_SMS_CODE",
              codeDeliveryDetails: {
                deliveryMedium: n.CODE_DELIVERY_DELIVERY_MEDIUM,
                destination: n.CODE_DELIVERY_DESTINATION
              }
            }
          });
        case 17:
          return _context47.abrupt("return", {
            isSignedIn: !1,
            nextStep: {
              signInStep: "CONFIRM_SIGN_IN_WITH_TOTP_CODE"
            }
          });
        case 18:
          throw new S({
            name: Se.SignInException,
            message: `An error occurred during the sign in process. ${t} challengeName returned by the underlying service was not addressed.`
          });
        case 19:
        case "end":
          return _context47.stop();
      }
    }, _callee47);
  }));
}
function ss(e, t) {
  return {
    sharedSecret: e,
    getSetupUri: (n, o) => {
      const s = `otpauth://totp/${n}:${o != null ? o : t}?secret=${e}&issuer=${n}`;
      return new Ie(s);
    }
  };
}
function We(e) {
  if (e === st.PasswordResetRequiredException) return {
    isSignedIn: !1,
    nextStep: {
      signInStep: "RESET_PASSWORD"
    }
  };
  if (e === st.UserNotConfirmedException) return {
    isSignedIn: !1,
    nextStep: {
      signInStep: "CONFIRM_SIGN_UP"
    }
  };
}
function Bc(e) {
  return e ? JSON.parse(e).map(n => n.includes(Ut) ? n.replace(Ut, "") : n) : [];
}
function Vc(e) {
  if (!e) return {};
  const t = {};
  return Object.entries(e).forEach(_ref39 => {
    let _ref40 = _slicedToArray(_ref39, 2),
      n = _ref40[0],
      o = _ref40[1];
    o && (t[`${Ut}${n}`] = o);
  }), t;
}
function Wc(e, t, n, o, s, i, r, d) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee48() {
    var a, c;
    return _regeneratorRuntime().wrap(function _callee48$(_context48) {
      while (1) switch (_context48.prev = _context48.next) {
        case 0:
          a = d == null ? void 0 : d.userAttributes, c = d == null ? void 0 : d.friendlyDeviceName;
          _context48.t0 = t;
          _context48.next = _context48.t0 === "SMS_MFA" ? 4 : _context48.t0 === "SELECT_MFA_TYPE" ? 5 : _context48.t0 === "MFA_SETUP" ? 6 : _context48.t0 === "NEW_PASSWORD_REQUIRED" ? 7 : _context48.t0 === "CUSTOM_CHALLENGE" ? 8 : _context48.t0 === "SOFTWARE_TOKEN_MFA" ? 9 : 10;
          break;
        case 4:
          return _context48.abrupt("return", Uc({
            challengeResponse: o,
            clientMetadata: r,
            session: n,
            username: e,
            config: s
          }));
        case 5:
          return _context48.abrupt("return", bc({
            challengeResponse: o,
            clientMetadata: r,
            session: n,
            username: e,
            config: s
          }));
        case 6:
          return _context48.abrupt("return", Nc({
            challengeResponse: o,
            clientMetadata: r,
            session: n,
            username: e,
            deviceName: c,
            config: s
          }));
        case 7:
          return _context48.abrupt("return", Dc({
            challengeResponse: o,
            clientMetadata: r,
            session: n,
            username: e,
            requiredAttributes: a,
            config: s
          }));
        case 8:
          return _context48.abrupt("return", He(_c, [{
            challengeResponse: o,
            clientMetadata: r,
            session: n,
            username: e,
            config: s,
            tokenOrchestrator: i
          }], e, i));
        case 9:
          return _context48.abrupt("return", Mc({
            challengeResponse: o,
            clientMetadata: r,
            session: n,
            username: e,
            config: s
          }));
        case 10:
          throw new S({
            name: Se.SignInException,
            message: `An error occurred during the sign in process. 
		${t} challengeName returned by the underlying service was not addressed.`
          });
        case 11:
        case "end":
          return _context48.stop();
      }
    }, _callee48);
  }));
}
function qc(e) {
  let t = "SMS_MFA";
  return e === "TOTP" && (t = "SOFTWARE_TOKEN_MFA"), t;
}
function is(e) {
  if (e === "SMS_MFA") return "SMS";
  if (e === "SOFTWARE_TOKEN_MFA") return "TOTP";
}
function it(e) {
  if (e) return e.map(is).filter(Boolean);
}
function Mt(e) {
  return e ? JSON.parse(e) : [];
}
function Hc(e, t) {
  const n = e.MFAS_CAN_SETUP,
    o = it(Mt(n));
  return o ? o.includes(t) : !1;
}
function rs() {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee49() {
    var e;
    return _regeneratorRuntime().wrap(function _callee49$(_context49) {
      while (1) switch (_context49.prev = _context49.next) {
        case 0:
          _context49.prev = 0;
          _context49.next = 3;
          return Ht();
        case 3:
          e = _context49.sent;
          _context49.next = 8;
          break;
        case 6:
          _context49.prev = 6;
          _context49.t0 = _context49["catch"](0);
        case 8:
          if (!(e && e.userId && e.username)) {
            _context49.next = 10;
            break;
          }
          throw new S({
            name: pa,
            message: "There is already a signed in user.",
            recoverySuggestion: "Call signOut before calling signIn again."
          });
        case 10:
        case "end":
          return _context49.stop();
      }
    }, _callee49, null, [[0, 6]]);
  }));
}
function qe(e, t, n) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee50() {
    var o, s, i, r, d, a;
    return _regeneratorRuntime().wrap(function _callee50$(_context50) {
      while (1) switch (_context50.prev = _context50.next) {
        case 0:
          if (t) {
            _context50.next = 2;
            break;
          }
          return _context50.abrupt("return");
        case 2:
          o = e.split("_")[1] || "";
          _context50.next = 5;
          return pt(o);
        case 5:
          s = _context50.sent;
          i = t == null ? void 0 : t.DeviceKey;
          r = t == null ? void 0 : t.DeviceGroupKey;
          _context50.prev = 8;
          _context50.next = 11;
          return s.generateHashDevice(r != null ? r : "", i != null ? i : "");
        case 11:
          _context50.next = 16;
          break;
        case 13:
          _context50.prev = 13;
          _context50.t0 = _context50["catch"](8);
          return _context50.abrupt("return");
        case 16:
          d = {
            Salt: Le.convert(Re(s.getSaltToHashDevices())),
            PasswordVerifier: Le.convert(Re(s.getVerifierDevices()))
          }, a = s.getRandomPassword();
          _context50.prev = 17;
          _context50.t1 = na;
          _context50.t2 = {
            region: x(e)
          };
          _context50.t3 = n;
          _context50.next = 23;
          return Br();
        case 23:
          _context50.t4 = _context50.sent;
          _context50.t5 = t == null ? void 0 : t.DeviceKey;
          _context50.t6 = d;
          _context50.t7 = {
            AccessToken: _context50.t3,
            DeviceName: _context50.t4,
            DeviceKey: _context50.t5,
            DeviceSecretVerifierConfig: _context50.t6
          };
          _context50.next = 29;
          return (0, _context50.t1)(_context50.t2, _context50.t7);
        case 29:
          return _context50.abrupt("return", {
            deviceKey: i,
            deviceGroupKey: r,
            randomPassword: a
          });
        case 32:
          _context50.prev = 32;
          _context50.t8 = _context50["catch"](17);
          return _context50.abrupt("return");
        case 35:
        case "end":
          return _context50.stop();
      }
    }, _callee50, null, [[8, 13], [17, 32]]);
  }));
}
function He(e, t, n, o) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee51() {
    return _regeneratorRuntime().wrap(function _callee51$(_context51) {
      while (1) switch (_context51.prev = _context51.next) {
        case 0:
          _context51.prev = 0;
          _context51.next = 3;
          return e(...t);
        case 3:
          return _context51.abrupt("return", _context51.sent);
        case 6:
          _context51.prev = 6;
          _context51.t0 = _context51["catch"](0);
          if (!(_context51.t0 instanceof S && _context51.t0.name === "ResourceNotFoundException" && _context51.t0.message.includes("Device does not exist."))) {
            _context51.next = 12;
            break;
          }
          _context51.next = 11;
          return o.clearDeviceMetadata(n);
        case 11:
          return _context51.abrupt("return", e(...t));
        case 12:
          throw _context51.t0;
        case 13:
        case "end":
          return _context51.stop();
      }
    }, _callee51, null, [[0, 6]]);
  }));
}
function Et(e) {
  const t = fe.dispatch;
  t({
    type: "SET_USERNAME",
    value: e
  });
}
function yt(e) {
  var n;
  return (n = fe.getState().username) != null ? n : e;
}
const as = o => l(void 0, [o], function (_ref41) {
    let e = _ref41.tokens,
      t = _ref41.authConfig,
      n = _ref41.username;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee52() {
      var g, E, p, s, i, r, d, _yield$Ke2, a, c, u, f, h;
      return _regeneratorRuntime().wrap(function _callee52$(_context52) {
        while (1) switch (_context52.prev = _context52.next) {
          case 0:
            I(t == null ? void 0 : t.Cognito);
            s = x(t.Cognito.userPoolId);
            Xo(e);
            i = e.refreshToken, r = {
              REFRESH_TOKEN: i
            };
            (g = e.deviceMetadata) != null && g.deviceKey && (r.DEVICE_KEY = e.deviceMetadata.deviceKey);
            d = W({
              username: n,
              userPoolId: t.Cognito.userPoolId,
              userPoolClientId: t.Cognito.userPoolClientId
            });
            _context52.next = 8;
            return Ke({
              region: s
            }, {
              ClientId: (E = t == null ? void 0 : t.Cognito) == null ? void 0 : E.userPoolClientId,
              AuthFlow: "REFRESH_TOKEN_AUTH",
              AuthParameters: r,
              UserContextData: d
            });
          case 8:
            _yield$Ke2 = _context52.sent;
            a = _yield$Ke2.AuthenticationResult;
            c = re((p = a == null ? void 0 : a.AccessToken) != null ? p : "");
            u = a != null && a.IdToken ? re(a.IdToken) : void 0;
            f = c.payload.iat;
            if (f) {
              _context52.next = 15;
              break;
            }
            throw new S({
              name: "iatNotFoundException",
              message: "iat not found in access token"
            });
          case 15:
            h = f * 1e3 - /* @__PURE__ */new Date().getTime();
            return _context52.abrupt("return", {
              accessToken: c,
              idToken: u,
              clockDrift: h,
              refreshToken: i,
              username: n
            });
          case 17:
          case "end":
            return _context52.stop();
        }
      }, _callee52);
    })();
  }),
  $c = Kr(as),
  jc = as,
  zc = {
    accessToken: "accessToken",
    idToken: "idToken",
    oidcProvider: "oidcProvider",
    clockDrift: "clockDrift",
    refreshToken: "refreshToken",
    deviceKey: "deviceKey",
    randomPasswordKey: "randomPasswordKey",
    deviceGroupKey: "deviceGroupKey",
    signInDetails: "signInDetails"
  };
var rt;
(function (e) {
  e.InvalidAuthTokens = "InvalidAuthTokens";
})(rt || (rt = {}));
const Gc = {
    [rt.InvalidAuthTokens]: {
      message: "Invalid tokens.",
      recoverySuggestion: "Make sure the tokens are valid."
    }
  },
  Yc = Ao(Gc);
class cs {
  constructor() {
    this.name = "CognitoIdentityServiceProvider";
  }
  getKeyValueStorage() {
    if (!this.keyValueStorage) throw new S({
      name: "KeyValueStorageNotFoundException",
      message: "KeyValueStorage was not found in TokenStore"
    });
    return this.keyValueStorage;
  }
  setKeyValueStorage(t) {
    this.keyValueStorage = t;
  }
  setAuthConfig(t) {
    this.authConfig = t;
  }
  loadTokens() {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee53() {
      var t, n, o, s, i, r, d, a, c, u, f, h, g;
      return _regeneratorRuntime().wrap(function _callee53$(_context53) {
        while (1) switch (_context53.prev = _context53.next) {
          case 0:
            _context53.prev = 0;
            _context53.next = 3;
            return this.getAuthKeys();
          case 3:
            s = _context53.sent;
            _context53.next = 6;
            return this.getKeyValueStorage().getItem(s.accessToken);
          case 6:
            i = _context53.sent;
            if (i) {
              _context53.next = 9;
              break;
            }
            throw new S({
              name: "NoSessionFoundException",
              message: "Auth session was not found. Make sure to call signIn."
            });
          case 9:
            r = re(i);
            _context53.next = 12;
            return this.getKeyValueStorage().getItem(s.idToken);
          case 12:
            d = _context53.sent;
            a = d ? re(d) : void 0;
            _context53.next = 16;
            return this.getKeyValueStorage().getItem(s.refreshToken);
          case 16:
            _context53.t0 = t = _context53.sent;
            if (!(_context53.t0 != null)) {
              _context53.next = 21;
              break;
            }
            _context53.t1 = t;
            _context53.next = 22;
            break;
          case 21:
            _context53.t1 = void 0;
          case 22:
            c = _context53.t1;
            _context53.next = 25;
            return this.getKeyValueStorage().getItem(s.clockDrift);
          case 25:
            _context53.t2 = n = _context53.sent;
            if (!(_context53.t2 != null)) {
              _context53.next = 30;
              break;
            }
            _context53.t3 = n;
            _context53.next = 31;
            break;
          case 30:
            _context53.t3 = "0";
          case 31:
            u = _context53.t3;
            f = Number.parseInt(u);
            _context53.next = 35;
            return this.getKeyValueStorage().getItem(s.signInDetails);
          case 35:
            h = _context53.sent;
            _context53.t4 = r;
            _context53.t5 = a;
            _context53.t6 = c;
            _context53.next = 41;
            return this.getDeviceMetadata();
          case 41:
            _context53.t7 = o = _context53.sent;
            if (!(_context53.t7 != null)) {
              _context53.next = 46;
              break;
            }
            _context53.t8 = o;
            _context53.next = 47;
            break;
          case 46:
            _context53.t8 = void 0;
          case 47:
            _context53.t9 = _context53.t8;
            _context53.t10 = f;
            _context53.next = 51;
            return this.getLastAuthUser();
          case 51:
            _context53.t11 = _context53.sent;
            g = {
              accessToken: _context53.t4,
              idToken: _context53.t5,
              refreshToken: _context53.t6,
              deviceMetadata: _context53.t9,
              clockDrift: _context53.t10,
              username: _context53.t11
            };
            return _context53.abrupt("return", (h && (g.signInDetails = JSON.parse(h)), g));
          case 56:
            _context53.prev = 56;
            _context53.t12 = _context53["catch"](0);
            return _context53.abrupt("return", null);
          case 59:
          case "end":
            return _context53.stop();
        }
      }, _callee53, this, [[0, 56]]);
    }));
  }
  storeTokens(t) {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee54() {
      var n, o;
      return _regeneratorRuntime().wrap(function _callee54$(_context54) {
        while (1) switch (_context54.prev = _context54.next) {
          case 0:
            Yc(t !== void 0, rt.InvalidAuthTokens);
            _context54.next = 3;
            return this.clearTokens();
          case 3:
            n = t.username;
            _context54.next = 6;
            return this.getKeyValueStorage().setItem(this.getLastAuthUserKey(), n);
          case 6:
            _context54.next = 8;
            return this.getAuthKeys();
          case 8:
            o = _context54.sent;
            _context54.next = 11;
            return this.getKeyValueStorage().setItem(o.accessToken, t.accessToken.toString());
          case 11:
            _context54.t0 = t.idToken;
            if (!_context54.t0) {
              _context54.next = 15;
              break;
            }
            _context54.next = 15;
            return this.getKeyValueStorage().setItem(o.idToken, t.idToken.toString());
          case 15:
            _context54.t1 = t.refreshToken;
            if (!_context54.t1) {
              _context54.next = 19;
              break;
            }
            _context54.next = 19;
            return this.getKeyValueStorage().setItem(o.refreshToken, t.refreshToken);
          case 19:
            _context54.t2 = t.deviceMetadata;
            if (!_context54.t2) {
              _context54.next = 31;
              break;
            }
            _context54.t3 = t.deviceMetadata.deviceKey;
            if (!_context54.t3) {
              _context54.next = 25;
              break;
            }
            _context54.next = 25;
            return this.getKeyValueStorage().setItem(o.deviceKey, t.deviceMetadata.deviceKey);
          case 25:
            _context54.t4 = t.deviceMetadata.deviceGroupKey;
            if (!_context54.t4) {
              _context54.next = 29;
              break;
            }
            _context54.next = 29;
            return this.getKeyValueStorage().setItem(o.deviceGroupKey, t.deviceMetadata.deviceGroupKey);
          case 29:
            _context54.next = 31;
            return this.getKeyValueStorage().setItem(o.randomPasswordKey, t.deviceMetadata.randomPassword);
          case 31:
            _context54.t5 = t.signInDetails;
            if (!_context54.t5) {
              _context54.next = 35;
              break;
            }
            _context54.next = 35;
            return this.getKeyValueStorage().setItem(o.signInDetails, JSON.stringify(t.signInDetails));
          case 35:
            _context54.next = 37;
            return this.getKeyValueStorage().setItem(o.clockDrift, `${t.clockDrift}`);
          case 37:
          case "end":
            return _context54.stop();
        }
      }, _callee54, this);
    }));
  }
  clearTokens() {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee55() {
      var t;
      return _regeneratorRuntime().wrap(function _callee55$(_context55) {
        while (1) switch (_context55.prev = _context55.next) {
          case 0:
            _context55.next = 2;
            return this.getAuthKeys();
          case 2:
            t = _context55.sent;
            _context55.next = 5;
            return Promise.all([this.getKeyValueStorage().removeItem(t.accessToken), this.getKeyValueStorage().removeItem(t.idToken), this.getKeyValueStorage().removeItem(t.clockDrift), this.getKeyValueStorage().removeItem(t.refreshToken), this.getKeyValueStorage().removeItem(t.signInDetails), this.getKeyValueStorage().removeItem(this.getLastAuthUserKey())]);
          case 5:
          case "end":
            return _context55.stop();
        }
      }, _callee55, this);
    }));
  }
  getDeviceMetadata(t) {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee56() {
      var n, o, s, i;
      return _regeneratorRuntime().wrap(function _callee56$(_context56) {
        while (1) switch (_context56.prev = _context56.next) {
          case 0:
            _context56.next = 2;
            return this.getAuthKeys(t);
          case 2:
            n = _context56.sent;
            _context56.next = 5;
            return this.getKeyValueStorage().getItem(n.deviceKey);
          case 5:
            o = _context56.sent;
            _context56.next = 8;
            return this.getKeyValueStorage().getItem(n.deviceGroupKey);
          case 8:
            s = _context56.sent;
            _context56.next = 11;
            return this.getKeyValueStorage().getItem(n.randomPasswordKey);
          case 11:
            i = _context56.sent;
            return _context56.abrupt("return", i && s && o ? {
              deviceKey: o,
              deviceGroupKey: s,
              randomPassword: i
            } : null);
          case 13:
          case "end":
            return _context56.stop();
        }
      }, _callee56, this);
    }));
  }
  clearDeviceMetadata(t) {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee57() {
      var n;
      return _regeneratorRuntime().wrap(function _callee57$(_context57) {
        while (1) switch (_context57.prev = _context57.next) {
          case 0:
            _context57.next = 2;
            return this.getAuthKeys(t);
          case 2:
            n = _context57.sent;
            _context57.next = 5;
            return Promise.all([this.getKeyValueStorage().removeItem(n.deviceKey), this.getKeyValueStorage().removeItem(n.deviceGroupKey), this.getKeyValueStorage().removeItem(n.randomPasswordKey)]);
          case 5:
          case "end":
            return _context57.stop();
        }
      }, _callee57, this);
    }));
  }
  getAuthKeys(t) {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee58() {
      var o, n;
      return _regeneratorRuntime().wrap(function _callee58$(_context58) {
        while (1) switch (_context58.prev = _context58.next) {
          case 0:
            I((o = this.authConfig) == null ? void 0 : o.Cognito);
            if (!(t != null)) {
              _context58.next = 5;
              break;
            }
            _context58.t0 = t;
            _context58.next = 8;
            break;
          case 5:
            _context58.next = 7;
            return this.getLastAuthUser();
          case 7:
            _context58.t0 = _context58.sent;
          case 8:
            n = _context58.t0;
            return _context58.abrupt("return", Jc(this.name, `${this.authConfig.Cognito.userPoolClientId}.${n}`));
          case 10:
          case "end":
            return _context58.stop();
        }
      }, _callee58, this);
    }));
  }
  getLastAuthUserKey() {
    var n;
    I((n = this.authConfig) == null ? void 0 : n.Cognito);
    const t = this.authConfig.Cognito.userPoolClientId;
    return `${this.name}.${t}.LastAuthUser`;
  }
  getLastAuthUser() {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee59() {
      var n;
      return _regeneratorRuntime().wrap(function _callee59$(_context59) {
        while (1) switch (_context59.prev = _context59.next) {
          case 0:
            _context59.next = 2;
            return this.getKeyValueStorage().getItem(this.getLastAuthUserKey());
          case 2:
            _context59.t0 = n = _context59.sent;
            if (!(_context59.t0 != null)) {
              _context59.next = 7;
              break;
            }
            _context59.t1 = n;
            _context59.next = 8;
            break;
          case 7:
            _context59.t1 = "username";
          case 8:
            return _context59.abrupt("return", _context59.t1);
          case 9:
          case "end":
            return _context59.stop();
        }
      }, _callee59, this);
    }));
  }
}
const Jc = (e, t) => Jt(zc)(`${e}`, t);
function Jt(e) {
  const t = Object.values(y({}, e));
  return (n, o) => t.reduce((s, i) => R(y({}, s), {
    [i]: `${n}.${o}.${i}`
  }), {});
}
const Eo = "amplify-signin-with-hostedUI",
  te = "CognitoIdentityServiceProvider";
class ds {
  constructor(t) {
    this.keyValueStorage = t;
  }
  clearOAuthInflightData() {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee60() {
      var t;
      return _regeneratorRuntime().wrap(function _callee60$(_context60) {
        while (1) switch (_context60.prev = _context60.next) {
          case 0:
            I(this.cognitoConfig);
            t = ne(te, this.cognitoConfig.userPoolClientId);
            _context60.next = 4;
            return Promise.all([this.keyValueStorage.removeItem(t.inflightOAuth), this.keyValueStorage.removeItem(t.oauthPKCE), this.keyValueStorage.removeItem(t.oauthState)]);
          case 4:
          case "end":
            return _context60.stop();
        }
      }, _callee60, this);
    }));
  }
  clearOAuthData() {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee61() {
      var t;
      return _regeneratorRuntime().wrap(function _callee61$(_context61) {
        while (1) switch (_context61.prev = _context61.next) {
          case 0:
            I(this.cognitoConfig);
            t = ne(te, this.cognitoConfig.userPoolClientId);
            _context61.next = 4;
            return this.clearOAuthInflightData();
          case 4:
            _context61.next = 6;
            return this.keyValueStorage.removeItem(Eo);
          case 6:
            return _context61.abrupt("return", this.keyValueStorage.removeItem(t.oauthSignIn));
          case 7:
          case "end":
            return _context61.stop();
        }
      }, _callee61, this);
    }));
  }
  loadOAuthState() {
    I(this.cognitoConfig);
    const t = ne(te, this.cognitoConfig.userPoolClientId);
    return this.keyValueStorage.getItem(t.oauthState);
  }
  storeOAuthState(t) {
    I(this.cognitoConfig);
    const n = ne(te, this.cognitoConfig.userPoolClientId);
    return this.keyValueStorage.setItem(n.oauthState, t);
  }
  loadPKCE() {
    I(this.cognitoConfig);
    const t = ne(te, this.cognitoConfig.userPoolClientId);
    return this.keyValueStorage.getItem(t.oauthPKCE);
  }
  storePKCE(t) {
    I(this.cognitoConfig);
    const n = ne(te, this.cognitoConfig.userPoolClientId);
    return this.keyValueStorage.setItem(n.oauthPKCE, t);
  }
  setAuthConfig(t) {
    this.cognitoConfig = t;
  }
  loadOAuthInFlight() {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee62() {
      var t;
      return _regeneratorRuntime().wrap(function _callee62$(_context62) {
        while (1) switch (_context62.prev = _context62.next) {
          case 0:
            I(this.cognitoConfig);
            t = ne(te, this.cognitoConfig.userPoolClientId);
            _context62.next = 4;
            return this.keyValueStorage.getItem(t.inflightOAuth);
          case 4:
            _context62.t0 = _context62.sent;
            return _context62.abrupt("return", _context62.t0 === "true");
          case 6:
          case "end":
            return _context62.stop();
        }
      }, _callee62, this);
    }));
  }
  storeOAuthInFlight(t) {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee63() {
      var n;
      return _regeneratorRuntime().wrap(function _callee63$(_context63) {
        while (1) switch (_context63.prev = _context63.next) {
          case 0:
            I(this.cognitoConfig);
            n = ne(te, this.cognitoConfig.userPoolClientId);
            _context63.next = 4;
            return this.keyValueStorage.setItem(n.inflightOAuth, `${t}`);
          case 4:
          case "end":
            return _context63.stop();
        }
      }, _callee63, this);
    }));
  }
  loadOAuthSignIn() {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee64() {
      var i, r, t, n, _ref42, _ref43, o, s;
      return _regeneratorRuntime().wrap(function _callee64$(_context64) {
        while (1) switch (_context64.prev = _context64.next) {
          case 0:
            I(this.cognitoConfig);
            t = ne(te, this.cognitoConfig.userPoolClientId);
            _context64.next = 4;
            return this.keyValueStorage.getItem(Eo);
          case 4:
            n = _context64.sent;
            _context64.next = 7;
            return this.keyValueStorage.getItem(t.oauthSignIn);
          case 7:
            _context64.t0 = i = _context64.sent;
            if (!(_context64.t0 == null)) {
              _context64.next = 12;
              break;
            }
            _context64.t1 = void 0;
            _context64.next = 13;
            break;
          case 12:
            _context64.t1 = i.split(",");
          case 13:
            _context64.t2 = r = _context64.t1;
            if (!(_context64.t2 != null)) {
              _context64.next = 18;
              break;
            }
            _context64.t3 = r;
            _context64.next = 19;
            break;
          case 18:
            _context64.t3 = [];
          case 19:
            _ref42 = _context64.t3;
            _ref43 = _slicedToArray(_ref42, 2);
            o = _ref43[0];
            s = _ref43[1];
            return _context64.abrupt("return", {
              isOAuthSignIn: o === "true" || n === "true",
              preferPrivateSession: s === "true"
            });
          case 24:
          case "end":
            return _context64.stop();
        }
      }, _callee64, this);
    }));
  }
  storeOAuthSignIn(t) {
    let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee65() {
      var o;
      return _regeneratorRuntime().wrap(function _callee65$(_context65) {
        while (1) switch (_context65.prev = _context65.next) {
          case 0:
            I(this.cognitoConfig);
            o = ne(te, this.cognitoConfig.userPoolClientId);
            _context65.next = 4;
            return this.keyValueStorage.setItem(o.oauthSignIn, `${t},${n}`);
          case 4:
          case "end":
            return _context65.stop();
        }
      }, _callee65, this);
    }));
  }
}
const ne = (e, t) => Jt(Ra)(e, t),
  $ = new ds(ve),
  Dt = [],
  Xc = e => {
    Dt.push(e);
  },
  us = () => {
    var e;
    for (; Dt.length;) (e = Dt.pop()) == null || e();
  };
class ls {
  constructor() {
    this.waitForInflightOAuth = Kt() ? () => l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee66() {
      return _regeneratorRuntime().wrap(function _callee66$(_context66) {
        while (1) switch (_context66.prev = _context66.next) {
          case 0:
            _context66.next = 2;
            return $.loadOAuthInFlight();
          case 2:
            if (!_context66.sent) {
              _context66.next = 4;
              break;
            }
            return _context66.abrupt("return", this.inflightPromise ? this.inflightPromise : (this.inflightPromise = new Promise((t, n) => {
              Xc(t);
            }), this.inflightPromise));
          case 4:
          case "end":
            return _context66.stop();
        }
      }, _callee66, this);
    })) : () => l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee67() {
      return _regeneratorRuntime().wrap(function _callee67$(_context67) {
        while (1) switch (_context67.prev = _context67.next) {
          case 0:
          case "end":
            return _context67.stop();
        }
      }, _callee67);
    }));
  }
  setAuthConfig(t) {
    $.setAuthConfig(t.Cognito), this.authConfig = t;
  }
  setTokenRefresher(t) {
    this.tokenRefresher = t;
  }
  setAuthTokenStore(t) {
    this.tokenStore = t;
  }
  getTokenStore() {
    if (!this.tokenStore) throw new S({
      name: "EmptyTokenStoreException",
      message: "TokenStore not set"
    });
    return this.tokenStore;
  }
  getTokenRefresher() {
    if (!this.tokenRefresher) throw new S({
      name: "EmptyTokenRefresherException",
      message: "TokenRefresher not set"
    });
    return this.tokenRefresher;
  }
  getTokens(t) {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee68() {
      var r, d, a, c, u, f, h, g, E, n, o, s, i;
      return _regeneratorRuntime().wrap(function _callee68$(_context68) {
        while (1) switch (_context68.prev = _context68.next) {
          case 0:
            _context68.prev = 0;
            I((r = this.authConfig) == null ? void 0 : r.Cognito);
            _context68.next = 7;
            break;
          case 4:
            _context68.prev = 4;
            _context68.t0 = _context68["catch"](0);
            return _context68.abrupt("return", null);
          case 7:
            _context68.next = 9;
            return this.waitForInflightOAuth();
          case 9:
            this.inflightPromise = void 0;
            _context68.next = 12;
            return this.getTokenStore().loadTokens();
          case 12:
            n = _context68.sent;
            _context68.next = 15;
            return this.getTokenStore().getLastAuthUser();
          case 15:
            o = _context68.sent;
            if (!(n === null)) {
              _context68.next = 18;
              break;
            }
            return _context68.abrupt("return", null);
          case 18:
            s = !!(n != null && n.idToken) && _n({
              expiresAt: ((c = (a = (d = n.idToken) == null ? void 0 : d.payload) == null ? void 0 : a.exp) != null ? c : 0) * 1e3,
              clockDrift: (u = n.clockDrift) != null ? u : 0
            }), i = _n({
              expiresAt: ((g = (h = (f = n.accessToken) == null ? void 0 : f.payload) == null ? void 0 : h.exp) != null ? g : 0) * 1e3,
              clockDrift: (E = n.clockDrift) != null ? E : 0
            });
            _context68.t1 = t != null && t.forceRefresh || s || i;
            if (!_context68.t1) {
              _context68.next = 25;
              break;
            }
            _context68.next = 23;
            return this.refreshTokens({
              tokens: n,
              username: o
            });
          case 23:
            n = _context68.sent;
            _context68.t1 = n === null;
          case 25:
            if (!_context68.t1) {
              _context68.next = 29;
              break;
            }
            _context68.t2 = null;
            _context68.next = 30;
            break;
          case 29:
            _context68.t2 = {
              accessToken: n == null ? void 0 : n.accessToken,
              idToken: n == null ? void 0 : n.idToken,
              signInDetails: n == null ? void 0 : n.signInDetails
            };
          case 30:
            return _context68.abrupt("return", _context68.t2);
          case 31:
          case "end":
            return _context68.stop();
        }
      }, _callee68, this, [[0, 4]]);
    }));
  }
  refreshTokens(o) {
    return l(this, arguments, function (_ref44) {
      var _this3 = this;
      let t = _ref44.tokens,
        n = _ref44.username;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee69() {
        var s, i;
        return _regeneratorRuntime().wrap(function _callee69$(_context69) {
          while (1) switch (_context69.prev = _context69.next) {
            case 0:
              _context69.prev = 0;
              s = t.signInDetails;
              _context69.next = 4;
              return _this3.getTokenRefresher()({
                tokens: t,
                authConfig: _this3.authConfig,
                username: n
              });
            case 4:
              i = _context69.sent;
              i.signInDetails = s;
              _context69.next = 8;
              return _this3.setTokens({
                tokens: i
              });
            case 8:
              ie.dispatch("auth", {
                event: "tokenRefresh"
              }, "Auth", se);
              return _context69.abrupt("return", i);
            case 12:
              _context69.prev = 12;
              _context69.t0 = _context69["catch"](0);
              return _context69.abrupt("return", _this3.handleErrors(_context69.t0));
            case 15:
            case "end":
              return _context69.stop();
          }
        }, _callee69, null, [[0, 12]]);
      })();
    });
  }
  handleErrors(t) {
    if (ge(t), t.message !== "Network error" && this.clearTokens(), ie.dispatch("auth", {
      event: "tokenRefresh_failure",
      data: {
        error: t
      }
    }, "Auth", se), t.name.startsWith("NotAuthorizedException")) return null;
    throw t;
  }
  setTokens(n) {
    return l(this, arguments, function (_ref45) {
      var _this4 = this;
      let t = _ref45.tokens;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee70() {
        return _regeneratorRuntime().wrap(function _callee70$(_context70) {
          while (1) switch (_context70.prev = _context70.next) {
            case 0:
              return _context70.abrupt("return", _this4.getTokenStore().storeTokens(t));
            case 1:
            case "end":
              return _context70.stop();
          }
        }, _callee70);
      })();
    });
  }
  clearTokens() {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee71() {
      return _regeneratorRuntime().wrap(function _callee71$(_context71) {
        while (1) switch (_context71.prev = _context71.next) {
          case 0:
            return _context71.abrupt("return", this.getTokenStore().clearTokens());
          case 1:
          case "end":
            return _context71.stop();
        }
      }, _callee71, this);
    }));
  }
  getDeviceMetadata(t) {
    return this.getTokenStore().getDeviceMetadata(t);
  }
  clearDeviceMetadata(t) {
    return this.getTokenStore().clearDeviceMetadata(t);
  }
}
class Qc {
  constructor() {
    this.authTokenStore = new cs(), this.authTokenStore.setKeyValueStorage(ve), this.tokenOrchestrator = new ls(), this.tokenOrchestrator.setAuthTokenStore(this.authTokenStore), this.tokenOrchestrator.setTokenRefresher($c);
  }
  getTokens() {
    let _ref46 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        forceRefresh: !1
      },
      t = _ref46.forceRefresh;
    return this.tokenOrchestrator.getTokens({
      forceRefresh: t
    });
  }
  setKeyValueStorage(t) {
    this.authTokenStore.setKeyValueStorage(t);
  }
  setAuthConfig(t) {
    this.authTokenStore.setAuthConfig(t), this.tokenOrchestrator.setAuthConfig(t);
  }
}
const Ae = new Qc(),
  B = Ae.tokenOrchestrator;
function Ce(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee72() {
    var t, n, o, s, i, r, d, a;
    return _regeneratorRuntime().wrap(function _callee72$(_context72) {
      while (1) switch (_context72.prev = _context72.next) {
        case 0:
          if (!e.AccessToken) {
            _context72.next = 9;
            break;
          }
          t = re(e.AccessToken), n = (t.payload.iat || 0) * 1e3, o = /* @__PURE__ */new Date().getTime(), s = n > 0 ? n - o : 0;
          e.RefreshToken && (r = e.RefreshToken), e.IdToken && (i = re(e.IdToken)), e != null && e.NewDeviceMetadata && (d = e.NewDeviceMetadata);
          a = {
            accessToken: t,
            idToken: i,
            refreshToken: r,
            clockDrift: s,
            deviceMetadata: d,
            username: e.username
          };
          e != null && e.signInDetails && (a.signInDetails = e.signInDetails);
          _context72.next = 7;
          return B.setTokens({
            tokens: a
          });
        case 7:
          _context72.next = 10;
          break;
        case 9:
          throw new J({
            message: "Invalid tokens",
            name: "InvalidTokens",
            recoverySuggestion: "Check Cognito UserPool settings"
          });
        case 10:
        case "end":
          return _context72.stop();
      }
    }, _callee72);
  }));
}
const Zc = "Unable to get user session following successful sign-in.",
  Ue = () => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee73() {
    return _regeneratorRuntime().wrap(function _callee73$(_context73) {
      while (1) switch (_context73.prev = _context73.next) {
        case 0:
          _context73.prev = 0;
          _context73.t0 = ie;
          _context73.next = 4;
          return Ht();
        case 4:
          _context73.t1 = _context73.sent;
          _context73.t2 = {
            event: "signedIn",
            data: _context73.t1
          };
          _context73.t3 = se;
          _context73.t0.dispatch.call(_context73.t0, "auth", _context73.t2, "Auth", _context73.t3);
          _context73.next = 13;
          break;
        case 10:
          _context73.prev = 10;
          _context73.t4 = _context73["catch"](0);
          throw _context73.t4.name === ht ? new S({
            name: Aa,
            message: Zc,
            recoverySuggestion: "This most likely is due to auth tokens not being persisted. If you are using cookie store, please ensure cookies can be correctly set from your server."
          }) : _context73.t4;
        case 13:
        case "end":
          return _context73.stop();
      }
    }, _callee73, null, [[0, 10]]);
  }));
function ed(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee74() {
    var d, t, n, o, s, i, r, _yield$He, a, c, u, f, h;
    return _regeneratorRuntime().wrap(function _callee74$(_context74) {
      while (1) switch (_context74.prev = _context74.next) {
        case 0:
          t = (d = C.getConfig().Auth) == null ? void 0 : d.Cognito;
          I(t);
          n = e.username, o = e.password, s = e.options, i = {
            loginId: n,
            authFlowType: "CUSTOM_WITHOUT_SRP"
          }, r = s == null ? void 0 : s.clientMetadata;
          b(!!n, w.EmptySignInUsername), b(!o, w.CustomAuthSignInPassword);
          _context74.prev = 4;
          _context74.next = 7;
          return He(kc, [n, r, t, B], n, B);
        case 7:
          _yield$He = _context74.sent;
          a = _yield$He.ChallengeName;
          c = _yield$He.ChallengeParameters;
          u = _yield$He.AuthenticationResult;
          f = _yield$He.Session;
          h = yt(n);
          Be({
            signInSession: f,
            username: h,
            challengeName: a,
            signInDetails: i
          });
          if (!u) {
            _context74.next = 32;
            break;
          }
          de();
          _context74.t1 = Ce;
          _context74.t2 = R;
          _context74.t3 = y({
            username: h
          }, u);
          _context74.next = 21;
          return qe(t.userPoolId, u.NewDeviceMetadata, u.AccessToken);
        case 21:
          _context74.t4 = _context74.sent;
          _context74.t5 = i;
          _context74.t6 = {
            NewDeviceMetadata: _context74.t4,
            signInDetails: _context74.t5
          };
          _context74.t7 = (0, _context74.t2)(_context74.t3, _context74.t6);
          _context74.next = 27;
          return (0, _context74.t1)(_context74.t7);
        case 27:
          _context74.next = 29;
          return Ue();
        case 29:
          _context74.t0 = {
            isSignedIn: !0,
            nextStep: {
              signInStep: "DONE"
            }
          };
          _context74.next = 33;
          break;
        case 32:
          _context74.t0 = Ve({
            challengeName: a,
            challengeParameters: c
          });
        case 33:
          return _context74.abrupt("return", _context74.t0);
        case 36:
          _context74.prev = 36;
          _context74.t8 = _context74["catch"](4);
          de(), ge(_context74.t8);
          c = We(_context74.t8.name);
          if (!c) {
            _context74.next = 42;
            break;
          }
          return _context74.abrupt("return", c);
        case 42:
          throw _context74.t8;
        case 43:
        case "end":
          return _context74.stop();
      }
    }, _callee74, null, [[4, 36]]);
  }));
}
function td(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee75() {
    var d, t, n, o, s, i, r, _yield$Lc, a, c, u, f, h;
    return _regeneratorRuntime().wrap(function _callee75$(_context75) {
      while (1) switch (_context75.prev = _context75.next) {
        case 0:
          t = e.username, n = e.password, o = e.options, s = {
            loginId: t,
            authFlowType: "CUSTOM_WITH_SRP"
          }, i = (d = C.getConfig().Auth) == null ? void 0 : d.Cognito;
          I(i);
          r = o == null ? void 0 : o.clientMetadata;
          b(!!t, w.EmptySignInUsername), b(!!n, w.EmptySignInPassword);
          _context75.prev = 4;
          _context75.next = 7;
          return Lc(t, n, r, i, B);
        case 7:
          _yield$Lc = _context75.sent;
          a = _yield$Lc.ChallengeName;
          c = _yield$Lc.ChallengeParameters;
          u = _yield$Lc.AuthenticationResult;
          f = _yield$Lc.Session;
          h = yt(t);
          Be({
            signInSession: f,
            username: h,
            challengeName: a,
            signInDetails: s
          });
          if (!u) {
            _context75.next = 32;
            break;
          }
          _context75.t1 = Ce;
          _context75.t2 = R;
          _context75.t3 = y({
            username: h
          }, u);
          _context75.next = 20;
          return qe(i.userPoolId, u.NewDeviceMetadata, u.AccessToken);
        case 20:
          _context75.t4 = _context75.sent;
          _context75.t5 = s;
          _context75.t6 = {
            NewDeviceMetadata: _context75.t4,
            signInDetails: _context75.t5
          };
          _context75.t7 = (0, _context75.t2)(_context75.t3, _context75.t6);
          _context75.next = 26;
          return (0, _context75.t1)(_context75.t7);
        case 26:
          de();
          _context75.next = 29;
          return Ue();
        case 29:
          _context75.t0 = {
            isSignedIn: !0,
            nextStep: {
              signInStep: "DONE"
            }
          };
          _context75.next = 33;
          break;
        case 32:
          _context75.t0 = Ve({
            challengeName: a,
            challengeParameters: c
          });
        case 33:
          return _context75.abrupt("return", _context75.t0);
        case 36:
          _context75.prev = 36;
          _context75.t8 = _context75["catch"](4);
          de(), ge(_context75.t8);
          c = We(_context75.t8.name);
          if (!c) {
            _context75.next = 42;
            break;
          }
          return _context75.abrupt("return", c);
        case 42:
          throw _context75.t8;
        case 43:
        case "end":
          return _context75.stop();
      }
    }, _callee75, null, [[4, 36]]);
  }));
}
function yo(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee76() {
    var r, d, t, n, o, s, i, _yield$Oc, a, c, u, f, h;
    return _regeneratorRuntime().wrap(function _callee76$(_context76) {
      while (1) switch (_context76.prev = _context76.next) {
        case 0:
          t = e.username, n = e.password, o = (r = C.getConfig().Auth) == null ? void 0 : r.Cognito, s = {
            loginId: t,
            authFlowType: "USER_SRP_AUTH"
          };
          I(o);
          i = (d = e.options) == null ? void 0 : d.clientMetadata;
          b(!!t, w.EmptySignInUsername), b(!!n, w.EmptySignInPassword);
          _context76.prev = 4;
          _context76.next = 7;
          return Oc(t, n, i, o, B);
        case 7:
          _yield$Oc = _context76.sent;
          a = _yield$Oc.ChallengeName;
          c = _yield$Oc.ChallengeParameters;
          u = _yield$Oc.AuthenticationResult;
          f = _yield$Oc.Session;
          h = yt(t);
          Be({
            signInSession: f,
            username: h,
            challengeName: a,
            signInDetails: s
          });
          if (!u) {
            _context76.next = 32;
            break;
          }
          de();
          _context76.t1 = Ce;
          _context76.t2 = R;
          _context76.t3 = y({
            username: h
          }, u);
          _context76.next = 21;
          return qe(o.userPoolId, u.NewDeviceMetadata, u.AccessToken);
        case 21:
          _context76.t4 = _context76.sent;
          _context76.t5 = s;
          _context76.t6 = {
            NewDeviceMetadata: _context76.t4,
            signInDetails: _context76.t5
          };
          _context76.t7 = (0, _context76.t2)(_context76.t3, _context76.t6);
          _context76.next = 27;
          return (0, _context76.t1)(_context76.t7);
        case 27:
          _context76.next = 29;
          return Ue();
        case 29:
          _context76.t0 = {
            isSignedIn: !0,
            nextStep: {
              signInStep: "DONE"
            }
          };
          _context76.next = 33;
          break;
        case 32:
          _context76.t0 = Ve({
            challengeName: a,
            challengeParameters: c
          });
        case 33:
          return _context76.abrupt("return", _context76.t0);
        case 36:
          _context76.prev = 36;
          _context76.t8 = _context76["catch"](4);
          de(), ge(_context76.t8);
          c = We(_context76.t8.name);
          if (!c) {
            _context76.next = 42;
            break;
          }
          return _context76.abrupt("return", c);
        case 42:
          throw _context76.t8;
        case 43:
        case "end":
          return _context76.stop();
      }
    }, _callee76, null, [[4, 36]]);
  }));
}
function nd(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee77() {
    var d, t, n, o, s, i, r, _yield$He2, a, c, u, f, h;
    return _regeneratorRuntime().wrap(function _callee77$(_context77) {
      while (1) switch (_context77.prev = _context77.next) {
        case 0:
          t = e.username, n = e.password, o = e.options, s = (d = C.getConfig().Auth) == null ? void 0 : d.Cognito, i = {
            loginId: t,
            authFlowType: "USER_PASSWORD_AUTH"
          };
          I(s);
          r = o == null ? void 0 : o.clientMetadata;
          b(!!t, w.EmptySignInUsername), b(!!n, w.EmptySignInPassword);
          _context77.prev = 4;
          _context77.next = 7;
          return He(Fc, [t, n, r, s, B], t, B);
        case 7:
          _yield$He2 = _context77.sent;
          a = _yield$He2.ChallengeName;
          c = _yield$He2.ChallengeParameters;
          u = _yield$He2.AuthenticationResult;
          f = _yield$He2.Session;
          h = yt(t);
          Be({
            signInSession: f,
            username: h,
            challengeName: a,
            signInDetails: i
          });
          if (!u) {
            _context77.next = 33;
            break;
          }
          _context77.t1 = Ce;
          _context77.t2 = R;
          _context77.t3 = y({}, u);
          _context77.t4 = h;
          _context77.next = 21;
          return qe(s.userPoolId, u.NewDeviceMetadata, u.AccessToken);
        case 21:
          _context77.t5 = _context77.sent;
          _context77.t6 = i;
          _context77.t7 = {
            username: _context77.t4,
            NewDeviceMetadata: _context77.t5,
            signInDetails: _context77.t6
          };
          _context77.t8 = (0, _context77.t2)(_context77.t3, _context77.t7);
          _context77.next = 27;
          return (0, _context77.t1)(_context77.t8);
        case 27:
          de();
          _context77.next = 30;
          return Ue();
        case 30:
          _context77.t0 = {
            isSignedIn: !0,
            nextStep: {
              signInStep: "DONE"
            }
          };
          _context77.next = 34;
          break;
        case 33:
          _context77.t0 = Ve({
            challengeName: a,
            challengeParameters: c
          });
        case 34:
          return _context77.abrupt("return", _context77.t0);
        case 37:
          _context77.prev = 37;
          _context77.t9 = _context77["catch"](4);
          de(), ge(_context77.t9);
          c = We(_context77.t9.name);
          if (!c) {
            _context77.next = 43;
            break;
          }
          return _context77.abrupt("return", c);
        case 43:
          throw _context77.t9;
        case 44:
        case "end":
          return _context77.stop();
      }
    }, _callee77, null, [[4, 37]]);
  }));
}
function It(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee78() {
    var n, t;
    return _regeneratorRuntime().wrap(function _callee78$(_context78) {
      while (1) switch (_context78.prev = _context78.next) {
        case 0:
          t = (n = e.options) == null ? void 0 : n.authFlowType;
          _context78.next = 3;
          return rs();
        case 3:
          _context78.t0 = t;
          _context78.next = _context78.t0 === "USER_SRP_AUTH" ? 6 : _context78.t0 === "USER_PASSWORD_AUTH" ? 7 : _context78.t0 === "CUSTOM_WITHOUT_SRP" ? 8 : _context78.t0 === "CUSTOM_WITH_SRP" ? 9 : 10;
          break;
        case 6:
          return _context78.abrupt("return", yo(e));
        case 7:
          return _context78.abrupt("return", nd(e));
        case 8:
          return _context78.abrupt("return", ed(e));
        case 9:
          return _context78.abrupt("return", td(e));
        case 10:
          return _context78.abrupt("return", yo(e));
        case 11:
        case "end":
          return _context78.stop();
      }
    }, _callee78);
  }));
}
const hs = () => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee79() {
  return _regeneratorRuntime().wrap(function _callee79$(_context79) {
    while (1) switch (_context79.prev = _context79.next) {
      case 0:
        throw new S({
          name: Jo,
          message: "The autoSignIn flow has not started, or has been cancelled/completed.",
          recoverySuggestion: "Please try to use the signIn API or log out before starting a new autoSignIn flow."
        });
      case 1:
      case "end":
        return _context79.stop();
    }
  }, _callee79);
}));
let Xt = hs;
function Ft(e) {
  Xt = e;
}
function xe() {
  Xt = hs;
}
const fs = 3 * 60 * 1e3;
function od(e) {
  const t = nt.listen("auth-internal", s => l(this, [s], function (_ref47) {
      let o = _ref47.payload;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee80() {
        var i;
        return _regeneratorRuntime().wrap(function _callee80$(_context80) {
          while (1) switch (_context80.prev = _context80.next) {
            case 0:
              switch (o.event) {
                case "confirmSignUp":
                  {
                    i = o.data;
                    i != null && i.isSignUpComplete && (nt.dispatch("auth-internal", {
                      event: "autoSignIn"
                    }), Ft(ys(e)), t());
                  }
              }
            case 1:
            case "end":
              return _context80.stop();
          }
        }, _callee80);
      })();
    })),
    n = setTimeout(() => {
      t(), Te(!1), clearTimeout(n), xe();
    }, fs);
}
function gs(e, t) {
  let n;
  return o => {
    n || e(...o), clearTimeout(n), n = setTimeout(() => {
      n = void 0;
    }, t);
  };
}
function sd(e, t, n) {
  const o = Date.now(),
    s = setInterval(() => l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee81() {
      var d;
      return _regeneratorRuntime().wrap(function _callee81$(_context81) {
        while (1) switch (_context81.prev = _context81.next) {
          case 0:
            if (!(Date.now() - o > fs)) {
              _context81.next = 4;
              break;
            }
            clearInterval(s), Te(!1), n(new S({
              name: Jo,
              message: "The account was not confirmed on time.",
              recoverySuggestion: "Try to verify your account by clicking the link sent your email or phone and then login manually."
            })), xe();
            _context81.next = 14;
            break;
          case 4:
            _context81.prev = 4;
            _context81.next = 7;
            return It(e);
          case 7:
            d = _context81.sent;
            d.nextStep.signInStep !== "CONFIRM_SIGN_UP" && (t(d), clearInterval(s), Te(!1), xe());
            _context81.next = 14;
            break;
          case 11:
            _context81.prev = 11;
            _context81.t0 = _context81["catch"](4);
            clearInterval(s), Te(!1), n(_context81.t0), xe();
          case 14:
          case "end":
            return _context81.stop();
        }
      }, _callee81, null, [[4, 11]]);
    })), 5e3);
}
const id = gs(sd, 300),
  rd = gs(dd, 300);
let ps = !1,
  ms;
function Es(e) {
  ms = e;
}
function ad(e) {
  return ms === e;
}
function De() {
  return ps;
}
function Te(e) {
  e === !1 && Es(void 0), ps = e;
}
function Ge(e) {
  return !!e.UserConfirmed;
}
function cd(e) {
  return () => l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee82() {
    return _regeneratorRuntime().wrap(function _callee82$(_context82) {
      while (1) switch (_context82.prev = _context82.next) {
        case 0:
          return _context82.abrupt("return", new Promise((t, n) => {
            id([e, t, n]);
          }));
        case 1:
        case "end":
          return _context82.stop();
      }
    }, _callee82);
  }));
}
function dd(e, t, n) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee83() {
    var o;
    return _regeneratorRuntime().wrap(function _callee83$(_context83) {
      while (1) switch (_context83.prev = _context83.next) {
        case 0:
          _context83.prev = 0;
          _context83.next = 3;
          return It(e);
        case 3:
          o = _context83.sent;
          t(o), xe();
          _context83.next = 10;
          break;
        case 7:
          _context83.prev = 7;
          _context83.t0 = _context83["catch"](0);
          n(_context83.t0), xe();
        case 10:
        case "end":
          return _context83.stop();
      }
    }, _callee83, null, [[0, 7]]);
  }));
}
function ys(e) {
  return () => l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee84() {
    return _regeneratorRuntime().wrap(function _callee84$(_context84) {
      while (1) switch (_context84.prev = _context84.next) {
        case 0:
          return _context84.abrupt("return", new Promise((t, n) => {
            rd([e, t, n]);
          }));
        case 1:
        case "end":
          return _context84.stop();
      }
    }, _callee84);
  }));
}
const ud = ys;
function Is(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee85() {
    var A, P, F, t, n, o, s, i, _ref48, r, d, a, c, u, f, h, g, E, p;
    return _regeneratorRuntime().wrap(function _callee85$(_context85) {
      while (1) switch (_context85.prev = _context85.next) {
        case 0:
          t = e.username, n = e.password, o = e.options, s = (A = C.getConfig().Auth) == null ? void 0 : A.Cognito, i = (P = s == null ? void 0 : s.signUpVerificationMethod) != null ? P : "code", _ref48 = (F = e.options) != null ? F : {}, r = _ref48.clientMetadata, d = _ref48.validationData, a = _ref48.autoSignIn;
          I(s), b(!!t, w.EmptySignUpUsername), b(!!n, w.EmptySignUpPassword);
          c = typeof a != "boolean" ? a : void 0, u = {
            username: t,
            options: c
          };
          (c == null ? void 0 : c.authFlowType) !== "CUSTOM_WITHOUT_SRP" && (u.password = n), (c || a === !0) && (Es(t), Te(!0));
          f = s.userPoolId;
          h = s.userPoolClientId;
          _context85.next = 8;
          return Yr({
            region: x(f),
            userAgentValue: v(T.SignUp)
          }, {
            Username: t,
            Password: n,
            UserAttributes: (o == null ? void 0 : o.userAttributes) && _t(o == null ? void 0 : o.userAttributes),
            ClientMetadata: r,
            ValidationData: d && _t(d),
            ClientId: h,
            UserContextData: W({
              username: t,
              userPoolId: f,
              userPoolClientId: h
            })
          });
        case 8:
          g = _context85.sent;
          E = g.UserSub;
          p = g.CodeDeliveryDetails;
          if (!(Ge(g) && De())) {
            _context85.next = 13;
            break;
          }
          return _context85.abrupt("return", (Ft(ud(u)), {
            isSignUpComplete: !0,
            nextStep: {
              signUpStep: "COMPLETE_AUTO_SIGN_IN"
            },
            userId: E
          }));
        case 13:
          if (!(Ge(g) && !De())) {
            _context85.next = 15;
            break;
          }
          return _context85.abrupt("return", {
            isSignUpComplete: !0,
            nextStep: {
              signUpStep: "DONE"
            },
            userId: E
          });
        case 15:
          if (!(!Ge(g) && De() && i === "code")) {
            _context85.next = 19;
            break;
          }
          od(u);
          _context85.next = 21;
          break;
        case 19:
          if (!(!Ge(g) && De() && i === "link")) {
            _context85.next = 21;
            break;
          }
          return _context85.abrupt("return", (Ft(cd(u)), {
            isSignUpComplete: !1,
            nextStep: {
              signUpStep: "COMPLETE_AUTO_SIGN_IN",
              codeDeliveryDetails: {
                deliveryMedium: p == null ? void 0 : p.DeliveryMedium,
                destination: p == null ? void 0 : p.Destination,
                attributeName: p == null ? void 0 : p.AttributeName
              }
            },
            userId: E
          }));
        case 21:
          return _context85.abrupt("return", {
            isSignUpComplete: !1,
            nextStep: {
              signUpStep: "CONFIRM_SIGN_UP",
              codeDeliveryDetails: {
                deliveryMedium: p == null ? void 0 : p.DeliveryMedium,
                destination: p == null ? void 0 : p.Destination,
                attributeName: p == null ? void 0 : p.AttributeName
              }
            },
            userId: E
          });
        case 22:
        case "end":
          return _context85.stop();
      }
    }, _callee85);
  }));
}
function Ss(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee86() {
    var c, u, t, n, o, s, i, r, a;
    return _regeneratorRuntime().wrap(function _callee86$(_context86) {
      while (1) switch (_context86.prev = _context86.next) {
        case 0:
          t = e.username;
          b(!!t, w.EmptyResetPasswordUsername);
          n = (c = C.getConfig().Auth) == null ? void 0 : c.Cognito;
          I(n);
          o = n.userPoolClientId;
          s = n.userPoolId;
          i = (u = e.options) == null ? void 0 : u.clientMetadata;
          r = W({
            username: t,
            userPoolId: s,
            userPoolClientId: o
          });
          _context86.next = 10;
          return Xr({
            region: x(n.userPoolId),
            userAgentValue: v(T.ResetPassword)
          }, {
            Username: t,
            ClientMetadata: i,
            ClientId: n.userPoolClientId,
            UserContextData: r
          });
        case 10:
          a = _context86.sent.CodeDeliveryDetails;
          return _context86.abrupt("return", {
            isPasswordReset: !1,
            nextStep: {
              resetPasswordStep: "CONFIRM_RESET_PASSWORD_WITH_CODE",
              codeDeliveryDetails: {
                deliveryMedium: a == null ? void 0 : a.DeliveryMedium,
                destination: a == null ? void 0 : a.Destination,
                attributeName: a == null ? void 0 : a.AttributeName
              }
            }
          });
        case 12:
        case "end":
          return _context86.stop();
      }
    }, _callee86);
  }));
}
function ws(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee87() {
    var c, u, t, n, o, s, i, r, d, a;
    return _regeneratorRuntime().wrap(function _callee87$(_context87) {
      while (1) switch (_context87.prev = _context87.next) {
        case 0:
          t = (c = C.getConfig().Auth) == null ? void 0 : c.Cognito;
          I(t);
          n = t.userPoolClientId, o = t.userPoolId, s = e.username, i = e.newPassword;
          b(!!s, w.EmptyConfirmResetPasswordUsername), b(!!i, w.EmptyConfirmResetPasswordNewPassword);
          r = e.confirmationCode;
          b(!!r, w.EmptyConfirmResetPasswordConfirmationCode);
          d = (u = e.options) == null ? void 0 : u.clientMetadata, a = W({
            username: s,
            userPoolId: o,
            userPoolClientId: n
          });
          _context87.next = 9;
          return Qr({
            region: x(t.userPoolId),
            userAgentValue: v(T.ConfirmResetPassword)
          }, {
            Username: s,
            ConfirmationCode: r,
            Password: i,
            ClientMetadata: d,
            ClientId: t.userPoolClientId,
            UserContextData: a
          });
        case 9:
        case "end":
          return _context87.stop();
      }
    }, _callee87);
  }));
}
function Cs(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee88() {
    var f, h, t, n, o, s, i, r, _yield$Zr, d, _y, a, c, u;
    return _regeneratorRuntime().wrap(function _callee88$(_context88) {
      while (1) switch (_context88.prev = _context88.next) {
        case 0:
          t = e.username;
          b(!!t, w.EmptySignUpUsername);
          n = (f = C.getConfig().Auth) == null ? void 0 : f.Cognito;
          I(n);
          o = n.userPoolClientId;
          s = n.userPoolId;
          i = (h = e.options) == null ? void 0 : h.clientMetadata;
          r = W({
            username: t,
            userPoolId: s,
            userPoolClientId: o
          });
          _context88.next = 10;
          return Zr({
            region: x(n.userPoolId),
            userAgentValue: v(T.ResendSignUpCode)
          }, {
            Username: t,
            ClientMetadata: i,
            ClientId: n.userPoolClientId,
            UserContextData: r
          });
        case 10:
          _yield$Zr = _context88.sent;
          d = _yield$Zr.CodeDeliveryDetails;
          _y = y({}, d);
          a = _y.DeliveryMedium;
          c = _y.AttributeName;
          u = _y.Destination;
          return _context88.abrupt("return", {
            destination: u,
            deliveryMedium: a,
            attributeName: c || void 0
          });
        case 17:
        case "end":
          return _context88.stop();
      }
    }, _callee88);
  }));
}
function As(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee89() {
    var c, t, n, o, s, i, r, d, a;
    return _regeneratorRuntime().wrap(function _callee89$(_context89) {
      while (1) switch (_context89.prev = _context89.next) {
        case 0:
          t = e.username, n = e.confirmationCode, o = e.options, s = (c = C.getConfig().Auth) == null ? void 0 : c.Cognito;
          I(s);
          i = s.userPoolId, r = s.userPoolClientId, d = o == null ? void 0 : o.clientMetadata;
          b(!!t, w.EmptyConfirmSignUpUsername), b(!!n, w.EmptyConfirmSignUpCode);
          a = W({
            username: t,
            userPoolId: i,
            userPoolClientId: r
          });
          _context89.next = 7;
          return Jr({
            region: x(s.userPoolId),
            userAgentValue: v(T.ConfirmSignUp)
          }, {
            Username: t,
            ConfirmationCode: n,
            ClientMetadata: d,
            ForceAliasCreation: o == null ? void 0 : o.forceAliasCreation,
            ClientId: s.userPoolClientId,
            UserContextData: a
          });
        case 7:
          return _context89.abrupt("return", new Promise((u, f) => {
            try {
              const h = {
                isSignUpComplete: !0,
                nextStep: {
                  signUpStep: "DONE"
                }
              };
              if (!De() || !ad(t)) {
                u(h);
                return;
              }
              const g = nt.listen("auth-internal", _ref49 => {
                let E = _ref49.payload;
                switch (E.event) {
                  case "autoSignIn":
                    u({
                      isSignUpComplete: !0,
                      nextStep: {
                        signUpStep: "COMPLETE_AUTO_SIGN_IN"
                      }
                    }), Te(!1), g();
                }
              });
              nt.dispatch("auth-internal", {
                event: "confirmSignUp",
                data: h
              });
            } catch (h) {
              f(h);
            }
          }));
        case 8:
        case "end":
          return _context89.stop();
      }
    }, _callee89);
  }));
}
function ld(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee90() {
    var c, t, n, _fe$getState2, o, s, i, r, d, a, _yield$Wc, u, f, h, g;
    return _regeneratorRuntime().wrap(function _callee90$(_context90) {
      while (1) switch (_context90.prev = _context90.next) {
        case 0:
          t = e.challengeResponse, n = e.options, _fe$getState2 = fe.getState(), o = _fe$getState2.username, s = _fe$getState2.challengeName, i = _fe$getState2.signInSession, r = _fe$getState2.signInDetails, d = (c = C.getConfig().Auth) == null ? void 0 : c.Cognito;
          I(d);
          a = n == null ? void 0 : n.clientMetadata;
          if (!(b(!!t, w.EmptyChallengeResponse), !o || !s || !i)) {
            _context90.next = 5;
            break;
          }
          throw new S({
            name: Se.SignInException,
            message: `
			An error occurred during the sign in process. 
			
			This most likely occurred due to:
			1. signIn was not called before confirmSignIn.
			2. signIn threw an exception.
			3. page was refreshed during the sign in flow.
			`,
            recoverySuggestion: "Make sure a successful call to signIn is made before calling confirmSignInand that the page is not refreshed until the sign in process is done."
          });
        case 5:
          _context90.prev = 5;
          _context90.next = 8;
          return Wc(o, s, i, t, d, B, a, n);
        case 8:
          _yield$Wc = _context90.sent;
          u = _yield$Wc.Session;
          f = _yield$Wc.ChallengeName;
          h = _yield$Wc.AuthenticationResult;
          g = _yield$Wc.ChallengeParameters;
          Be({
            signInSession: u,
            username: o,
            challengeName: f,
            signInDetails: r
          });
          if (!h) {
            _context90.next = 32;
            break;
          }
          de();
          _context90.t1 = Ce;
          _context90.t2 = R;
          _context90.t3 = y({
            username: o
          }, h);
          _context90.next = 21;
          return qe(d.userPoolId, h.NewDeviceMetadata, h.AccessToken);
        case 21:
          _context90.t4 = _context90.sent;
          _context90.t5 = r;
          _context90.t6 = {
            NewDeviceMetadata: _context90.t4,
            signInDetails: _context90.t5
          };
          _context90.t7 = (0, _context90.t2)(_context90.t3, _context90.t6);
          _context90.next = 27;
          return (0, _context90.t1)(_context90.t7);
        case 27:
          _context90.next = 29;
          return Ue();
        case 29:
          _context90.t0 = {
            isSignedIn: !0,
            nextStep: {
              signInStep: "DONE"
            }
          };
          _context90.next = 33;
          break;
        case 32:
          _context90.t0 = Ve({
            challengeName: f,
            challengeParameters: g
          });
        case 33:
          return _context90.abrupt("return", _context90.t0);
        case 36:
          _context90.prev = 36;
          _context90.t8 = _context90["catch"](5);
          ge(_context90.t8);
          f = We(_context90.t8.name);
          if (!f) {
            _context90.next = 42;
            break;
          }
          return _context90.abrupt("return", f);
        case 42:
          throw _context90.t8;
        case 43:
        case "end":
          return _context90.stop();
      }
    }, _callee90, null, [[5, 36]]);
  }));
}
function hd(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee91() {
    var i, t, n, o, _yield$L, s;
    return _regeneratorRuntime().wrap(function _callee91$(_context91) {
      while (1) switch (_context91.prev = _context91.next) {
        case 0:
          t = e.sms, n = e.totp, o = (i = C.getConfig().Auth) == null ? void 0 : i.Cognito;
          I(o);
          _context91.next = 4;
          return L({
            forceRefresh: !1
          });
        case 4:
          _yield$L = _context91.sent;
          s = _yield$L.tokens;
          q(s);
          _context91.next = 9;
          return ea({
            region: x(o.userPoolId),
            userAgentValue: v(T.UpdateMFAPreference)
          }, {
            AccessToken: s.accessToken.toString(),
            SMSMfaSettings: Io(t),
            SoftwareTokenMfaSettings: Io(n)
          });
        case 9:
        case "end":
          return _context91.stop();
      }
    }, _callee91);
  }));
}
function Io(e) {
  if (e === "DISABLED") return {
    Enabled: !1
  };
  if (e === "PREFERRED") return {
    Enabled: !0,
    PreferredMfa: !0
  };
  if (e === "ENABLED") return {
    Enabled: !0
  };
  if (e === "NOT_PREFERRED") return {
    Enabled: !0,
    PreferredMfa: !1
  };
}
function fd() {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee92() {
    var s, e, _yield$L2, t, _yield$Yo, n, o;
    return _regeneratorRuntime().wrap(function _callee92$(_context92) {
      while (1) switch (_context92.prev = _context92.next) {
        case 0:
          e = (s = C.getConfig().Auth) == null ? void 0 : s.Cognito;
          I(e);
          _context92.next = 4;
          return L({
            forceRefresh: !1
          });
        case 4:
          _yield$L2 = _context92.sent;
          t = _yield$L2.tokens;
          q(t);
          _context92.next = 9;
          return Yo({
            region: x(e.userPoolId),
            userAgentValue: v(T.FetchMFAPreference)
          }, {
            AccessToken: t.accessToken.toString()
          });
        case 9:
          _yield$Yo = _context92.sent;
          n = _yield$Yo.PreferredMfaSetting;
          o = _yield$Yo.UserMFASettingList;
          return _context92.abrupt("return", {
            preferred: is(n),
            enabled: it(o)
          });
        case 13:
        case "end":
          return _context92.stop();
      }
    }, _callee92);
  }));
}
function gd(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee93() {
    var i, t, n, o, _yield$L3, s;
    return _regeneratorRuntime().wrap(function _callee93$(_context93) {
      while (1) switch (_context93.prev = _context93.next) {
        case 0:
          t = (i = C.getConfig().Auth) == null ? void 0 : i.Cognito;
          I(t);
          n = e.code, o = e.options;
          b(!!n, w.EmptyVerifyTOTPSetupCode);
          _context93.next = 6;
          return L({
            forceRefresh: !1
          });
        case 6:
          _yield$L3 = _context93.sent;
          s = _yield$L3.tokens;
          q(s);
          _context93.next = 11;
          return zo({
            region: x(t.userPoolId),
            userAgentValue: v(T.VerifyTOTPSetup)
          }, {
            AccessToken: s.accessToken.toString(),
            UserCode: n,
            FriendlyDeviceName: o == null ? void 0 : o.friendlyDeviceName
          });
        case 11:
        case "end":
          return _context93.stop();
      }
    }, _callee93);
  }));
}
function pd(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee94() {
    var i, t, n, o, _yield$L4, s;
    return _regeneratorRuntime().wrap(function _callee94$(_context94) {
      while (1) switch (_context94.prev = _context94.next) {
        case 0:
          t = (i = C.getConfig().Auth) == null ? void 0 : i.Cognito;
          I(t);
          n = e.oldPassword, o = e.newPassword;
          b(!!n, w.EmptyUpdatePassword), b(!!o, w.EmptyUpdatePassword);
          _context94.next = 6;
          return L({
            forceRefresh: !1
          });
        case 6:
          _yield$L4 = _context94.sent;
          s = _yield$L4.tokens;
          q(s);
          _context94.next = 11;
          return ta({
            region: x(t.userPoolId),
            userAgentValue: v(T.UpdatePassword)
          }, {
            AccessToken: s.accessToken.toString(),
            PreviousPassword: n,
            ProposedPassword: o
          });
        case 11:
        case "end":
          return _context94.stop();
      }
    }, _callee94);
  }));
}
function md() {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee95() {
    var s, i, r, e, _yield$L5, t, n, _yield$Go2, o;
    return _regeneratorRuntime().wrap(function _callee95$(_context95) {
      while (1) switch (_context95.prev = _context95.next) {
        case 0:
          e = (s = C.getConfig().Auth) == null ? void 0 : s.Cognito;
          I(e);
          _context95.next = 4;
          return L({
            forceRefresh: !1
          });
        case 4:
          _yield$L5 = _context95.sent;
          t = _yield$L5.tokens;
          q(t);
          n = (r = (i = t.idToken) == null ? void 0 : i.payload["cognito:username"]) != null ? r : "";
          _context95.next = 10;
          return Go({
            region: x(e.userPoolId),
            userAgentValue: v(T.SetUpTOTP)
          }, {
            AccessToken: t.accessToken.toString()
          });
        case 10:
          _yield$Go2 = _context95.sent;
          o = _yield$Go2.SecretCode;
          if (o) {
            _context95.next = 14;
            break;
          }
          throw new S({
            name: ga,
            message: "Failed to set up TOTP."
          });
        case 14:
          return _context95.abrupt("return", ss(o, JSON.stringify(n)));
        case 15:
        case "end":
          return _context95.stop();
      }
    }, _callee95);
  }));
}
const xs = e => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee96() {
  var d, t, n, o, s, _yield$L6, i, _yield$aa, r;
  return _regeneratorRuntime().wrap(function _callee96$(_context96) {
    while (1) switch (_context96.prev = _context96.next) {
      case 0:
        t = e.userAttributes, n = e.options, o = (d = C.getConfig().Auth) == null ? void 0 : d.Cognito, s = n == null ? void 0 : n.clientMetadata;
        I(o);
        _context96.next = 4;
        return L({
          forceRefresh: !1
        });
      case 4:
        _yield$L6 = _context96.sent;
        i = _yield$L6.tokens;
        q(i);
        _context96.next = 9;
        return aa({
          region: x(o.userPoolId),
          userAgentValue: v(T.UpdateUserAttributes)
        }, {
          AccessToken: i.accessToken.toString(),
          ClientMetadata: s,
          UserAttributes: _t(t)
        });
      case 9:
        _yield$aa = _context96.sent;
        r = _yield$aa.CodeDeliveryDetailsList;
        return _context96.abrupt("return", y(y({}, Ed(t)), yd(r)));
      case 12:
      case "end":
        return _context96.stop();
    }
  }, _callee96);
}));
function Ed(e) {
  var n;
  const t = {};
  return (n = Object.keys(e)) == null || n.forEach(o => {
    t[o] = {
      isUpdated: !0,
      nextStep: {
        updateAttributeStep: "DONE"
      }
    };
  }), t;
}
function yd(e) {
  const t = {};
  return e == null || e.forEach(n => {
    const o = n.AttributeName,
      s = n.DeliveryMedium,
      i = n.Destination;
    o && (t[o] = {
      isUpdated: !1,
      nextStep: {
        updateAttributeStep: "CONFIRM_ATTRIBUTE_WITH_CODE",
        codeDeliveryDetails: {
          attributeName: o,
          deliveryMedium: s,
          destination: i
        }
      }
    });
  }), t;
}
const Id = e => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee97() {
  var _e$userAttribute, t, n, o, s;
  return _regeneratorRuntime().wrap(function _callee97$(_context97) {
    while (1) switch (_context97.prev = _context97.next) {
      case 0:
        _e$userAttribute = e.userAttribute;
        t = _e$userAttribute.attributeKey;
        n = _e$userAttribute.value;
        o = e.options;
        _context97.next = 6;
        return xs({
          userAttributes: {
            [t]: n
          },
          options: o
        });
      case 6:
        s = _context97.sent;
        return _context97.abrupt("return", Object.values(s)[0]);
      case 8:
      case "end":
        return _context97.stop();
    }
  }, _callee97);
}));
function Sd(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee98() {
    var i, t, n, o, _yield$L7, s;
    return _regeneratorRuntime().wrap(function _callee98$(_context98) {
      while (1) switch (_context98.prev = _context98.next) {
        case 0:
          t = (i = C.getConfig().Auth) == null ? void 0 : i.Cognito;
          I(t);
          n = e.confirmationCode, o = e.userAttributeKey;
          b(!!n, w.EmptyConfirmUserAttributeCode);
          _context98.next = 6;
          return L({
            forceRefresh: !1
          });
        case 6:
          _yield$L7 = _context98.sent;
          s = _yield$L7.tokens;
          q(s);
          _context98.next = 11;
          return ca({
            region: x(t.userPoolId),
            userAgentValue: v(T.ConfirmUserAttribute)
          }, {
            AccessToken: s.accessToken.toString(),
            AttributeName: o,
            Code: n
          });
        case 11:
        case "end":
          return _context98.stop();
      }
    }, _callee98);
  }));
}
new Y("AuthError");
const wd = {
    oauthSignInError: {
      message: K.OAUTH_ERROR,
      log: "Make sure Cognito Hosted UI has been configured correctly"
    },
    noConfig: {
      message: K.DEFAULT_MSG,
      log: `
            Error: Amplify has not been configured correctly.
            This error is typically caused by one of the following scenarios:

            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point
                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information
            
            2. There might be multiple conflicting versions of amplify packages in your node_modules.
				Refer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)
        `
    },
    missingAuthConfig: {
      message: K.DEFAULT_MSG,
      log: `
            Error: Amplify has not been configured correctly. 
            The configuration object is missing required auth properties.
            This error is typically caused by one of the following scenarios:

            1. Did you run \`amplify push\` after adding auth via \`amplify add auth\`?
                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information

            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.
        `
    },
    emptyUsername: {
      message: K.EMPTY_USERNAME
    },
    // TODO: should include a list of valid sign-in types
    invalidUsername: {
      message: K.INVALID_USERNAME
    },
    emptyPassword: {
      message: K.EMPTY_PASSWORD
    },
    emptyCode: {
      message: K.EMPTY_CODE
    },
    signUpError: {
      message: K.SIGN_UP_ERROR,
      log: "The first parameter should either be non-null string or object"
    },
    noMFA: {
      message: K.NO_MFA
    },
    invalidMFA: {
      message: K.INVALID_MFA
    },
    emptyChallengeResponse: {
      message: K.EMPTY_CHALLENGE
    },
    noUserSession: {
      message: K.NO_USER_SESSION
    },
    deviceConfig: {
      message: K.DEVICE_CONFIG
    },
    networkError: {
      message: K.NETWORK_ERROR
    },
    autoSignInError: {
      message: K.AUTOSIGNIN_ERROR
    },
    default: {
      message: K.DEFAULT_MSG
    }
  },
  we = (e, t) => new S({
    message: e != null ? e : "An error has occurred during the oauth process.",
    name: Se.OAuthSignInError,
    recoverySuggestion: t != null ? t : wd.oauthSignInError.log
  });
var Ot;
(function (e) {
  e.NoConfig = "noConfig", e.MissingAuthConfig = "missingAuthConfig", e.EmptyUsername = "emptyUsername", e.InvalidUsername = "invalidUsername", e.EmptyPassword = "emptyPassword", e.EmptyCode = "emptyCode", e.SignUpError = "signUpError", e.NoMFA = "noMFA", e.InvalidMFA = "invalidMFA", e.EmptyChallengeResponse = "emptyChallengeResponse", e.NoUserSession = "noUserSession", e.Default = "default", e.DeviceConfig = "deviceConfig", e.NetworkError = "networkError", e.AutoSignInError = "autoSignInError", e.OAuthSignInError = "oauthSignInError";
})(Ot || (Ot = {}));
const Cd = "`signInWithRedirect` has been canceled.",
  Ad = "An error occurred while validating the state.",
  xd = "Try to initiate an OAuth flow from Amplify",
  Ts = e => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee99() {
    var t, n;
    return _regeneratorRuntime().wrap(function _callee99$(_context99) {
      while (1) switch (_context99.prev = _context99.next) {
        case 0:
          _context99.next = 2;
          return $.loadOAuthState();
        case 2:
          t = _context99.sent;
          n = e === t ? t : void 0;
          if (n) {
            _context99.next = 6;
            break;
          }
          throw new S({
            name: Ot.OAuthSignInError,
            message: e === null ? Cd : Ad,
            recoverySuggestion: e === null ? void 0 : xd
          });
        case 6:
          return _context99.abrupt("return", n);
        case 7:
        case "end":
          return _context99.stop();
      }
    }, _callee99);
  })),
  vs = d => l(void 0, [d], function (_ref50) {
    let e = _ref50.currentUrl,
      t = _ref50.userAgentValue,
      n = _ref50.clientId,
      o = _ref50.redirectUri,
      s = _ref50.responseType,
      i = _ref50.domain,
      r = _ref50.preferPrivateSession;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee100() {
      var a, c, u;
      return _regeneratorRuntime().wrap(function _callee100$(_context100) {
        while (1) switch (_context100.prev = _context100.next) {
          case 0:
            a = new Ie(e), c = a.searchParams.get("error"), u = a.searchParams.get("error_description");
            if (!c) {
              _context100.next = 3;
              break;
            }
            throw we(u != null ? u : c);
          case 3:
            return _context100.abrupt("return", s === "code" ? Td({
              currentUrl: e,
              userAgentValue: t,
              clientId: n,
              redirectUri: o,
              domain: i,
              preferPrivateSession: r
            }) : vd({
              currentUrl: e,
              redirectUri: o,
              preferPrivateSession: r
            }));
          case 4:
          case "end":
            return _context100.stop();
        }
      }, _callee100);
    })();
  }),
  Td = r => l(void 0, [r], function (_ref51) {
    let e = _ref51.currentUrl,
      t = _ref51.userAgentValue,
      n = _ref51.clientId,
      o = _ref51.redirectUri,
      s = _ref51.domain,
      i = _ref51.preferPrivateSession;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee101() {
      var ae, d, a, c, u, f, h, g, E, _yield$yield$fetch$js, p, A, P, F, j, le, Z, ee;
      return _regeneratorRuntime().wrap(function _callee101$(_context101) {
        while (1) switch (_context101.prev = _context101.next) {
          case 0:
            d = new Ie(e), a = d.searchParams.get("code"), c = d.searchParams.get("state");
            if (!(!a || !c)) {
              _context101.next = 3;
              break;
            }
            throw we("User cancelled OAuth flow.");
          case 3:
            _context101.next = 5;
            return Ts(c);
          case 5:
            u = _context101.sent;
            f = "https://" + s + "/oauth2/token";
            _context101.next = 9;
            return $.loadPKCE();
          case 9:
            h = _context101.sent;
            g = y({
              grant_type: "authorization_code",
              code: a,
              client_id: n,
              redirect_uri: o
            }, h ? {
              code_verifier: h
            } : {});
            E = Object.entries(g).map(_ref52 => {
              let _ref53 = _slicedToArray(_ref52, 2),
                pe = _ref53[0],
                z = _ref53[1];
              return `${encodeURIComponent(pe)}=${encodeURIComponent(z)}`;
            }).join("&");
            _context101.next = 14;
            return fetch(f, {
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                [Zs]: t
              },
              body: E
            });
          case 14:
            _context101.next = 16;
            return _context101.sent.json();
          case 16:
            _yield$yield$fetch$js = _context101.sent;
            p = _yield$yield$fetch$js.access_token;
            A = _yield$yield$fetch$js.refresh_token;
            P = _yield$yield$fetch$js.id_token;
            F = _yield$yield$fetch$js.error;
            j = _yield$yield$fetch$js.error_message;
            le = _yield$yield$fetch$js.token_type;
            Z = _yield$yield$fetch$js.expires_in;
            if (!F) {
              _context101.next = 26;
              break;
            }
            throw we(j != null ? j : F);
          case 26:
            ee = (ae = p && re(p).payload.username) != null ? ae : "username";
            _context101.next = 29;
            return Ce({
              username: ee,
              AccessToken: p,
              IdToken: P,
              RefreshToken: A,
              TokenType: le,
              ExpiresIn: Z
            });
          case 29:
            return _context101.abrupt("return", Rs({
              redirectUri: o,
              state: u,
              preferPrivateSession: i
            }));
          case 30:
          case "end":
            return _context101.stop();
        }
      }, _callee101);
    })();
  }),
  vd = o => l(void 0, [o], function (_ref54) {
    let e = _ref54.currentUrl,
      t = _ref54.redirectUri,
      n = _ref54.preferPrivateSession;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee102() {
      var E, p, s, _substring$split$map$, i, r, d, a, c, u, f, h, g;
      return _regeneratorRuntime().wrap(function _callee102$(_context102) {
        while (1) switch (_context102.prev = _context102.next) {
          case 0:
            s = new Ie(e), _substring$split$map$ = ((E = s.hash) != null ? E : "#").substring(1).split("&").map(A => A.split("=")).reduce((A, _ref55) => {
              let _ref56 = _slicedToArray(_ref55, 2),
                P = _ref56[0],
                F = _ref56[1];
              return R(y({}, A), {
                [P]: F
              });
            }, {
              id_token: void 0,
              access_token: void 0,
              state: void 0,
              token_type: void 0,
              expires_in: void 0,
              error_description: void 0,
              error: void 0
            }), i = _substring$split$map$.id_token, r = _substring$split$map$.access_token, d = _substring$split$map$.state, a = _substring$split$map$.token_type, c = _substring$split$map$.expires_in, u = _substring$split$map$.error_description, f = _substring$split$map$.error;
            if (!f) {
              _context102.next = 3;
              break;
            }
            throw we(u != null ? u : f);
          case 3:
            if (r) {
              _context102.next = 5;
              break;
            }
            throw we("No access token returned from OAuth flow.");
          case 5:
            _context102.next = 7;
            return Ts(d);
          case 7:
            h = _context102.sent;
            g = (p = r && re(r).payload.username) != null ? p : "username";
            _context102.next = 11;
            return Ce({
              username: g,
              AccessToken: r,
              IdToken: i,
              TokenType: a,
              ExpiresIn: c
            });
          case 11:
            return _context102.abrupt("return", Rs({
              redirectUri: t,
              state: h,
              preferPrivateSession: n
            }));
          case 12:
          case "end":
            return _context102.stop();
        }
      }, _callee102);
    })();
  }),
  Rs = o => l(void 0, [o], function (_ref57) {
    let e = _ref57.redirectUri,
      t = _ref57.state,
      n = _ref57.preferPrivateSession;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee103() {
      return _regeneratorRuntime().wrap(function _callee103$(_context103) {
        while (1) switch (_context103.prev = _context103.next) {
          case 0:
            _context103.next = 2;
            return $.clearOAuthData();
          case 2:
            _context103.next = 4;
            return $.storeOAuthSignIn(!0, n);
          case 4:
            us();
            Rd(t) && ie.dispatch("auth", {
              event: "customOAuthState",
              data: kr(Pd(t))
            }, "Auth", se);
            ie.dispatch("auth", {
              event: "signInWithRedirect"
            }, "Auth", se);
            _context103.next = 9;
            return Ue();
          case 9:
            _d(e);
          case 10:
          case "end":
            return _context103.stop();
        }
      }, _callee103);
    })();
  }),
  Rd = e => /-/.test(e),
  Pd = e => e.split("-").splice(1).join("-"),
  _d = e => {
    typeof window != "undefined" && typeof window.history != "undefined" && window.history.replaceState(window.history.state, "", e);
  };
function Qt(e) {
  var o, s;
  const t = (o = e == null ? void 0 : e.find(Nd)) != null ? o : e == null ? void 0 : e.find(bd),
    n = (s = e == null ? void 0 : e.find(Md)) != null ? s : e == null ? void 0 : e.find(Ud);
  if (t) return t;
  throw n ? Sa : ya;
}
const Nd = e => e.startsWith(String(window.location.origin + window.location.pathname)),
  bd = e => e.includes(String(window.location.hostname)),
  Ud = e => e.startsWith("http://"),
  Md = e => e.startsWith("https://"),
  Zt = e => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee104() {
    return _regeneratorRuntime().wrap(function _callee104$(_context104) {
      while (1) switch (_context104.prev = _context104.next) {
        case 0:
          us();
          _context104.next = 3;
          return $.clearOAuthInflightData();
        case 3:
          ie.dispatch("auth", {
            event: "signInWithRedirect_failure",
            data: {
              error: e
            }
          }, "Auth", se);
        case 4:
        case "end":
          return _context104.stop();
      }
    }, _callee104);
  })),
  Dd = e => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee105() {
    var t, n, o, _n$oauth, s, i, r, d;
    return _regeneratorRuntime().wrap(function _callee105$(_context105) {
      while (1) switch (_context105.prev = _context105.next) {
        case 0:
          _context105.prev = 0;
          I(e), at(e), $.setAuthConfig(e);
          _context105.next = 7;
          break;
        case 4:
          _context105.prev = 4;
          _context105.t0 = _context105["catch"](0);
          return _context105.abrupt("return");
        case 7:
          _context105.next = 9;
          return $.loadOAuthInFlight();
        case 9:
          if (!_context105.sent) {
            _context105.next = 20;
            break;
          }
          _context105.prev = 10;
          t = window.location.href, n = e.loginWith, o = e.userPoolClientId, _n$oauth = n.oauth, s = _n$oauth.domain, i = _n$oauth.redirectSignIn, r = _n$oauth.responseType, d = Qt(i);
          _context105.next = 14;
          return vs({
            currentUrl: t,
            clientId: o,
            domain: s,
            redirectUri: d,
            responseType: r,
            userAgentValue: v(T.SignInWithRedirect)
          });
        case 14:
          _context105.next = 20;
          break;
        case 16:
          _context105.prev = 16;
          _context105.t1 = _context105["catch"](10);
          _context105.next = 20;
          return Zt(_context105.t1);
        case 20:
        case "end":
          return _context105.stop();
      }
    }, _callee105, null, [[0, 4], [10, 16]]);
  }));
Kt() && C[Po](Dd);
const Fd = {
    Google: "Google",
    Facebook: "Facebook",
    Amazon: "LoginWithAmazon",
    Apple: "SignInWithApple"
  },
  Ps = e => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee106() {
    return _regeneratorRuntime().wrap(function _callee106$(_context106) {
      while (1) switch (_context106.prev = _context106.next) {
        case 0:
          window != null && window.location && (window.location.href = e.replace("http://", "https://"));
        case 1:
        case "end":
          return _context106.stop();
      }
    }, _callee106);
  })),
  So = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
  Od = e => {
    const t = new Uint8Array(e);
    To().getRandomValues(t);
    let n = "",
      o;
    for (const s of t) n += So.charAt(s % So.length);
    return {
      value: n,
      method: "S256",
      toCodeChallenge() {
        return o || (o = kd(n), o);
      }
    };
  };
function kd(e) {
  const t = new Oe();
  return t.update(e), Ld(Le.convert(t.digestSync(), {
    urlSafe: !0
  }));
}
function Ld(e) {
  return e.replace(/=/g, "");
}
const Kd = () => Or(32),
  Bd = e => {
    function t(n) {
      return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee107() {
        var s;
        return _regeneratorRuntime().wrap(function _callee107$(_context107) {
          while (1) switch (_context107.prev = _context107.next) {
            case 0:
              _context107.t0 = n.persisted;
              if (!_context107.t0) {
                _context107.next = 5;
                break;
              }
              _context107.next = 4;
              return e.loadOAuthInFlight();
            case 4:
              _context107.t0 = _context107.sent;
            case 5:
              if (!_context107.t0) {
                _context107.next = 9;
                break;
              }
              s = we("User cancelled OAuth flow.");
              _context107.next = 9;
              return Zt(s);
            case 9:
              window.removeEventListener("pageshow", t);
            case 10:
            case "end":
              return _context107.stop();
          }
        }, _callee107);
      }));
    }
    window.addEventListener("pageshow", t);
  };
function _s(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee108() {
    var o, s, i, t, n;
    return _regeneratorRuntime().wrap(function _callee108$(_context108) {
      while (1) switch (_context108.prev = _context108.next) {
        case 0:
          t = (o = C.getConfig().Auth) == null ? void 0 : o.Cognito;
          I(t);
          at(t);
          $.setAuthConfig(t);
          _context108.next = 6;
          return rs();
        case 6:
          n = "COGNITO";
          return _context108.abrupt("return", (typeof (e == null ? void 0 : e.provider) == "string" ? n = Fd[e.provider] : (s = e == null ? void 0 : e.provider) != null && s.custom && (n = e.provider.custom), Vd({
            oauthConfig: t.loginWith.oauth,
            clientId: t.userPoolClientId,
            provider: n,
            customState: e == null ? void 0 : e.customState,
            preferPrivateSession: (i = e == null ? void 0 : e.options) == null ? void 0 : i.preferPrivateSession
          })));
        case 8:
        case "end":
          return _context108.stop();
      }
    }, _callee108);
  }));
}
const Vd = i => l(void 0, [i], function (_ref58) {
    let e = _ref58.oauthConfig,
      t = _ref58.provider,
      n = _ref58.clientId,
      o = _ref58.customState,
      s = _ref58.preferPrivateSession;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee109() {
      var Z, r, d, a, c, u, f, _Od, h, g, E, p, A, P, _ref61, F, j, le;
      return _regeneratorRuntime().wrap(function _callee109$(_context109) {
        while (1) switch (_context109.prev = _context109.next) {
          case 0:
            r = e.domain, d = e.redirectSignIn, a = e.responseType, c = e.scopes, u = Kd(), f = o ? `${u}-${Lr(o)}` : u, _Od = Od(128), h = _Od.value, g = _Od.method, E = _Od.toCodeChallenge, p = Qt(e.redirectSignIn);
            Kt() && $.storeOAuthInFlight(!0), $.storeOAuthState(f), $.storePKCE(h);
            A = Object.entries(y({
              redirect_uri: p,
              response_type: a,
              client_id: n,
              identity_provider: t,
              scope: c.join(" "),
              state: f
            }, a === "code" && {
              code_challenge: E(),
              code_challenge_method: g
            })).map(_ref59 => {
              let _ref60 = _slicedToArray(_ref59, 2),
                ee = _ref60[0],
                ae = _ref60[1];
              return `${encodeURIComponent(ee)}=${encodeURIComponent(ae)}`;
            }).join("&"), P = `https://${r}/oauth2/authorize?${A}`;
            Bd($);
            _context109.next = 6;
            return Ps(P);
          case 6:
            _context109.t0 = Z = _context109.sent;
            if (!(_context109.t0 != null)) {
              _context109.next = 11;
              break;
            }
            _context109.t1 = Z;
            _context109.next = 12;
            break;
          case 11:
            _context109.t1 = {};
          case 12:
            _ref61 = _context109.t1;
            F = _ref61.type;
            j = _ref61.error;
            le = _ref61.url;
            _context109.prev = 16;
            if (!(F === "error")) {
              _context109.next = 19;
              break;
            }
            throw we(String(j));
          case 19:
            _context109.t2 = F === "success" && le;
            if (!_context109.t2) {
              _context109.next = 23;
              break;
            }
            _context109.next = 23;
            return vs({
              currentUrl: le,
              clientId: n,
              domain: r,
              redirectUri: p,
              responseType: a,
              userAgentValue: v(T.SignInWithRedirect),
              preferPrivateSession: s
            });
          case 23:
            _context109.next = 30;
            break;
          case 25:
            _context109.prev = 25;
            _context109.t3 = _context109["catch"](16);
            _context109.next = 29;
            return Zt(_context109.t3);
          case 29:
            throw _context109.t3;
          case 30:
          case "end":
            return _context109.stop();
        }
      }, _callee109, null, [[16, 25]]);
    })();
  }),
  Wd = e => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee110() {
    var s, t, _yield$Bt, n, _yield$Yo2, o;
    return _regeneratorRuntime().wrap(function _callee110$(_context110) {
      while (1) switch (_context110.prev = _context110.next) {
        case 0:
          t = (s = e.getConfig().Auth) == null ? void 0 : s.Cognito;
          I(t);
          _context110.next = 4;
          return Bt(e, {
            forceRefresh: !1
          });
        case 4:
          _yield$Bt = _context110.sent;
          n = _yield$Bt.tokens;
          q(n);
          _context110.next = 9;
          return Yo({
            region: x(t.userPoolId),
            userAgentValue: v(T.FetchUserAttributes)
          }, {
            AccessToken: n.accessToken.toString()
          });
        case 9:
          _yield$Yo2 = _context110.sent;
          o = _yield$Yo2.UserAttributes;
          return _context110.abrupt("return", fa(o));
        case 12:
        case "end":
          return _context110.stop();
      }
    }, _callee110);
  })),
  qd = () => Wd(C),
  Hd = e => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee111() {
    return _regeneratorRuntime().wrap(function _callee111$(_context111) {
      while (1) switch (_context111.prev = _context111.next) {
        case 0:
          _context111.next = 2;
          return e.clearOAuthData();
        case 2:
          B.clearTokens();
          _context111.next = 5;
          return Mo();
        case 5:
          ie.dispatch("auth", {
            event: "signedOut"
          }, "Auth", se);
        case 6:
        case "end":
          return _context111.stop();
      }
    }, _callee111);
  })),
  $d = function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    return l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee112() {
      var n, o, _n$oauth2, s, i, r, d;
      return _regeneratorRuntime().wrap(function _callee112$(_context112) {
        while (1) switch (_context112.prev = _context112.next) {
          case 0:
            at(e);
            n = e.loginWith, o = e.userPoolClientId, _n$oauth2 = n.oauth, s = _n$oauth2.domain, i = _n$oauth2.redirectSignOut, r = Qt(i), d = `https://${s}/logout?${Object.entries({
              client_id: o,
              logout_uri: encodeURIComponent(r)
            }).map(_ref62 => {
              let _ref63 = _slicedToArray(_ref62, 2),
                a = _ref63[0],
                c = _ref63[1];
              return `${a}=${c}`;
            }).join("&")}`;
            return _context112.abrupt("return", Ps(d));
          case 3:
          case "end":
            return _context112.stop();
        }
      }, _callee112);
    }));
  },
  jd = (e, t) => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee113() {
    var _yield$t$loadOAuthSig, n;
    return _regeneratorRuntime().wrap(function _callee113$(_context113) {
      while (1) switch (_context113.prev = _context113.next) {
        case 0:
          _context113.next = 2;
          return t.loadOAuthSignIn();
        case 2:
          _yield$t$loadOAuthSig = _context113.sent;
          n = _yield$t$loadOAuthSig.isOAuthSignIn;
          _context113.next = 6;
          return Hd(t);
        case 6:
          if (!n) {
            _context113.next = 8;
            break;
          }
          return _context113.abrupt("return", $d(e));
        case 8:
        case "end":
          return _context113.stop();
      }
    }, _callee113);
  })),
  Ns = new Y("Auth");
function St(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee114() {
    var o, s, t, n, i, _ref64, r;
    return _regeneratorRuntime().wrap(function _callee114$(_context114) {
      while (1) switch (_context114.prev = _context114.next) {
        case 0:
          t = (o = C.getConfig().Auth) == null ? void 0 : o.Cognito;
          I(t);
          if (!(e != null && e.global)) {
            _context114.next = 7;
            break;
          }
          _context114.next = 5;
          return Gd(t);
        case 5:
          _context114.next = 9;
          break;
        case 7:
          _context114.next = 9;
          return zd(t);
        case 9:
          try {
            at(t), n = !0;
          } catch (i) {
            n = !1;
          }
          if (!n) {
            _context114.next = 27;
            break;
          }
          i = new ds(ve);
          i.setAuthConfig(t);
          _context114.next = 15;
          return jd(t, i);
        case 15:
          _context114.t0 = s = _context114.sent;
          if (!(_context114.t0 != null)) {
            _context114.next = 20;
            break;
          }
          _context114.t1 = s;
          _context114.next = 21;
          break;
        case 20:
          _context114.t1 = {};
        case 21:
          _ref64 = _context114.t1;
          r = _ref64.type;
          if (!(r === "error")) {
            _context114.next = 25;
            break;
          }
          throw new S({
            name: wa,
            message: "An error occurred when attempting to log out from OAuth provider."
          });
        case 25:
          _context114.next = 31;
          break;
        case 27:
          B.clearTokens();
          _context114.next = 30;
          return Mo();
        case 30:
          ie.dispatch("auth", {
            event: "signedOut"
          }, "Auth", se);
        case 31:
        case "end":
          return _context114.stop();
      }
    }, _callee114);
  }));
}
function zd(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee115() {
    var t;
    return _regeneratorRuntime().wrap(function _callee115$(_context115) {
      while (1) switch (_context115.prev = _context115.next) {
        case 0:
          _context115.prev = 0;
          _context115.next = 3;
          return B.getTokenStore().loadTokens();
        case 3:
          t = _context115.sent;
          Xo(t);
          _context115.t0 = Yd(t.accessToken);
          if (!_context115.t0) {
            _context115.next = 9;
            break;
          }
          _context115.next = 9;
          return Gr({
            region: x(e.userPoolId),
            userAgentValue: v(T.SignOut)
          }, {
            ClientId: e.userPoolClientId,
            Token: t.refreshToken
          });
        case 9:
          _context115.next = 14;
          break;
        case 11:
          _context115.prev = 11;
          _context115.t1 = _context115["catch"](0);
          Ns.debug("Client signOut error caught but will proceed with token removal");
        case 14:
        case "end":
          return _context115.stop();
      }
    }, _callee115, null, [[0, 11]]);
  }));
}
function Gd(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee116() {
    var t;
    return _regeneratorRuntime().wrap(function _callee116$(_context116) {
      while (1) switch (_context116.prev = _context116.next) {
        case 0:
          _context116.prev = 0;
          _context116.next = 3;
          return B.getTokenStore().loadTokens();
        case 3:
          t = _context116.sent;
          q(t);
          _context116.next = 7;
          return ra({
            region: x(e.userPoolId),
            userAgentValue: v(T.SignOut)
          }, {
            AccessToken: t.accessToken.toString()
          });
        case 7:
          _context116.next = 12;
          break;
        case 9:
          _context116.prev = 9;
          _context116.t0 = _context116["catch"](0);
          Ns.debug("Global signOut error caught but will proceed with token removal");
        case 12:
        case "end":
          return _context116.stop();
      }
    }, _callee116, null, [[0, 9]]);
  }));
}
const Yd = e => {
    var t;
    return !!((t = e == null ? void 0 : e.payload) != null && t.origin_jti);
  },
  Jd = e => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee117() {
    var u, t, n, o, s, _yield$L8, i, _yield$ia, r, _y2, d, a, c;
    return _regeneratorRuntime().wrap(function _callee117$(_context117) {
      while (1) switch (_context117.prev = _context117.next) {
        case 0:
          t = e.userAttributeKey, n = e.options, o = (u = C.getConfig().Auth) == null ? void 0 : u.Cognito, s = n == null ? void 0 : n.clientMetadata;
          I(o);
          _context117.next = 4;
          return L({
            forceRefresh: !1
          });
        case 4:
          _yield$L8 = _context117.sent;
          i = _yield$L8.tokens;
          q(i);
          _context117.next = 9;
          return ia({
            region: x(o.userPoolId),
            userAgentValue: v(T.SendUserAttributeVerificationCode)
          }, {
            AccessToken: i.accessToken.toString(),
            ClientMetadata: s,
            AttributeName: t
          });
        case 9:
          _yield$ia = _context117.sent;
          r = _yield$ia.CodeDeliveryDetails;
          _y2 = y({}, r);
          d = _y2.DeliveryMedium;
          a = _y2.AttributeName;
          c = _y2.Destination;
          return _context117.abrupt("return", {
            destination: c,
            deliveryMedium: d,
            attributeName: a
          });
        case 16:
        case "end":
          return _context117.stop();
      }
    }, _callee117);
  }));
function Xd(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee118() {
    var s, t, n, _yield$L9, o;
    return _regeneratorRuntime().wrap(function _callee118$(_context118) {
      while (1) switch (_context118.prev = _context118.next) {
        case 0:
          t = (s = C.getConfig().Auth) == null ? void 0 : s.Cognito;
          I(t);
          n = e.userAttributeKeys;
          _context118.next = 5;
          return L({
            forceRefresh: !1
          });
        case 5:
          _yield$L9 = _context118.sent;
          o = _yield$L9.tokens;
          q(o);
          _context118.next = 10;
          return la({
            region: x(t.userPoolId),
            userAgentValue: v(T.DeleteUserAttributes)
          }, {
            AccessToken: o.accessToken.toString(),
            UserAttributeNames: n
          });
        case 10:
        case "end":
          return _context118.stop();
      }
    }, _callee118);
  }));
}
function Qd() {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee119() {
    var n, e, _yield$L10, t;
    return _regeneratorRuntime().wrap(function _callee119$(_context119) {
      while (1) switch (_context119.prev = _context119.next) {
        case 0:
          e = (n = C.getConfig().Auth) == null ? void 0 : n.Cognito;
          I(e);
          _context119.next = 4;
          return L();
        case 4:
          _yield$L10 = _context119.sent;
          t = _yield$L10.tokens;
          q(t);
          _context119.next = 9;
          return sa({
            region: x(e.userPoolId),
            userAgentValue: v(T.DeleteUser)
          }, {
            AccessToken: t.accessToken.toString()
          });
        case 9:
          _context119.next = 11;
          return B.clearDeviceMetadata();
        case 11:
          _context119.next = 13;
          return St();
        case 13:
        case "end":
          return _context119.stop();
      }
    }, _callee119);
  }));
}
function Zd() {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee120() {
    var o, e, _yield$L11, t, n;
    return _regeneratorRuntime().wrap(function _callee120$(_context120) {
      while (1) switch (_context120.prev = _context120.next) {
        case 0:
          e = (o = C.getConfig().Auth) == null ? void 0 : o.Cognito;
          I(e);
          _context120.next = 4;
          return L();
        case 4:
          _yield$L11 = _context120.sent;
          t = _yield$L11.tokens;
          q(t);
          _context120.next = 9;
          return B == null ? void 0 : B.getDeviceMetadata();
        case 9:
          n = _context120.sent;
          ft(n);
          _context120.next = 13;
          return da({
            region: x(e.userPoolId),
            userAgentValue: v(T.RememberDevice)
          }, {
            AccessToken: t.accessToken.toString(),
            DeviceKey: n.deviceKey,
            DeviceRememberedStatus: "remembered"
          });
        case 13:
        case "end":
          return _context120.stop();
      }
    }, _callee120);
  }));
}
function eu(e) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee121() {
    var r, _ref65, _ref65$device, _ref65$device2, t, n, _yield$L12, o, s, i;
    return _regeneratorRuntime().wrap(function _callee121$(_context121) {
      while (1) switch (_context121.prev = _context121.next) {
        case 0:
          _ref65 = e != null ? e : {}, _ref65$device = _ref65.device, _ref65$device2 = _ref65$device === void 0 ? {
            id: void 0
          } : _ref65$device, t = _ref65$device2.id, n = (r = C.getConfig().Auth) == null ? void 0 : r.Cognito;
          I(n);
          _context121.next = 4;
          return L();
        case 4:
          _yield$L12 = _context121.sent;
          o = _yield$L12.tokens;
          q(o);
          _context121.next = 9;
          return B.getDeviceMetadata();
        case 9:
          s = _context121.sent;
          i = s == null ? void 0 : s.deviceKey;
          t || ft(s);
          _context121.next = 14;
          return oa({
            region: x(n.userPoolId),
            userAgentValue: v(T.ForgetDevice)
          }, {
            AccessToken: o.accessToken.toString(),
            DeviceKey: t != null ? t : i
          });
        case 14:
          _context121.t0 = !t || t === i;
          if (!_context121.t0) {
            _context121.next = 18;
            break;
          }
          _context121.next = 18;
          return B.clearDeviceMetadata();
        case 18:
        case "end":
          return _context121.stop();
      }
    }, _callee121);
  }));
}
const tu = 60;
function nu() {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee122() {
    var o, s, e, _yield$L13, t, n;
    return _regeneratorRuntime().wrap(function _callee122$(_context122) {
      while (1) switch (_context122.prev = _context122.next) {
        case 0:
          e = (o = C.getConfig().Auth) == null ? void 0 : o.Cognito;
          I(e);
          _context122.next = 4;
          return L();
        case 4:
          _yield$L13 = _context122.sent;
          t = _yield$L13.tokens;
          q(t);
          _context122.next = 9;
          return ua({
            region: x(e.userPoolId),
            userAgentValue: v(T.FetchDevices)
          }, {
            AccessToken: t.accessToken.toString(),
            Limit: tu
          });
        case 9:
          n = _context122.sent;
          return _context122.abrupt("return", ou((s = n.Devices) != null ? s : []));
        case 11:
        case "end":
          return _context122.stop();
      }
    }, _callee122);
  }));
}
const ou = e => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee123() {
    return _regeneratorRuntime().wrap(function _callee123$(_context123) {
      while (1) switch (_context123.prev = _context123.next) {
        case 0:
          return _context123.abrupt("return", e.map(_ref66 => {
            let _ref66$DeviceKey = _ref66.DeviceKey,
              t = _ref66$DeviceKey === void 0 ? "" : _ref66$DeviceKey,
              _ref66$DeviceAttribut = _ref66.DeviceAttributes,
              n = _ref66$DeviceAttribut === void 0 ? [] : _ref66$DeviceAttribut,
              o = _ref66.DeviceCreateDate,
              s = _ref66.DeviceLastModifiedDate,
              i = _ref66.DeviceLastAuthenticatedDate;
            let r;
            const d = n.reduce((a, _ref67) => {
              let c = _ref67.Name,
                u = _ref67.Value;
              return c && u && (c === "device_name" && (r = u), a[c] = u), a;
            }, {});
            return {
              id: t,
              name: r,
              attributes: d,
              createDate: o ? new Date(o * 1e3) : void 0,
              lastModifiedDate: s ? new Date(s * 1e3) : void 0,
              lastAuthenticatedDate: i ? new Date(i * 1e3) : void 0
            };
          }));
        case 1:
        case "end":
          return _context123.stop();
      }
    }, _callee123);
  })),
  su = {
    identityId: "identityId"
  },
  iu = new Y("DefaultIdentityIdStore");
class bs {
  setAuthConfig(t) {
    Je(t.Cognito), this.authConfig = t, this._authKeys = ru("Cognito", t.Cognito.identityPoolId);
  }
  constructor(t) {
    this._authKeys = {}, this.keyValueStorage = t;
  }
  loadIdentityId() {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee124() {
      var t, n;
      return _regeneratorRuntime().wrap(function _callee124$(_context124) {
        while (1) switch (_context124.prev = _context124.next) {
          case 0:
            Je((t = this.authConfig) == null ? void 0 : t.Cognito);
            _context124.prev = 1;
            if (!this._primaryIdentityId) {
              _context124.next = 4;
              break;
            }
            return _context124.abrupt("return", {
              id: this._primaryIdentityId,
              type: "primary"
            });
          case 4:
            _context124.next = 6;
            return this.keyValueStorage.getItem(this._authKeys.identityId);
          case 6:
            n = _context124.sent;
            return _context124.abrupt("return", n ? {
              id: n,
              type: "guest"
            } : null);
          case 10:
            _context124.prev = 10;
            _context124.t0 = _context124["catch"](1);
            return _context124.abrupt("return", (iu.log("Error getting stored IdentityId.", _context124.t0), null));
          case 13:
          case "end":
            return _context124.stop();
        }
      }, _callee124, this, [[1, 10]]);
    }));
  }
  storeIdentityId(t) {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee125() {
      var n;
      return _regeneratorRuntime().wrap(function _callee125$(_context125) {
        while (1) switch (_context125.prev = _context125.next) {
          case 0:
            Je((n = this.authConfig) == null ? void 0 : n.Cognito), t.type === "guest" ? (this.keyValueStorage.setItem(this._authKeys.identityId, t.id), this._primaryIdentityId = void 0) : (this._primaryIdentityId = t.id, this.keyValueStorage.removeItem(this._authKeys.identityId));
          case 1:
          case "end":
            return _context125.stop();
        }
      }, _callee125, this);
    }));
  }
  clearIdentityId() {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee126() {
      return _regeneratorRuntime().wrap(function _callee126$(_context126) {
        while (1) switch (_context126.prev = _context126.next) {
          case 0:
            this._primaryIdentityId = void 0;
            _context126.next = 3;
            return this.keyValueStorage.removeItem(this._authKeys.identityId);
          case 3:
          case "end":
            return _context126.stop();
        }
      }, _callee126, this);
    }));
  }
}
const ru = (e, t) => Jt(su)(`com.amplify.${e}`, t);
function Us(e) {
  const t = re(e).payload.iss,
    n = {};
  if (!t) throw new S({
    name: "InvalidIdTokenException",
    message: "Invalid Idtoken."
  });
  const o = t.replace(/(^\w+:|^)\/\//, "");
  return n[o] = e, n;
}
const au = new Y("CognitoIdentityIdProvider");
function cu(o) {
  return l(this, arguments, function (_ref68) {
    let e = _ref68.tokens,
      t = _ref68.authConfig,
      n = _ref68.identityIdStore;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee127() {
      var s, i, r;
      return _regeneratorRuntime().wrap(function _callee127$(_context127) {
        while (1) switch (_context127.prev = _context127.next) {
          case 0:
            n.setAuthConfig({
              Cognito: t
            });
            _context127.next = 3;
            return n.loadIdentityId();
          case 3:
            s = _context127.sent;
            if (!e) {
              _context127.next = 14;
              break;
            }
            if (!(s && s.type === "primary")) {
              _context127.next = 7;
              break;
            }
            return _context127.abrupt("return", s.id);
          case 7:
            i = e.idToken ? Us(e.idToken.toString()) : {};
            _context127.next = 10;
            return wo(i, t);
          case 10:
            r = _context127.sent;
            s && s.id === r && au.debug(`The guest identity ${s.id} has become the primary identity.`), s = {
              id: r,
              type: "primary"
            };
            _context127.next = 20;
            break;
          case 14:
            if (!(s && s.type === "guest")) {
              _context127.next = 16;
              break;
            }
            return _context127.abrupt("return", s.id);
          case 16:
            _context127.next = 18;
            return wo({}, t);
          case 18:
            _context127.t0 = _context127.sent;
            s = {
              id: _context127.t0,
              type: "guest"
            };
          case 20:
            return _context127.abrupt("return", (n.storeIdentityId(s), s.id));
          case 21:
          case "end":
            return _context127.stop();
        }
      }, _callee127);
    })();
  });
}
function wo(e, t) {
  return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee128() {
    var n, o, s;
    return _regeneratorRuntime().wrap(function _callee128$(_context128) {
      while (1) switch (_context128.prev = _context128.next) {
        case 0:
          n = t == null ? void 0 : t.identityPoolId;
          o = Pt(n);
          _context128.next = 4;
          return Rr({
            region: o
          }, {
            IdentityPoolId: n,
            Logins: e
          });
        case 4:
          s = _context128.sent.IdentityId;
          if (s) {
            _context128.next = 7;
            break;
          }
          throw new S({
            name: "GetIdResponseException",
            message: "Received undefined response from getId operation",
            recoverySuggestion: "Make sure to pass a valid identityPoolId in the configuration."
          });
        case 7:
          return _context128.abrupt("return", s);
        case 8:
        case "end":
          return _context128.stop();
      }
    }, _callee128);
  }));
}
const Ye = new Y("CognitoCredentialsProvider"),
  Co = 50 * 60 * 1e3;
class Ms {
  constructor(t) {
    this._nextCredentialsRefresh = 0, this._identityIdStore = t;
  }
  clearCredentialsAndIdentityId() {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee129() {
      return _regeneratorRuntime().wrap(function _callee129$(_context129) {
        while (1) switch (_context129.prev = _context129.next) {
          case 0:
            Ye.debug("Clearing out credentials and identityId");
            this._credentialsAndIdentityId = void 0;
            _context129.next = 4;
            return this._identityIdStore.clearIdentityId();
          case 4:
          case "end":
            return _context129.stop();
        }
      }, _callee129, this);
    }));
  }
  clearCredentials() {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee130() {
      return _regeneratorRuntime().wrap(function _callee130$(_context130) {
        while (1) switch (_context130.prev = _context130.next) {
          case 0:
            Ye.debug("Clearing out in-memory credentials"), this._credentialsAndIdentityId = void 0;
          case 1:
          case "end":
            return _context130.stop();
        }
      }, _callee130, this);
    }));
  }
  getCredentialsAndIdentityId(t) {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee131() {
      var n, o, s, i, r, d;
      return _regeneratorRuntime().wrap(function _callee131$(_context131) {
        while (1) switch (_context131.prev = _context131.next) {
          case 0:
            n = t.authenticated, o = t.tokens, s = t.authConfig;
            _context131.prev = 1;
            Je(s == null ? void 0 : s.Cognito);
            _context131.next = 8;
            break;
          case 5:
            _context131.prev = 5;
            _context131.t0 = _context131["catch"](1);
            return _context131.abrupt("return");
          case 8:
            if (!(!n && !s.Cognito.allowGuestAccess)) {
              _context131.next = 10;
              break;
            }
            return _context131.abrupt("return");
          case 10:
            i = t.forceRefresh;
            r = this.hasTokenChanged(o);
            _context131.next = 14;
            return cu({
              tokens: o,
              authConfig: s.Cognito,
              identityIdStore: this._identityIdStore
            });
          case 14:
            d = _context131.sent;
            return _context131.abrupt("return", ((i || r) && this.clearCredentials(), n ? (xa(o), this.credsForOIDCTokens(s.Cognito, o, d)) : this.getGuestCredentials(d, s.Cognito)));
          case 16:
          case "end":
            return _context131.stop();
        }
      }, _callee131, this, [[1, 5]]);
    }));
  }
  getGuestCredentials(t, n) {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee132() {
      var o, s, i, r;
      return _regeneratorRuntime().wrap(function _callee132$(_context132) {
        while (1) switch (_context132.prev = _context132.next) {
          case 0:
            if (!(this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === !1)) {
              _context132.next = 2;
              break;
            }
            return _context132.abrupt("return", (Ye.info("returning stored credentials as they neither past TTL nor expired."), this._credentialsAndIdentityId));
          case 2:
            this.clearCredentials();
            o = Pt(n.identityPoolId);
            _context132.next = 6;
            return qn({
              region: o
            }, {
              IdentityId: t
            });
          case 6:
            s = _context132.sent;
            if (!(s.Credentials && s.Credentials.AccessKeyId && s.Credentials.SecretKey)) {
              _context132.next = 13;
              break;
            }
            this._nextCredentialsRefresh = /* @__PURE__ */new Date().getTime() + Co;
            i = {
              credentials: {
                accessKeyId: s.Credentials.AccessKeyId,
                secretAccessKey: s.Credentials.SecretKey,
                sessionToken: s.Credentials.SessionToken,
                expiration: s.Credentials.Expiration
              },
              identityId: t
            }, r = s.IdentityId;
            return _context132.abrupt("return", (r && (i.identityId = r, this._identityIdStore.storeIdentityId({
              id: r,
              type: "guest"
            })), this._credentialsAndIdentityId = R(y({}, i), {
              isAuthenticatedCreds: !1
            }), i));
          case 13:
            throw new S({
              name: "CredentialsNotFoundException",
              message: "Cognito did not respond with either Credentials, AccessKeyId or SecretKey."
            });
          case 14:
          case "end":
            return _context132.stop();
        }
      }, _callee132, this);
    }));
  }
  credsForOIDCTokens(t, n, o) {
    return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee133() {
      var d, s, i, r, a, c;
      return _regeneratorRuntime().wrap(function _callee133$(_context133) {
        while (1) switch (_context133.prev = _context133.next) {
          case 0:
            if (!(this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === !0)) {
              _context133.next = 2;
              break;
            }
            return _context133.abrupt("return", (Ye.debug("returning stored credentials as they neither past TTL nor expired."), this._credentialsAndIdentityId));
          case 2:
            this.clearCredentials();
            s = n.idToken ? Us(n.idToken.toString()) : {};
            i = Pt(t.identityPoolId);
            _context133.next = 7;
            return qn({
              region: i
            }, {
              IdentityId: o,
              Logins: s
            });
          case 7:
            r = _context133.sent;
            if (!(r.Credentials && r.Credentials.AccessKeyId && r.Credentials.SecretKey)) {
              _context133.next = 15;
              break;
            }
            a = {
              credentials: {
                accessKeyId: r.Credentials.AccessKeyId,
                secretAccessKey: r.Credentials.SecretKey,
                sessionToken: r.Credentials.SessionToken,
                expiration: r.Credentials.Expiration
              },
              identityId: o
            };
            this._credentialsAndIdentityId = R(y({}, a), {
              isAuthenticatedCreds: !0,
              associatedIdToken: (d = n.idToken) == null ? void 0 : d.toString()
            }), this._nextCredentialsRefresh = /* @__PURE__ */new Date().getTime() + Co;
            c = r.IdentityId;
            return _context133.abrupt("return", (c && (a.identityId = c, this._identityIdStore.storeIdentityId({
              id: c,
              type: "primary"
            })), a));
          case 15:
            throw new S({
              name: "CredentialsException",
              message: "Cognito did not respond with either Credentials, AccessKeyId or SecretKey."
            });
          case 16:
          case "end":
            return _context133.stop();
        }
      }, _callee133, this);
    }));
  }
  isPastTTL() {
    return this._nextCredentialsRefresh === void 0 ? !0 : this._nextCredentialsRefresh <= Date.now();
  }
  hasTokenChanged(t) {
    var n, o;
    return !!t && !!((n = this._credentialsAndIdentityId) != null && n.associatedIdToken) && ((o = t.idToken) == null ? void 0 : o.toString()) !== this._credentialsAndIdentityId.associatedIdToken;
  }
}
const du = new Ms(new bs(ve)),
  Ds = {
    /**
     * Configures Amplify with the {@link resourceConfig} and {@link libraryOptions}.
     *
     * @param resourceConfig The {@link ResourcesConfig} object that is typically imported from the
     * `amplifyconfiguration.json` file. It can also be an object literal created inline when calling `Amplify.configure`.
     * @param libraryOptions The {@link LibraryOptions} additional options for the library.
     *
     * @example
     * import config from './amplifyconfiguration.json';
     *
     * Amplify.configure(config);
     */
    configure(e, t) {
      const n = _o(e);
      if (!n.Auth) {
        C.configure(n, t);
        return;
      }
      if (t != null && t.Auth) {
        C.configure(n, t);
        return;
      }
      if (!C.libraryOptions.Auth) {
        Ae.setAuthConfig(n.Auth), Ae.setKeyValueStorage(
        // TODO: allow configure with a public interface
        t != null && t.ssr ? new Rt({
          sameSite: "lax"
        }) : ve), C.configure(n, R(y({}, t), {
          Auth: {
            tokenProvider: Ae,
            credentialsProvider: du
          }
        }));
        return;
      }
      if (t) {
        t.ssr !== void 0 && Ae.setKeyValueStorage(
        // TODO: allow configure with a public interface
        t.ssr ? new Rt({
          sameSite: "lax"
        }) : ve), C.configure(n, y({
          Auth: C.libraryOptions.Auth
        }, t));
        return;
      }
      C.configure(n);
    },
    /**
     * Returns the {@link ResourcesConfig} object passed in as the `resourceConfig` parameter when calling
     * `Amplify.configure`.
     *
     * @returns An {@link ResourcesConfig} object.
     */
    getConfig() {
      return C.getConfig();
    }
  },
  wt = _axios.default.create();
class Fs extends J {
  constructor(_ref69) {
    let t = _ref69.message,
      n = _ref69.recoverySuggestion,
      o = _ref69.underlyingError;
    super({
      name: "AmplifyServerContextError",
      message: t,
      recoverySuggestion: n,
      underlyingError: o
    });
  }
}
const xt = /* @__PURE__ */new WeakMap();
function uu() {
  return {
    value: Symbol("AmplifyServerContextToken")
  };
}
const en = {
    register(e) {
      const t = uu();
      return xt.set(t, e), {
        token: t
      };
    },
    deregister(e) {
      return xt.delete(e.token);
    },
    get(e) {
      return xt.get(e.token);
    }
  },
  lu = (e, t) => {
    const n = new Uo();
    return n.configure(e, t), en.register({
      amplify: n
    });
  },
  hu = e => {
    gu(e);
    const t = en.get(e);
    if (t) return t;
    throw new Fs({
      message: "Attempted to get the Amplify Server Context that may have been destroyed.",
      recoverySuggestion: "Ensure always call Amplify APIs within `runWithAmplifyServerContext` function, and do not attempt to reuse `contextSpec` object."
    });
  },
  fu = e => {
    en.deregister(e);
  },
  gu = e => {
    let t = !1;
    if (Object.prototype.hasOwnProperty.call(e, "token") && Object.prototype.hasOwnProperty.call(e.token, "value") ? Object.prototype.toString.call(e.token.value) !== "[object Symbol]" && (t = !0) : t = !0, t) throw new Fs({
      message: "Invalid `contextSpec`.",
      recoverySuggestion: "Ensure to use the `contextSpec` object injected by `runWithAmplifyServerContext` function."
    });
  },
  pu = (e, t, n) => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee134() {
    var o;
    return _regeneratorRuntime().wrap(function _callee134$(_context134) {
      while (1) switch (_context134.prev = _context134.next) {
        case 0:
          o = lu(e, t);
          _context134.prev = 1;
          _context134.next = 4;
          return n(o);
        case 4:
          return _context134.abrupt("return", _context134.sent);
        case 5:
          _context134.prev = 5;
          fu(o);
          return _context134.finish(5);
        case 8:
        case "end":
          return _context134.stop();
      }
    }, _callee134, null, [[1,, 5, 8]]);
  })),
  mu = {
    // TODO: allow configure with a public interface
    sameSite: "lax",
    secure: !0,
    path: "/"
  },
  Eu = 365 * 24 * 60 * 60 * 1e3,
  yu = (e, t) => ({
    setItem(o, s) {
      return e.delete(o), e.set(o, s, R(y({}, mu), {
        expires: new Date(Date.now() + Eu)
      })), Promise.resolve();
    },
    getItem(o) {
      return l(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee135() {
        var r, s, i;
        return _regeneratorRuntime().wrap(function _callee135$(_context135) {
          while (1) switch (_context135.prev = _context135.next) {
            case 0:
              s = e.get(o), i = (r = s == null ? void 0 : s.value) != null ? r : null;
              _context135.t0 = i && t != null && t.getItem;
              if (!_context135.t0) {
                _context135.next = 6;
                break;
              }
              _context135.next = 5;
              return t.getItem(o, i);
            case 5:
              _context135.t0 = !_context135.sent;
            case 6:
              if (!_context135.t0) {
                _context135.next = 10;
                break;
              }
              _context135.t1 = null;
              _context135.next = 11;
              break;
            case 10:
              _context135.t1 = i;
            case 11:
              return _context135.abrupt("return", _context135.t1);
            case 12:
            case "end":
              return _context135.stop();
          }
        }, _callee135);
      }));
    },
    removeItem(o) {
      return e.delete(o), Promise.resolve();
    },
    clear() {
      throw new Error("This method has not implemented.");
    }
  }),
  Iu = (e, t) => {
    const n = new cs();
    n.setAuthConfig(e), n.setKeyValueStorage(t);
    const o = new ls();
    return o.setAuthConfig(e), o.setAuthTokenStore(n), o.setTokenRefresher(jc), {
      getTokens: function () {
        let _ref70 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            forceRefresh: !1
          },
          s = _ref70.forceRefresh;
        return o.getTokens({
          forceRefresh: s
        });
      }
    };
  },
  Su = (e, t) => new Ms(new bs(t)),
  wu = (e, t) => Bt(hu(e).amplify, t),
  Cu = o => l(void 0, [o], function (_ref71) {
    let e = _ref71.req,
      t = _ref71.res,
      n = _ref71.amplifyConfig;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee137() {
      var c, a, s, i, r, d;
      return _regeneratorRuntime().wrap(function _callee137$(_context137) {
        while (1) switch (_context137.prev = _context137.next) {
          case 0:
            s = (0, _cookieUniversal.default)(e, t, !1);
            _context137.t0 = yu;
            _context137.t1 = {
              get(a) {
                c = s.get(a);
                return {
                  name: a,
                  value: c
                };
              },
              getAll() {
                a = s.getAll();
                return Object.keys(a).map(u => ({
                  name: u,
                  value: a[u]
                }));
              },
              set(a, c, u) {
                s.set(a, c, R(y({}, u), {
                  domain: n.Auth.cookieStorageDomain,
                  secure: n.Auth.cookieSecure,
                  maxAge: 86400 * 30
                  // 30 days
                }));
              },

              delete(a) {
                s.remove(a);
              }
            };
            i = (0, _context137.t0)(_context137.t1);
            r = Iu(n.Auth, i);
            d = Su(n.Auth, i);
            _context137.next = 8;
            return pu(n, {
              Auth: {
                tokenProvider: r,
                credentialsProvider: d
              }
            }, a => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee136() {
              return _regeneratorRuntime().wrap(function _callee136$(_context136) {
                while (1) switch (_context136.prev = _context136.next) {
                  case 0:
                    _context136.next = 2;
                    return wu(a);
                  case 2:
                    return _context136.abrupt("return", _context136.sent);
                  case 3:
                  case "end":
                    return _context136.stop();
                }
              }, _callee136);
            })));
          case 8:
            return _context137.abrupt("return", _context137.sent);
          case 9:
          case "end":
            return _context137.stop();
        }
      }, _callee137);
    })();
  }),
  Au = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
    __proto__: null,
    AuthError: S,
    get autoSignIn() {
      return Xt;
    },
    confirmResetPassword: ws,
    confirmSignIn: ld,
    confirmSignUp: As,
    confirmUserAttribute: Sd,
    decodeJWT: re,
    deleteUser: Qd,
    deleteUserAttributes: Xd,
    fetchAuthSession: L,
    fetchDevices: nu,
    fetchMFAPreference: fd,
    fetchUserAttributes: qd,
    forgetDevice: eu,
    getCurrentUser: Ht,
    rememberDevice: Zd,
    resendSignUpCode: Cs,
    resetPassword: Ss,
    sendUserAttributeVerificationCode: Jd,
    setUpTOTP: md,
    signIn: It,
    signInWithRedirect: _s,
    signOut: St,
    signUp: Is,
    updateMFAPreference: hd,
    updatePassword: pd,
    updateUserAttribute: Id,
    updateUserAttributes: xs,
    verifyTOTPSetup: gd
  }, Symbol.toStringTag, {
    value: "Module"
  })),
  xu = (e, t) => It({
    username: e,
    password: t
  }),
  Tu = e => {
    const t = e.username,
      n = e.password,
      o = e.attributes;
    return Is({
      username: t,
      password: n,
      options: {
        userAttributes: o
      }
    });
  },
  vu = (e, t) => As({
    username: e,
    confirmationCode: t
  }).then(() => "SUCCESS"),
  Ru = e => Cs({
    username: e
  }),
  Pu = e => Ss({
    username: e
  }),
  _u = (e, t, n) => ws({
    username: e,
    newPassword: n,
    confirmationCode: t
  }),
  Nu = () => St({
    global: !0
  }),
  bu = _ref72 => {
    let e = _ref72.MSAUTH_ID_TOKEN,
      t = _ref72.MSAUTH_ACCESS_TOKEN;
    return !e || !t ? Promise.reject("No authenticated user") : wt.get("/uds/v2/profile", {
      headers: {
        MSAUTH_ID_TOKEN: e,
        MSAUTH_ACCESS_TOKEN: t
      }
    }).then(n => n.data.data);
  },
  Uu = e => L().then(_ref73 => {
    let t = _ref73.tokens;
    if (!t) return Promise.reject("No authenticated user");
    const _ref74 = t || {},
      n = _ref74.idToken,
      o = _ref74.accessToken;
    return wt.patch("/uds/v2/profile", {
      params: e,
      headers: {
        MSAUTH_ID_TOKEN: n == null ? void 0 : n.toString(),
        MSAUTH_ACCESS_TOKEN: o == null ? void 0 : o.toString()
      }
    }).then(s => s.data.data);
  }),
  Mu = function (_ref75) {
    let e = _ref75.MSAUTH_ID_TOKEN,
      t = _ref75.MSAUTH_ACCESS_TOKEN;
    let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return !e || !t ? Promise.reject("No authenticated user") : wt.get("/uds/v2/consents", {
      params: n,
      headers: {
        MSAUTH_ID_TOKEN: e,
        MSAUTH_ACCESS_TOKEN: t
      }
    }).then(o => o.data.data);
  },
  Os = _ref76 => {
    let e = _ref76.req,
      t = _ref76.res;
    return {
      Auth: {
        currentSession: () => Cu({
          req: e,
          res: t,
          amplifyConfig: Ds.getConfig()
        })
      }
    };
  },
  ks = (e, t) => {
    if (e && t) {
      const _Os = Os({
          req: e,
          res: t
        }),
        n = _Os.Auth;
      return n;
    }
    return {
      currentSession: L
    };
  },
  Du = (e, t) => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee138() {
    var n, _ref77, o, s;
    return _regeneratorRuntime().wrap(function _callee138$(_context138) {
      while (1) switch (_context138.prev = _context138.next) {
        case 0:
          _context138.next = 2;
          return ks(e, t).currentSession();
        case 2:
          n = _context138.sent;
          _ref77 = (n == null ? void 0 : n.tokens) || {};
          o = _ref77.idToken;
          s = _ref77.accessToken;
          return _context138.abrupt("return", {
            MSAUTH_ID_TOKEN: o == null ? void 0 : o.toString(),
            MSAUTH_ACCESS_TOKEN: s == null ? void 0 : s.toString()
          });
        case 7:
        case "end":
          return _context138.stop();
      }
    }, _callee138);
  })),
  Fu = e => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee139() {
    var r, _yield$L14, t, _ref78, n, o;
    return _regeneratorRuntime().wrap(function _callee139$(_context139) {
      while (1) switch (_context139.prev = _context139.next) {
        case 0:
          _context139.next = 2;
          return L();
        case 2:
          _yield$L14 = _context139.sent;
          t = _yield$L14.tokens;
          _ref78 = t || {};
          n = _ref78.idToken;
          o = /* @__PURE__ */new Date();
          if (!(new Date(((r = n == null ? void 0 : n.payload) == null ? void 0 : r.exp) * 1e3) - o < e * 1e3)) {
            _context139.next = 13;
            break;
          }
          _context139.next = 10;
          return L({
            forceRefresh: !0
          });
        case 10:
          _context139.t0 = "Session refreshed";
          _context139.next = 14;
          break;
        case 13:
          _context139.t0 = "Session not refreshed";
        case 14:
          return _context139.abrupt("return", _context139.t0);
        case 15:
        case "end":
          return _context139.stop();
      }
    }, _callee139);
  })),
  Ou = _ref79 => {
    let e = _ref79.region,
      t = _ref79.userPoolId,
      n = _ref79.userPoolWebClientId,
      o = _ref79.cookieStorageDomain,
      s = _ref79.oauthDomain,
      i = _ref79.oauthRedirectSignIn,
      r = _ref79.oauthRedirectSignOut,
      d = _ref79.cookieSecure,
      a = _ref79.msApiEndpoint,
      _ref79$ssr = _ref79.ssr,
      c = _ref79$ssr === void 0 ? !0 : _ref79$ssr;
    a && wt.interceptors.request.use(u => l(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee140() {
      return _regeneratorRuntime().wrap(function _callee140$(_context140) {
        while (1) switch (_context140.prev = _context140.next) {
          case 0:
            return _context140.abrupt("return", (u.baseURL = a, u));
          case 1:
          case "end":
            return _context140.stop();
        }
      }, _callee140);
    })), u => Promise.reject(u)), Ds.configure({
      Auth: {
        Cognito: {
          userPoolId: t,
          userPoolClientId: n,
          region: e,
          mandatorySignIn: !1,
          loginWith: {
            oauth: {
              domain: s,
              scopes: ["profile", "email", "openid", "aws.cognito.signin.user.admin"],
              redirectSignIn: [i],
              redirectSignOut: [r],
              responseType: "code"
            }
          }
        },
        cookieStorageDomain: o,
        cookieSecure: d
      }
    }, {
      ssr: c
    }), Ae.setKeyValueStorage(new Rt({
      domain: o,
      path: "/",
      expires: 30,
      secure: d
    }));
  },
  Wu = {
    cognitoAuth: Au,
    cognitoHub: ie,
    init: Ou,
    signIn: xu,
    signOut: () => St(),
    signUp: Tu,
    federatedSignIn: e => _s(e),
    confirmSignUp: vu,
    resendSignUp: Ru,
    forgotPassword: Pu,
    forgotPasswordSubmit: _u,
    currentUser: bu,
    currentSession: () => L(),
    currentUserConsents: Mu,
    userPoolSignout: Nu,
    updateCurrentUser: Uu,
    getAuthenticationHeaders: Du,
    withSSRContext: Os,
    authSSR: ks,
    refreshSessionIfExpiringBefore: Fu
  };
exports.default = Wu;